
import _, { merge } from "lodash";
import { monkey } from "baobab";
import AWS from "aws-sdk";
import request from "superagent";
import FileSaver from "file-saver";
import ls from "local-storage";

import * as utils from "../utils/utils.js";
import { transformFromChecklistEntities, transformToChecklistEntities } from "../utils/transformUtils.js";
import { applyStructurePatchV1, coerceContentPlanV1, coerceStructurePatchV1, contentPlanToStructurePatchV1, inferStructureStudioIntent, projectChecklistToStructureV1 } from "../utils/structureStudioUtils.js";
import * as entityUtils from "../utils/entityUtils.js";
import env from "../constants/env";
import * as awsS3 from "../persistence/s3";
import { resolveCurrentJobHit } from "../search/algolia";
import * as dynamoDb from "../persistence/dynamoDb";
import state, {
	clearPendingPreviewStateUpdates,
	flushPendingPreviewStateUpdates,
	PREVIEW_UPDATE_MODE_LIVE,
	PREVIEW_UPDATE_MODE_MANUAL,
	PREVIEW_UPDATE_MODE_ON_REFRESH
} from "../state/state";
import browserHistory from "../history";
import { showError, showInfo, showConfirm, showError2, showWarningToast } from "./alertActions";
import { replaceActivity, updateActivity, getActivityById } from "./inventoryActions";
import { generateUUID } from "../utils/utils";
import { fixIftttStructureIds, getBlankArithemticOperator, /*getBlankComparisonOperator,*/ getBlankVisibleIf } from "./logicEditorActions";
import PlayerPaths from "../constants/paths/playerPaths";
import { cleanUpExternalResources, addExternalResource, getActivityContentForAuthoring, getDriveObjectForReference, cleanUpRelatedItemReferences, hasLock, breakLock } from "./activityActions";
import { refreshCredentials } from "../utils/securityUtil.js";
import { normalizeActivity, validateExternalDependencies } from "../utils/activity";
import { getOrgId } from "./orgsActions";
import { getJwtToken, getIdentityId, isOrganizationAdministrator, isOrganizationAuthor, isOrganizationUser, isOrganizationEmployeeInternal, preserveLastActivityForRecovery, setLastActivityRecoveryPending, clearLastActivityRecovery, removeArchivedActivityRecovery } from "./user";
import { listDrive, getResourceReference, getDriveObjectByPath, getUrlForValue, isDriveReference, listDriveMap, getDriveObject, getDriveForActivity } from "./drive.js";
import { fixUtterance, replaceTtsPhonetics } from "../utils/ttsUtils";
import AppConstants from "../constants/appConstants";
import * as editorActions from "./editorActions";
import { getExternalResources, getRelatedItems } from "./activityActions";
import { readClipboardText } from "../utils/clipboard";
import { getChatCompletions, getChatCompletionsLambda } from "../ai/aiAssistant";
import { resolveBankRefContent } from "../utils/bankRefResolver";
import { stripAmbifiMarkdownColorSyntax } from "../utils/ambifiMarkdownColorUtils";
import { buildPreviewDrivePayloadForChecklist } from "../utils/previewDriveUtils";
import removeMarkdown from "remove-markdown";
import { logWebLoginSequence } from "../utils/webLoginSequenceLogger";
import { getProjectOpsContributionPricingSummary } from "../utils/pricingUtils";
import {
	ASSET_FOLDER_STRUCTURE_ITEMS,
	ASSET_FOLDER_STRUCTURE_SECTIONS,
	buildAssetFolderNodes,
	createAssetFolderResourceMetadata,
	getEffectiveAssetFolderStructurePreset
} from "../utils/assetFolderImportUtils";
import { buildPowerPointImportNodes } from "../utils/powerPointImportUtils";
import { normalizePanelKey } from "../utils/propertyPanelUtils";
import { getStreamRetryDelayMs, isStreamRateLimitError } from "../utils/streamRateLimitUtils";
import { invoiceItemMatchesProjectOpsBudgetTarget, isProjectOpsEnabledForOrg, normalizeProjectOpsContext, shouldApplyProjectOpsBudgetSettlement } from "../utils/projectOpsUtils";
import { listActivityWorkflowWorkItems, updateActivityWorkflowWorkItemProgress } from "./notificationActions";
import { advanceIchProjectForMilestones, stampIchInstanceForSave } from "./ichProjectOpsActions";
import { buildStatusDeleteRequest, getStatusDeleteErrorMessage } from "../utils/statusDeleteUtils";
import { isAiCapabilityEnabled } from "../utils/aiCapabilityUtils";
import {
	createPricingSession,
	getPricingSessionSnapshot,
	isPricingSessionActive,
	validatePricingChecklistForSession
} from "../utils/pricingSessionUtils";

import { StreamChat } from "stream-chat";
import chatClient from "../utils/chatClient.js";
// const chatClient = StreamChat.getInstance("fcfa7htpwnqq");
// const chatClient = StreamChat.getInstance("bymefp455ef2");
// chatClient.setBaseURL('https://chat.stream-io-api.com');

const EXTERNAL_RESOURCES_PROP = "externalResources";
const EXTERNAL_RESOURCES_STATE_PATH = ["tree", "root", "entity", EXTERNAL_RESOURCES_PROP];
const RELATED_ITEMS_PROP = "relatedItems";
const RELATED_ITEMS_STATE_PATH = ["tree", "root", "entity", RELATED_ITEMS_PROP];

AWS.config.update({ region: "us-east-1" });

let _visiblePaths = [];
let changePropertyCount = 0; //eslint-disable-line no-unused-vars
let previewBuildRequestId = 0;
const isItemContainerType = (type) => _.isString(type) && type.toLowerCase() === "itemcontainer";
const ITEM_CONTAINER_KIND_LEGACY = "legacy";
const ITEM_CONTAINER_GROUP_START = "#group-start";
const ITEM_CONTAINER_GROUP_END = "#group-end";

function isItemContainerDebugEnabled() {
	if (!utils.isDev()) {
		return false;
	}

	const debugParam = utils.getQueryStringParam("itemContainerDebug");
	return debugParam === true || debugParam === "true" || debugParam === 1 || debugParam === "1";
}

function collectItemContainerStats(nodes, stats = [], parentPath = "", entityTree = false) {
	if (!Array.isArray(nodes)) {
		return stats;
	}

	nodes.forEach((node, index) => {
		if (!node) {
			return;
		}
		const path = parentPath === "" ? String(index) : `${parentPath}.${index}`;
		const type = entityTree ? _.get(node, "entity.type", "") : _.get(node, "type", "");
		const children = Array.isArray(node.children) ? node.children : [];
		if (isItemContainerType(type)) {
			stats.push({
				path,
				type,
				childrenCount: children.length,
				id: entityTree ? _.get(node, "entity.id", "") : _.get(node, "id", "")
			});
		}
		if (children.length > 0) {
			collectItemContainerStats(children, stats, path, entityTree);
		}
	});
	return stats;
}

function logItemContainerStats(label, nodes, entityTree = false) {
	try {
		if (!isItemContainerDebugEnabled()) {
			return;
		}
		const stats = collectItemContainerStats(nodes, [], "", entityTree);
		console.log(`[itemContainer][${label}]`, {
			containerCount: stats.length,
			containers: stats
		});
	} catch (err) {
		console.warn("Unable to log itemContainer stats", err);
	}
}

function hasEmbeddedDriveRuntimeInfo(resource) {
	return _.isObject(resource) && _.isString(resource.path) && !_.isEmpty(resource.path);
}

function mergePublishedDriveResource(resource, driveObject) {
	if (!_.isObject(resource) || !_.isObject(driveObject)) {
		return resource;
	}

	const merged = _.assign({}, resource);

	if (_.isString(driveObject.path) && !_.isEmpty(driveObject.path)) {
		merged.path = driveObject.path;
	}
	if (!_.isNil(driveObject.private)) {
		merged.private = !!driveObject.private;
	}
	if (!_.isNil(driveObject.revision)) {
		merged.revision = driveObject.revision;
	}
	if (_.isPlainObject(driveObject.metaData)) {
		merged.metaData = _.assign({}, resource.metaData || {}, driveObject.metaData);
	}

	return merged;
}

function decodeUrlPathPart(part = "") {
	let decoded = _.toString(part || "");
	for (let index = 0; index < 4; index += 1) {
		try {
			const next = decodeURIComponent(decoded);
			if (next === decoded) {
				break;
			}
			decoded = next;
		} catch (_err) {
			break;
		}
	}
	return decoded;
}

function encodeDriveAssetUrlPath(path = "") {
	return _.toString(path)
		.split("/")
		.map(part => encodeURIComponent(decodeUrlPathPart(part)))
		.join("/");
}

function getPublishedDriveResourceUrl(resource) {
	if (!hasEmbeddedDriveRuntimeInfo(resource)) {
		return "";
	}

	const resourcePath = _.toString(resource.path || "");
	const normalizedPath = resourcePath
		.replace(/^\/public\//, "")
		.replace(/^\/private\//, "")
		.replace(/^public\//, "")
		.replace(/^private\//, "");
	const isPrivateResource = _.has(resource, "private")
		? !!resource.private
		: _.startsWith(resourcePath, "/private/") || _.startsWith(resourcePath, "private/");
	const urlPrefix = isPrivateResource ? env.cloudFront.assetUrls.private : env.cloudFront.assetUrls.public;
	const revision = _.isNil(resource.revision) ? "" : `?v=${encodeURIComponent(resource.revision)}`;

	return `${urlPrefix}/${encodeDriveAssetUrlPath(normalizedPath)}${revision}`;
}

function activityHasExternalResourceRefs(node) {
	let found = false;

	const visit = (value) => {
		if (found || _.isNil(value)) {
			return;
		}

		if (_.isArray(value)) {
			value.forEach(visit);
			return;
		}

		if (_.isPlainObject(value)) {
			if (value.type === "resource/ref" && _.isString(value.refId) && value.refId !== "") {
				found = true;
				return;
			}

			_.forEach(value, visit);
		}
	};

	visit(node);
	return found;
}

async function enrichRuntimeChecklistExternalResources(runtimeChecklist) {
	if (!_.isObject(runtimeChecklist) || !_.isArray(runtimeChecklist.externalResources) || runtimeChecklist.externalResources.length === 0) {
		return runtimeChecklist;
	}

	const driveResources = runtimeChecklist.externalResources.filter((resource) => {
		return resource && resource.type === "resource/external/drive" && _.isString(resource.guid) && !_.isEmpty(resource.guid);
	});

	if (driveResources.length === 0) {
		return runtimeChecklist;
	}

	const driveRuntimeInfoByGuid = {};
	const unresolvedResources = [];

	driveResources.forEach((resource) => {
		if (hasEmbeddedDriveRuntimeInfo(resource)) {
			driveRuntimeInfoByGuid[resource.guid] = resource;
			return;
		}

		const driveObject = getDriveObject(resource.guid);
		if (_.isObject(driveObject) && hasEmbeddedDriveRuntimeInfo(driveObject)) {
			driveRuntimeInfoByGuid[resource.guid] = driveObject;
			return;
		}

		unresolvedResources.push(resource);
	});

	if (unresolvedResources.length > 0) {
		try {
			const fetchedByGuid = await getDriveForActivity(_.assign({}, runtimeChecklist, {
				externalResources: _.uniqBy(unresolvedResources, "guid")
			}));

			unresolvedResources.forEach((resource) => {
				const driveObject = _.get(fetchedByGuid, [resource.guid], null);
				if (_.isObject(driveObject) && hasEmbeddedDriveRuntimeInfo(driveObject)) {
					driveRuntimeInfoByGuid[resource.guid] = driveObject;
				}
			});
		} catch (err) {
			console.warn("Unable to enrich runtime activity drive resources during save", runtimeChecklist.id, err);
		}
	}

	runtimeChecklist.externalResources = runtimeChecklist.externalResources.map((resource) => {
		if (!resource || resource.type !== "resource/external/drive" || !resource.guid) {
			return resource;
		}
		const driveRuntimeInfo = driveRuntimeInfoByGuid[resource.guid];
		return driveRuntimeInfo ? mergePublishedDriveResource(resource, driveRuntimeInfo) : resource;
	});

	if (isDriveReference(runtimeChecklist.heroImage)) {
		const heroResource = _.find(runtimeChecklist.externalResources, (resource) => resource && resource.id === runtimeChecklist.heroImage.refId);
		const heroImageUrl = getPublishedDriveResourceUrl(heroResource);
		if (heroImageUrl) {
			runtimeChecklist.heroImageUrl = heroImageUrl;
		}
	}

	return runtimeChecklist;
}

function hasValidRawItemChildren(children = []) {
	return Array.isArray(children) && children.some((child) => _.isObject(child) && _.isString(child.type));
}

function hasValidEntityItemChildren(children = []) {
	return Array.isArray(children) && children.some((child) => _.isObject(child) && _.isObject(child.entity) && _.isString(child.entity.type));
}

function buildEntitySiblingLookup(entityNodes = []) {
	const byGuid = {};
	const byId = {};
	if (!Array.isArray(entityNodes)) {
		return { byGuid, byId };
	}
	entityNodes.forEach((entityNode) => {
		if (!_.isObject(entityNode) || !_.isObject(entityNode.entity)) {
			return;
		}
		const guid = _.get(entityNode, "entity.guid", "");
		const id = _.get(entityNode, "entity.id", "");
		if (_.isString(guid) && guid !== "") {
			byGuid[guid] = entityNode;
		}
		if (_.isString(id) && id !== "") {
			byId[id] = entityNode;
		}
	});
	return { byGuid, byId };
}

function materializeEntityChildrenFromRawChildren(rawChildren = [], identityId = null) {
	if (!Array.isArray(rawChildren) || rawChildren.length === 0) {
		return [];
	}

	const pseudoActivity = {
		id: generateUUID(),
		name: "__itemContainerHydrate__",
		children: _.cloneDeep(rawChildren)
	};
	const transformed = transformToChecklistEntities(pseudoActivity, identityId);
	return _.get(transformed, "root.children", []);
}

function repairMissingItemContainerEntityChildren(rawNodes = [], entityNodes = [], identityId = null) {
	if (!Array.isArray(rawNodes) || !Array.isArray(entityNodes) || rawNodes.length === 0 || entityNodes.length === 0) {
		return 0;
	}

	const entityLookup = buildEntitySiblingLookup(entityNodes);
	let repairedCount = 0;

	rawNodes.forEach((rawNode, rawIndex) => {
		if (!_.isObject(rawNode)) {
			return;
		}

		let entityNode = _.isObject(entityNodes[rawIndex]) ? entityNodes[rawIndex] : null;
		const rawGuid = _.get(rawNode, "guid", "");
		const rawId = _.get(rawNode, "id", "");
		if (_.isString(rawGuid) && rawGuid !== "" && entityLookup.byGuid[rawGuid]) {
			entityNode = entityLookup.byGuid[rawGuid];
		} else if (_.isString(rawId) && rawId !== "" && entityLookup.byId[rawId]) {
			entityNode = entityLookup.byId[rawId];
		}

		if (!_.isObject(entityNode)) {
			return;
		}

		const rawChildren = Array.isArray(rawNode.children) ? rawNode.children : [];
		let entityChildren = Array.isArray(entityNode.children) ? entityNode.children : [];
		const rawType = _.get(rawNode, "type", "");

		if (isItemContainerType(rawType) && hasValidRawItemChildren(rawChildren) && !hasValidEntityItemChildren(entityChildren)) {
			const hydratedChildren = materializeEntityChildrenFromRawChildren(rawChildren, identityId);
			if (Array.isArray(hydratedChildren) && hydratedChildren.length > 0) {
				entityNode.children = hydratedChildren;
				entityNode.expanded = true;
				entityChildren = entityNode.children;
				repairedCount += 1;
			}
		}

		if (rawChildren.length > 0 && entityChildren.length > 0) {
			repairedCount += repairMissingItemContainerEntityChildren(rawChildren, entityChildren, identityId);
		}
	});

	return repairedCount;
}

function isLegacyItemContainerNode(node) {
	if (!_.isObject(node) || !isItemContainerType(node.type)) {
		return false;
	}
	const containerKind = _.toLower(_.trim(_.get(node, "containerKind", "form")));
	return containerKind === ITEM_CONTAINER_KIND_LEGACY;
}

function hasLegacyItemContainerNodes(nodes = []) {
	if (!Array.isArray(nodes) || nodes.length === 0) {
		return false;
	}
	for (let i = 0; i < nodes.length; i += 1) {
		const node = nodes[i];
		if (!_.isObject(node)) {
			continue;
		}
		if (isLegacyItemContainerNode(node)) {
			return true;
		}
		if (Array.isArray(node.children) && hasLegacyItemContainerNodes(node.children)) {
			return true;
		}
	}
	return false;
}

function addItemGroupMarker(item, marker) {
	if (!_.isObject(item)) {
		return;
	}
	const markerNormalized = _.toLower(marker);
	const groupNames = _.isArray(item.groupNames) ? _.cloneDeep(item.groupNames) : [];
	const hasMarker = groupNames.some((groupName) => _.toLower(groupName) === markerNormalized);
	if (!hasMarker) {
		groupNames.push(marker);
	}
	item.groupNames = groupNames;
}

function getItemContainerHeaderLabel(container) {
	if (!_.isObject(container)) {
		return "";
	}
	const label1 = _.isString(container.label1) ? container.label1 : "";
	if (!_.isEmpty(_.trim(label1))) {
		return label1;
	}
	const label = _.isString(container.label) ? container.label : "";
	if (!_.isEmpty(_.trim(label))) {
		return label;
	}
	return "";
}

function buildLegacyItemContainerHeaderItem(container) {
	if (!_.isObject(container) || container.showHeader === false) {
		return null;
	}
	const label = getItemContainerHeaderLabel(container);
	if (_.isEmpty(label)) {
		return null;
	}

	return {
		id: "",
		guid: generateUUID(),
		type: "item",
		groupNames: _.isArray(container.groupNames) ? _.cloneDeep(container.groupNames) : [],
		filterTags: _.isArray(container.filterTags) ? _.cloneDeep(container.filterTags) : [],
		showFor: _.isObject(container.showFor) ? _.cloneDeep(container.showFor) : {},
		checked: false,
		ignoreCompletion: true,
		skipItem: true,
		enabled: container.enabled !== false,
		visible: container.visible !== false,
		conditionalVisible: (_.isString(container.conditionalVisible) || _.isPlainObject(container.conditionalVisible) || _.isArray(container.conditionalVisible))
			? _.cloneDeep(container.conditionalVisible)
			: "",
		label1: label,
		label2: "",
		labelOnly: true,
		labelOnlyBackgroundColor: _.isString(container.labelOnlyBackgroundColor) ? container.labelOnlyBackgroundColor : "",
		styles: _.isObject(container.styles) ? _.cloneDeep(container.styles) : {},
		classes: _.isObject(container.classes) ? _.cloneDeep(container.classes) : {}
	};
}

function normalizeLegacyFlattenNode(node) {
	if (!_.isObject(node)) {
		return null;
	}

	if (_.isString(node.type) && node.type !== "") {
		return _.cloneDeep(node);
	}

	const entityType = _.get(node, "entity.type", "");
	if (!_.isString(entityType) || entityType === "") {
		return _.cloneDeep(node);
	}

	const normalized = _.cloneDeep(node.entity);
	if (!_.isArray(normalized.children)) {
		const nodeChildren = _.isArray(node.children) ? node.children : [];
		if (nodeChildren.length > 0) {
			normalized.children = nodeChildren
				.map((childNode) => normalizeLegacyFlattenNode(childNode))
				.filter((childNode) => _.isObject(childNode));
		}
	}
	return normalized;
}

function pushLegacyGroupedItems(flattened, groupedItems, container = null) {
	if (!_.isArray(groupedItems) || groupedItems.length === 0) {
		return;
	}
	addItemGroupMarker(groupedItems[0], ITEM_CONTAINER_GROUP_START);
	addItemGroupMarker(groupedItems[groupedItems.length - 1], ITEM_CONTAINER_GROUP_END);
	if (_.isObject(container)) {
		groupedItems[0].itemContainerLeadGuid = _.get(container, "guid", "");
		groupedItems[0].itemContainerLeadId = _.get(container, "id", "");
	}
	flattened.push(...groupedItems);
}

function collectLegacyItemContainerGroups(container) {
	const groups = [];
	if (!_.isObject(container)) {
		return groups;
	}

	let currentGroup = [];
	const headerItem = buildLegacyItemContainerHeaderItem(container);
	if (_.isObject(headerItem)) {
		currentGroup.push(headerItem);
	}

	const containerChildren = _.isArray(container.children) ? container.children : [];
	containerChildren.forEach((child) => {
		const normalizedChild = normalizeLegacyFlattenNode(child);
		if (!_.isObject(normalizedChild)) {
			return;
		}

		if (isLegacyItemContainerNode(normalizedChild)) {
			if (currentGroup.length > 0) {
				groups.push(currentGroup);
				currentGroup = [];
			}
			const nestedGroups = collectLegacyItemContainerGroups(normalizedChild);
			nestedGroups.forEach((nestedGroup) => {
				if (_.isArray(nestedGroup) && nestedGroup.length > 0) {
					groups.push(nestedGroup);
				}
			});
			return;
		}

		if (_.isArray(normalizedChild.children) && normalizedChild.children.length > 0) {
			normalizedChild.children = flattenItemContainerChildren(normalizedChild.children);
		}

		currentGroup.push(normalizedChild);
	});

	if (currentGroup.length > 0) {
		groups.push(currentGroup);
	}

	return groups;
}

function flattenItemContainerChildren(children) {
	const flattened = [];
	if (!_.isArray(children)) {
		return flattened;
	}

	children.forEach((child) => {
		if (!_.isObject(child)) {
			return;
		}

		const normalizedChild = normalizeLegacyFlattenNode(child);
		if (!_.isObject(normalizedChild)) {
			return;
		}
		if (isLegacyItemContainerNode(normalizedChild)) {
			const containerGroups = collectLegacyItemContainerGroups(normalizedChild);
			containerGroups.forEach((groupedItems) => {
				pushLegacyGroupedItems(flattened, groupedItems, normalizedChild);
			});
			return;
		}

		if (_.isArray(normalizedChild.children) && normalizedChild.children.length > 0) {
			normalizedChild.children = flattenItemContainerChildren(normalizedChild.children);
		}

		flattened.push(normalizedChild);
	});

	return flattened;
}

function applyLegacyItemContainerRuntimeFallback(checklist) {
	if (!_.isObject(checklist) || !_.isArray(checklist.children) || !hasLegacyItemContainerNodes(checklist.children)) {
		return checklist;
	}

	const fallbackChecklist = _.cloneDeep(checklist);
	fallbackChecklist.children = flattenItemContainerChildren(fallbackChecklist.children);
	if (isItemContainerDebugEnabled() && typeof window !== "undefined") {
		try {
			window.__itemContainerPreviewDebug = {
				timestamp: Date.now(),
				mode: "legacy-only-fallback",
				before: collectItemContainerStats(_.get(checklist, "children", []), [], "", false),
				after: collectItemContainerStats(_.get(fallbackChecklist, "children", []), [], "", false),
				topLevelAfter: _.get(fallbackChecklist, "children", []).map((node, index) => ({
					index,
					type: _.get(node, "type", ""),
					childrenCount: _.isArray(node.children) ? node.children.length : 0
				}))
			};
		} catch (err) {
			console.warn("Unable to capture itemContainer preview debug data", err);
		}
	}
	return fallbackChecklist;
}

function sanitizeChecklistForPreview(checklist, source = "preview") {
	if (!_.isObject(checklist)) {
		return checklist;
	}

	const sanitizedChecklist = _.cloneDeep(checklist);
	const invalidNodes = [];

	function sanitizeChildren(children, path = "children") {
		if (!Array.isArray(children)) {
			if (!_.isUndefined(children)) {
				invalidNodes.push({
					path,
					reason: "children_not_array",
					valueType: typeof children
				});
			}
			return [];
		}

		const sanitizedChildren = [];
		for (let i = 0; i < children.length; i += 1) {
			const child = children[i];
			const childPath = `${path}.${i}`;
			if (!_.isObject(child)) {
				invalidNodes.push({
					path: childPath,
					reason: "node_not_object",
					valueType: typeof child
				});
				continue;
			}

			const type = _.get(child, "type", "");
			if (!_.isString(type) || _.trim(type) === "") {
				invalidNodes.push({
					path: childPath,
					reason: "missing_type",
					keys: Object.keys(child).slice(0, 12)
				});
				continue;
			}

			if (Object.prototype.hasOwnProperty.call(child, "children")) {
				child.children = sanitizeChildren(child.children, `${childPath}.children`);
			}
			sanitizedChildren.push(child);
		}

		return sanitizedChildren;
	}

	sanitizedChecklist.children = sanitizeChildren(sanitizedChecklist.children, "children");

	if (invalidNodes.length > 0) {
		console.warn(`[preview][sanitize] Removed ${invalidNodes.length} invalid node(s) from ${source} checklist payload.`, invalidNodes.slice(0, 25));
		if (isItemContainerDebugEnabled() && typeof window !== "undefined") {
			window.__previewChecklistSanitize = {
				timestamp: Date.now(),
				source,
				removedCount: invalidNodes.length,
				invalidNodes: invalidNodes.slice(0, 200)
			};
		}
	}

	return sanitizedChecklist;
}

export function clearAppState(tree = state) {
	tree.set(["appState", "previewChecklist"], {
		checklist: {},
		showModal: false,
		showInline: false,
		activityVars: {},
		activityVarsProfileKey: "",
		live: false,
		allVisible: true
	});
}

export function resetEditorSessionState(tree = state, options = {}) {
	const preserveClipboard = options.preserveClipboard === true;

	tree.set(["tree"], {});
	tree.set(["editActivityMetaData"], {
		inlineVariables: {}
	});
	tree.set(["selectedNodePath"], []);
	tree.set(["selectedChecklistId"], "");
	tree.set(["typeahead"], []);
	if (!preserveClipboard) {
		tree.set(["clipboardPasteText"], "");
		tree.set(["clipboard"], {});
		tree.set(["clipboardExternalResources"], []);
		tree.set(["clipboardRelatedItems"], []);
		tree.set(["clipboardMode"], "");
	}
	tree.set(["history"], []);
	tree.set(["historyIndex"], -1);
	tree.set(["appState", "editor", "showSpinner"], false);
	tree.set(["appState", "editor", "spinnerMessage"], "");
	tree.set(["appState", "documents", "showSpinner"], false);
	clearAppState(tree);

	if (typeof window !== "undefined") {
		delete window.refreshFromS3;
		delete window.restoredFromLs;
		delete window.__itemContainerPreviewDebug;
		delete window.__itemContainerLoadDebug;
		delete window.__previewChecklistSanitize;
	}
}

function getCurrentBrowserPath() {
	return `${_.toString(window.location.pathname || "")}${_.toString(window.location.search || "")}${_.toString(window.location.hash || "")}`;
}

function isSupportedNavigationPath(path) {
	return !(_.isString(path) && path.indexOf("/infinityInspire") === 0) || isAiCapabilityEnabled(env.appCapabilities);
}

function getNavPanelForPath(path, fallback = "home") {
	if (!_.isString(path) || path === "") {
		return fallback;
	}
	if (path.indexOf("/searchHistory") !== -1) {
		return "searchHistory";
	} else if (path.indexOf("/infinityInspire") !== -1 && isSupportedNavigationPath(path)) {
		return "infinityInspire";
	} else if (path.indexOf("/search") !== -1) {
		return "search";
	} else if (path.indexOf("/chat") !== -1) {
		return "chat";
	} else if (path.indexOf("/dashboard") !== -1) {
		return "dashboard";
	} else if (path.indexOf("/checklists") !== -1) {
		return "myChecklists";
	} else if (path.indexOf("/history") !== -1) {
		return "history";
	} else if (path.indexOf("/timers") !== -1) {
		return "timers";
	} else if (path.indexOf("/checkMateImport") !== -1) {
		return "checkMateImport";
	} else if (path.indexOf("/player") !== -1) {
		return "player";
	} else if (path.indexOf("/home") !== -1) {
		return "home";
	}
	return fallback;
}

function clearRouteTransitionLoaders() {
	utils.hideLoader(state);
	state.set(["appState", "documents", "showSpinner"], false);
	state.set(PlayerPaths.SHOW_SPINNER, false);
}

function syncUrlParamsForNavigationTarget(targetPath, reason) {
	const syncedParams = utils.syncUrlParamsFromPath(targetPath);
	if (syncedParams) {
		logWebLoginSequence("actions.navigate synced url params", {
			reason,
			paramKeys: Object.keys(syncedParams)
		});
	}
}

export function navigate(nav, altMyChecklistsTarget = null) {
	console.info("APP START", utils.getLs("origin"));
	const origin = utils.getLs("origin");
	const mobileDeferredBootstrap = (
		utils.isMobile() &&
		Number(utils.getQueryStringParam("app-api-version")) >= 8 &&
		utils.getQueryStringParam("deferInventory") === true
	);
	logWebLoginSequence("actions.navigate entered", {
		nav,
		origin: origin || "",
		altMyChecklistsTarget,
		userLoggedIn: state.get(["user", "loggedIn"]),
		userEntryPoint: state.get(["user", "entryPoint"]) || "",
		navPanelSelected: state.get(["appState", "navPanel", "selected"]),
		appInitialized: state.get(["appState", "initialized"]),
		mobileDeferredBootstrap
	});

	if (state.get(["user", "loggedIn"]) && origin && origin !== "") {
		if (origin === "/login" || origin === "/" || !isSupportedNavigationPath(origin)) {
			logWebLoginSequence("actions.navigate clearing ignored origin", {
				origin
			});
			ls.remove("origin");
		} else {
			console.info("APP START REDIRECT", origin);
			const targetNavPanel = getNavPanelForPath(origin, state.get(["appState", "navPanel", "selected"]) || "home");
			logWebLoginSequence("actions.navigate redirecting to stored origin", {
				origin,
				targetNavPanel
			});
			// Remove key if about to set
			ls.remove("origin");
			syncUrlParamsForNavigationTarget(origin, "stored-origin");
			state.set(["appState", "navPanel", "selected"], targetNavPanel);
			clearRouteTransitionLoaders();
			const currentPath = getCurrentBrowserPath();
			if (currentPath === origin) {
				logWebLoginSequence("actions.navigate skipped same-origin push", {
					origin,
					targetNavPanel
				});
				return;
			}
			browserHistory.push(origin);
			return;
		}
	}

	const user = state.get(["user"]);
	console.log("Nav request", user, nav);
	const mobileOrHomeHidden = utils.isMobile() || state.get(["appCapabilities", "views", "nav", "homeVisible"]) === false;

	// Have to deal with iTunes subscription and if expired
	let expired = false;
	const current = Date.now();
	let subscriptionPlan;
	if (user.hasOwnProperty("subscriptionPlan")) {
		subscriptionPlan = state.get(["user", "subscriptionPlan"]);
	} else {
		subscriptionPlan = env.config.defaultPlan;
	}

	if ((user.subscriptionPlan === "pro-plan-yearly-itunes" || user.subscriptionPlan === "pro-plan-monthly-itunes") && current > user.subscriptionExpiration) {
		expired = true;
	} else {
		expired = false;
	}
	if (nav/* && !mobile */) {
		state.set(["appState", "initialized"], true);
		const urlParams = state.get(["appState", "urlParams"]);
		if ((urlParams.subscriptionPlan === "basic-plan" || urlParams.subscriptionPlan === "standard-plan" || urlParams.subscriptionPlan === "pro-plan")) {
			if (subscriptionPlan === "pro-plan-unlimited") {
				alert("You are already in the Pro Plan (Unlimited) plan. This plan has all features and never expires. There is no need to change plans.");
			} else if (subscriptionPlan.includes("itunes")) {
				alert("You are already in a plan purchased through the app. You will need to let that expire before you can purchase a plan from the website. Email support@ambifi.com if you have questions.");
			}
		}

		if (urlParams.updateCard === "true") {
			const path = "/updateCustomerCard";
			browserHistory.push(path);
		} else if (urlParams.purchaseCustom === "true") {
			const path = "/purchaseCustom";
			browserHistory.push(path);
		} else if (expired ||
			((urlParams.subscriptionPlan === "basic-plan" || urlParams.subscriptionPlan === "standard-plan" || urlParams.subscriptionPlan === "pro-plan") &&
				(subscriptionPlan === "basic-plan" || subscriptionPlan === "basic-plan-checkmate" || subscriptionPlan === "standard-plan-unlimited" || subscriptionPlan === "pro-plan-monthly" || subscriptionPlan === "pro-plan-yearly"))) {
			const path = "/subscribe";
			browserHistory.push(path);
		} else {
			//if mobile, checklists is default entry point, if not mobile, home is default
			let path = mobileDeferredBootstrap ? "/home" : (mobileOrHomeHidden ? (isOrganizationAdministrator() || isOrganizationAuthor()) ? "/checklists" : "/search" : "/home");
			const userInfo = state.select("user").get();
			/**
															 * entryPoint['appState','navPanel']
															 */
			// entryPoint
			let targetNavPanel = mobileDeferredBootstrap ? "home" : (mobileOrHomeHidden ? (isOrganizationAdministrator() || isOrganizationAuthor()) ? "checklists" : "search" : "home");

			if (!mobileDeferredBootstrap && userInfo && userInfo.entryPoint && userInfo.entryPoint !== "" && isSupportedNavigationPath(userInfo.entryPoint)) {
				if (userInfo.entryPoint.indexOf("/search") !== -1) {
					targetNavPanel = "search";
				} else if (userInfo.entryPoint.indexOf("/infinityInspire") !== -1) {
					targetNavPanel = "infinityInspire";
				} else if (userInfo.entryPoint.indexOf("/chat") !== -1) {
					targetNavPanel = "chat";
				} else if (userInfo.entryPoint.indexOf("/searchHistory") !== -1) {
					targetNavPanel = "searchHistory";
				} else if (userInfo.entryPoint.indexOf("/dashboard") !== -1) {
					targetNavPanel = "dashboard";
				} else if (userInfo.entryPoint.indexOf("/checklists") !== -1) {
					targetNavPanel = "myChecklists";
				} else if (userInfo.entryPoint.indexOf("/history") !== -1) {
					targetNavPanel = "history";
				} else if (userInfo.entryPoint.indexOf("/timers") !== -1) {
					targetNavPanel = "timers";
				} else if (userInfo.entryPoint.indexOf("/checkMateImport") !== -1) {
					targetNavPanel = "checkMateImport";
				} else if (userInfo.entryPoint.indexOf("/player") !== -1) {
					targetNavPanel = "player";
				} else if (userInfo.entryPoint.indexOf("/home") !== -1) {
					targetNavPanel = "home";
				}
				path = userInfo.entryPoint;
			}

			if (((path === "/home" && targetNavPanel === "home") || (path === "/checklists" && targetNavPanel === "myChecklists")) && altMyChecklistsTarget && _.isString(altMyChecklistsTarget) && isSupportedNavigationPath(altMyChecklistsTarget)) {
				path = altMyChecklistsTarget;
				if (altMyChecklistsTarget.indexOf("/search") !== -1) {
					targetNavPanel = "search";
				} else if (altMyChecklistsTarget.indexOf("/infinityInspire") !== -1) {
					targetNavPanel = "infinityInspire";
				} else if (altMyChecklistsTarget.indexOf("/chat") !== -1) {
					targetNavPanel = "chat";
				} else if (altMyChecklistsTarget.indexOf("/searchHistory") !== -1) {
					targetNavPanel = "searchHistory";
				} else if (altMyChecklistsTarget.indexOf("/dashboard") !== -1) {
					targetNavPanel = "dashboard";
				} else if (altMyChecklistsTarget.indexOf("/checklists") !== -1) {
					targetNavPanel = "myChecklists";
				} else if (altMyChecklistsTarget.indexOf("/history") !== -1) {
					targetNavPanel = "history";
				} else if (altMyChecklistsTarget.indexOf("/timers") !== -1) {
					targetNavPanel = "timers";
				} else if (altMyChecklistsTarget.indexOf("/checkMateImport") !== -1) {
					targetNavPanel = "checkMateImport";
				} else if (altMyChecklistsTarget.indexOf("/player") !== -1) {
					targetNavPanel = "player";
				} else if (altMyChecklistsTarget.indexOf("/home") !== -1) {
					targetNavPanel = "home";
				}
			}

			logWebLoginSequence("actions.navigate final route", {
				path,
				targetNavPanel,
				userEntryPoint: userInfo && userInfo.entryPoint ? userInfo.entryPoint : "",
				altMyChecklistsTarget,
				mobileOrHomeHidden,
				expired
			});
			state.set(["appState", "navPanel", "selected"], targetNavPanel);
			clearRouteTransitionLoaders();
			syncUrlParamsForNavigationTarget(path, "final-route");
			const currentPath = getCurrentBrowserPath();
			if (currentPath === path) {
				logWebLoginSequence("actions.navigate skipped same-route push", {
					path,
					targetNavPanel
				});
				return;
			}
			browserHistory.push(path);
		}
	}
}

// Call this right after a user updates something locally
export function setOptimisticUpdate(instanceId, updatedFields) {
	const cur = state.select(["optimisticMap", instanceId]);
	const prev = cur.get() || {};
	cur.set(merge({}, prev, updatedFields));
}

// 3) Helper: clear one or all
export function clearOptimisticUpdate(instanceId) {
	if (instanceId) {
		state.unset(["optimisticMap", instanceId]);
	} else {
		state.set(["optimisticMap"], {});
	}
}

export function getMergedHit(hit) {
	const override = state.get(["optimisticMap", hit.instanceId]);
	return override ? merge({}, hit, override) : hit;
}

export function deleteChecklistInstance(tree, identityId, checklistId, instanceId, timestamp) {
	let lastTimestamp = timestamp.replace(" ", "T");

	awsS3.deleteJsonFileFromS3WithKeyPrefix(env.s3.contentBucket, identityId, checklistId + "/" + lastTimestamp + "_" + instanceId + ".json");
}

export function performSaveActivityPreflightValidation() {
	//showEditorSpinner();
	let result = {
		blockSave: false,
		optionalSave: false,
		validationErrors: [],
		getValidationErrorsAsText: () => {
			const _result = result.validationErrors.map(error => {
				return error.message;
			});
			return _result.join("\n");
		},
		getValidationErrorAsArray: () => {
			return result.validationErrors.map(error => {
				return error.message;
			});
		}
	};
	let activity = transformFromChecklistEntities(state.get(["tree", "root"]));

	const linkValidationErrors = validateExternalDependencies(activity, true);
	if (!_.isEmpty(linkValidationErrors)) {
		result.validationErrors = linkValidationErrors;
	}

	result.validationErrors.forEach(error => {
		if (error.validationErrorSeverity > 1) {
			result.blockSave = true;
		}
		if (error.validationErrorSeverity > 0) {
			result.optionalSave = true;
		}
	});
	console.log("Validation result:", result);
	return result;
}

export function hideEditorSpinner() {
	state.set(["appState", "editor", "showSpinner"], false);
	state.set(["appState", "editor", "spinnerMessage"], "");
}

export function showEditorSpinner(message = "") {
	if (_.isString(message) && message.trim() !== "") {
		state.set(["appState", "editor", "spinnerMessage"], message);
	}
	state.set(["appState", "editor", "showSpinner"], true);
}

export function setEditorSpinnerMessage(message) {
	state.set(["appState", "editor", "spinnerMessage"], message);
}

export function togglePreviewVisible(tree = state) {
	if (tree.get(["tree", "root"]).children.length === 0) {
		alert("No content in your activity yet! Add a List, Section or Item in the outline to get started.");
	} else {

		tree.set(["appState", "previewChecklist", "allVisible"], !tree.get(["appState", "previewChecklist", "allVisible"]));

		previewChecklistInline();
	}
}

export function togglePreviewLive(tree = state) {
	if (tree.get(["tree", "root"]).children.length === 0) {
		alert("No content in your activity yet! Add a List, Section or Item in the outline to get started.");
	} else {
		const currentMode = getPreviewUpdateMode(tree);
		const nextMode = currentMode === PREVIEW_UPDATE_MODE_MANUAL
			? PREVIEW_UPDATE_MODE_ON_REFRESH
			: currentMode === PREVIEW_UPDATE_MODE_ON_REFRESH
				? PREVIEW_UPDATE_MODE_LIVE
				: PREVIEW_UPDATE_MODE_MANUAL;

		setPreviewUpdateMode(tree, nextMode);
		if (nextMode === PREVIEW_UPDATE_MODE_MANUAL) {
			clearPendingPreviewStateUpdates();
		} else {
			previewChecklistInline();
		}
	}
}

export function getPreviewUpdateMode(tree = state) {
	const mode = tree.get(["appState", "previewChecklist", "updateMode"]);
	if (mode === PREVIEW_UPDATE_MODE_LIVE || mode === PREVIEW_UPDATE_MODE_ON_REFRESH || mode === PREVIEW_UPDATE_MODE_MANUAL) {
		return mode;
	}
	return tree.get(["appState", "previewChecklist", "live"]) ? PREVIEW_UPDATE_MODE_LIVE : PREVIEW_UPDATE_MODE_MANUAL;
}

export function setPreviewUpdateMode(tree = state, mode = PREVIEW_UPDATE_MODE_MANUAL) {
	const normalizedMode = mode === PREVIEW_UPDATE_MODE_LIVE || mode === PREVIEW_UPDATE_MODE_ON_REFRESH
		? mode
		: PREVIEW_UPDATE_MODE_MANUAL;
	tree.set(["appState", "previewChecklist", "updateMode"], normalizedMode);
	tree.set(["appState", "previewChecklist", "live"], normalizedMode === PREVIEW_UPDATE_MODE_LIVE);
}

export function getPreviewUpdateModeLabel(mode) {
	if (mode === PREVIEW_UPDATE_MODE_LIVE) {
		return "Live";
	}
	if (mode === PREVIEW_UPDATE_MODE_ON_REFRESH) {
		return "Update On Refresh";
	}
	return "Manual";
}

export function applyPreviewStateUpdates(tree = state) {
	if (tree.get(["tree", "root"]).children.length === 0) {
		alert("No content in your activity yet! Add a List, Section or Item in the outline to get started.");
		return;
	}

	const previewChecklist = tree.get(["appState", "previewChecklist"]);
	if (!previewChecklist || previewChecklist.showInline !== true) {
		previewChecklistInline();
		return;
	}

	flushPendingPreviewStateUpdates();
}

export function downloadActivity(activity) {
	if (_.isUndefined(activity)) {
		activity = transformFromChecklistEntities(state.get(["tree", "root"]));
	}
	cleanUpExternalResources(activity);
	cleanUpRelatedItemReferences(activity);
	const blob = new Blob([JSON.stringify(activity)], { type: "application/json;charset=utf-8" });
	FileSaver.saveAs(blob, `${activity.id}.json`);
}

export async function downloadActivityPublishedFromS3(activityId) {
	showDocumentsSpinner();
	try {
		let activityInfo = getActivityById(activityId);
		let activity = await awsS3.getActivity(activityInfo.id, activityInfo.identityId);
		const blob = new Blob([JSON.stringify(activity)], { type: "application/json;charset=utf-8" });
		FileSaver.saveAs(blob, `${activity.id}.json`);
	} finally {
		hideDocumentsSpinner();
	}
}

export async function downloadActivitySourceFromS3(activityId) {
	showDocumentsSpinner();
	try {
		let activityInfo = getActivityById(activityId);
		let result = await awsS3.getActivityForAuthoring(activityInfo.id, activityInfo.identityId);
		let sourceActivity = _.get(result, "activity", {});
		const blob = new Blob([JSON.stringify(sourceActivity)], { type: "application/json;charset=utf-8" });
		FileSaver.saveAs(blob, `${sourceActivity.id}-source.json`);
	} finally {
		hideDocumentsSpinner();
	}
}

export async function downloadActivityFromS3(activityId) {
	return downloadActivityPublishedFromS3(activityId);
}


export async function saveChecklistNoUi(checklist = null) {
	return new Promise((resolve, reject) => {
		setTimeout(async () => {
			try {
				await refreshCredentials(true);
				console.log("About to save checklist", checklist);
				let _checklist = checklist;
				const runtimeChecklist = await compileChecklistBankRefsForRuntimeSave(_checklist);

				awsS3.updateChecklistsAndPushToS3(_checklist, null, { message: "The activity was successfully saved!", runtimeChecklist }).then(() => {
					resolve();
				}).catch((e) => {
					console.error(e);
					reject(e);
				});
			} catch (e) {
				console.error(e);
				reject(e);
			}
		});
	});
}

export async function bulkRepublishActivities(activityDocs = [], opts = {}) {
	const {
		onProgress = null,
		stopOnError = false,
		breakLocks = false
	} = opts || {};

	const candidates = (_.isArray(activityDocs) ? activityDocs : []).filter((activity) => {
		return _.isObject(activity) && _.isString(activity.id) && activity.id !== "" && !activity.newDoc;
	});

	const report = {
		startedAt: new Date().toISOString(),
		total: candidates.length,
		processed: 0,
		succeeded: 0,
		failed: 0,
		successes: [],
		failures: []
	};

	const startedAtMs = Date.now();

	for (let i = 0; i < candidates.length; i += 1) {
		const doc = candidates[i];
		const activityId = doc.id;
		const activityName = _.toString(doc.name || activityId);
		const keyPrefix = doc.identityId && doc.sharedWithType !== "self" ? doc.identityId : getIdentityId();

			if (_.isFunction(onProgress)) {
				onProgress({
					index: i,
					total: candidates.length,
					activityId,
					activityName,
					status: "running"
				});
			}

			try {
				const lockInfo = await hasLock(activityId, keyPrefix);
				if (!lockInfo.unlocked) {
					if (!breakLocks) {
						const lockOwner = _.toString(lockInfo.lockOwner || "another user");
						throw new Error(`Activity is locked by ${lockOwner}. Enable "Break locks when needed" to override.`);
					}

					if (!isOrganizationAdministrator() && !lockInfo.lockedInOtherInstance) {
						const lockOwner = _.toString(lockInfo.lockOwner || "another user");
						throw new Error(`Activity is locked by ${lockOwner}. Only administrators can break another user's lock.`);
					}

					if (_.isFunction(onProgress)) {
						onProgress({
							index: i,
							total: candidates.length,
							activityId,
							activityName,
							status: "breaking lock"
						});
					}

					await breakLock(activityId, keyPrefix);
				}

				const { activity } = await awsS3.getActivityForAuthoring(activityId, keyPrefix);
			const previousRevision = _.isNumber(activity.revision) ? activity.revision : null;
			const nextRevision = _.isNumber(previousRevision) ? previousRevision + 1 : 1;
			activity.revision = nextRevision;
			activity.revisionTs = Date.now();
			cleanUpExternalResources(activity);
			if (activityHasExternalResourceRefs(activity) && (!_.isArray(activity.externalResources) || activity.externalResources.length === 0)) {
				throw new Error("Activity still contains resource references but externalResources is empty after cleanup. Refusing to republish to avoid corrupting source/runtime files.");
			}
			cleanUpRelatedItemReferences(activity);
			await utils.publishActivity(activity);
			const runtimeChecklist = await compileChecklistBankRefsForRuntimeSave(activity);
			await awsS3.updateChecklistsAndPushToS3(activity, null, {
				message: "",
				ignoreContributors: true,
				lock: false,
				runtimeChecklist
			});

			report.succeeded += 1;
			report.successes.push({
				activityId,
				activityName,
				previousRevision,
				revision: nextRevision
			});

			if (_.isFunction(onProgress)) {
				onProgress({
					index: i + 1,
					total: candidates.length,
					activityId,
					activityName,
					status: "success",
					previousRevision,
					revision: nextRevision
				});
			}
		} catch (err) {
			const errorMessage = _.toString(_.get(err, "message", err) || "Unknown error");
			report.failed += 1;
			report.failures.push({
				activityId,
				activityName,
				error: errorMessage
			});

			if (_.isFunction(onProgress)) {
				onProgress({
					index: i + 1,
					total: candidates.length,
					activityId,
					activityName,
					status: "error",
					error: errorMessage
				});
			}

			if (stopOnError) {
				report.processed = i + 1;
				break;
			}
		}

		report.processed = i + 1;
	}

	report.finishedAt = new Date().toISOString();
	report.durationMs = Date.now() - startedAtMs;

	return report;
}

export async function bulkPublishActivitiesToOrgSearch(activityDocs = [], opts = {}) {
	const {
		onProgress = null,
		stopOnError = false
	} = opts || {};

	const candidates = (_.isArray(activityDocs) ? activityDocs : []).filter((activity) => {
		return _.isObject(activity) && _.isString(activity.id) && activity.id !== "" && !activity.newDoc;
	});

	const report = {
		startedAt: new Date().toISOString(),
		total: candidates.length,
		processed: 0,
		succeeded: 0,
		failed: 0,
		successes: [],
		failures: []
	};

	const startedAtMs = Date.now();

	for (let i = 0; i < candidates.length; i += 1) {
		const doc = candidates[i];
		const activityId = doc.id;
		const activityName = _.toString(doc.name || activityId);
		const wasAlreadyPublished = doc.orgPrivacy === "public";

		if (_.isFunction(onProgress)) {
			onProgress({
				index: i,
				total: candidates.length,
				activityId,
				activityName,
				status: "running"
			});
		}

		try {
			await awsS3.setDocumentOrgPrivacy(doc, "public");

			report.succeeded += 1;
			report.successes.push({
				activityId,
				activityName,
				action: wasAlreadyPublished ? "updated" : "published"
			});

			if (_.isFunction(onProgress)) {
				onProgress({
					index: i + 1,
					total: candidates.length,
					activityId,
					activityName,
					status: "success",
					action: wasAlreadyPublished ? "updated" : "published"
				});
			}
		} catch (err) {
			const errorMessage = _.toString(_.get(err, "message", err) || "Unknown error");
			report.failed += 1;
			report.failures.push({
				activityId,
				activityName,
				error: errorMessage
			});

			if (_.isFunction(onProgress)) {
				onProgress({
					index: i + 1,
					total: candidates.length,
					activityId,
					activityName,
					status: "error",
					error: errorMessage
				});
			}

			if (stopOnError) {
				report.processed = i + 1;
				break;
			}
		}

		report.processed = i + 1;
	}

	report.finishedAt = new Date().toISOString();
	report.durationMs = Date.now() - startedAtMs;

	if (_.isFunction(onProgress)) {
		onProgress({
			index: report.processed,
			total: candidates.length,
			status: "complete"
		});
	}

	return report;
}

export async function bulkPrintActivities(activityDocs = [], opts = {}) {
	const {
		onProgress = null,
		stopOnError = false,
		reportType = "aiReport"
	} = opts || {};

	const candidates = (_.isArray(activityDocs) ? activityDocs : []).filter((activity) => {
		return _.isObject(activity) && _.isString(activity.id) && activity.id !== "" && !activity.newDoc;
	});

	const report = {
		startedAt: new Date().toISOString(),
		reportType,
		total: candidates.length,
		processed: 0,
		succeeded: 0,
		failed: 0,
		successes: [],
		failures: []
	};

	const startedAtMs = Date.now();

	for (let i = 0; i < candidates.length; i += 1) {
		const doc = candidates[i];
		const activityId = doc.id;
		const activityName = _.toString(doc.name || activityId);

		if (_.isFunction(onProgress)) {
			onProgress({
				index: i,
				total: candidates.length,
				activityId,
				activityName,
				status: "running"
			});
		}

		try {
			await awsS3.printActivityByType(doc, {
				reportType,
				manageSpinner: false
			});

			report.succeeded += 1;
			report.successes.push({
				activityId,
				activityName
			});

			if (_.isFunction(onProgress)) {
				onProgress({
					index: i + 1,
					total: candidates.length,
					activityId,
					activityName,
					status: "success"
				});
			}
		} catch (err) {
			const errorMessage = _.toString(_.get(err, "message", err) || "Unknown error");
			report.failed += 1;
			report.failures.push({
				activityId,
				activityName,
				error: errorMessage
			});

			if (_.isFunction(onProgress)) {
				onProgress({
					index: i + 1,
					total: candidates.length,
					activityId,
					activityName,
					status: "error",
					error: errorMessage
				});
			}

			if (stopOnError) {
				report.processed = i + 1;
				report.finishedAt = new Date().toISOString();
				report.durationMs = Date.now() - startedAtMs;
				throw err;
			}
		}

		report.processed = i + 1;
	}

	report.finishedAt = new Date().toISOString();
	report.durationMs = Date.now() - startedAtMs;

	if (_.isFunction(onProgress)) {
		onProgress({
			index: report.processed,
			total: candidates.length,
			status: "complete"
		});
	}

	return report;
}

export async function rollbackActivityRevision(activityDoc, sourceVersionId, opts = {}) {
	if (!_.isObject(activityDoc) || !_.isString(activityDoc.id) || activityDoc.id === "") {
		throw new Error("Unable to rollback activity revision because the activity metadata is invalid.");
	}
	if (!_.isString(sourceVersionId) || sourceVersionId === "") {
		throw new Error("Unable to rollback activity revision because no source version was selected.");
	}

	await refreshCredentials(true);
	const {
		runtimeVersionId = null
	} = opts || {};

	try {
		const response = await request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.artifacts.restoreActivityRevision(activityDoc.id)}`)
			.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
			.send(JSON.stringify({
				sourceVersionId,
				runtimeVersionId
			}));

		return response.body;
	} catch (err) {
		const errorMessage = _.toString(_.get(err, "response.body.message") || _.get(err, "response.body.err.message") || _.get(err, "message") || err);
		throw new Error(errorMessage);
	}
}

export async function getActivityRevisionHistory(activityDoc) {
	if (!_.isObject(activityDoc) || !_.isString(activityDoc.id) || activityDoc.id === "") {
		throw new Error("Unable to load activity revision history because the activity metadata is invalid.");
	}

	await refreshCredentials(true);

	try {
		const response = await request.get(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.artifacts.listActivityRevisions(activityDoc.id)}`)
			.set({ Authorization: getJwtToken() });

		return response.body;
	} catch (err) {
		const errorMessage = _.toString(_.get(err, "response.body.message") || _.get(err, "response.body.err.message") || _.get(err, "message") || err);
		throw new Error(errorMessage);
	}
}

export async function compareActivityRevisions(activityDoc, leftSourceVersionId, rightSourceVersionId) {
	if (!_.isObject(activityDoc) || !_.isString(activityDoc.id) || activityDoc.id === "") {
		throw new Error("Unable to compare activity revisions because the activity metadata is invalid.");
	}
	if (!_.isString(leftSourceVersionId) || leftSourceVersionId === "" || !_.isString(rightSourceVersionId) || rightSourceVersionId === "") {
		throw new Error("Unable to compare activity revisions because two source versions must be selected.");
	}

	await refreshCredentials(true);

	try {
		const response = await request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.artifacts.compareActivityRevisions(activityDoc.id)}`)
			.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
			.send(JSON.stringify({
				leftSourceVersionId,
				rightSourceVersionId
			}));

		return response.body;
	} catch (err) {
		const errorMessage = _.toString(_.get(err, "response.body.message") || _.get(err, "response.body.err.message") || _.get(err, "message") || err);
		throw new Error(errorMessage);
	}
}

function buildSimulatedSaveFailureError(checklist = null) {
	const activityName = _.get(checklist, "name", "this activity");
	const error = new Error(`Simulated save failure for dev testing for "${activityName}". A fresh recovery draft was written to local storage. Refresh the page and confirm the restore prompt appears.`);
	error.code = "SimulatedSaveFailure";
	error.simulatedSaveFailure = true;
	return error;
}

export async function normalizeRecoveryDraftRevision(activity) {
	if (!_.isObject(activity)) {
		return activity;
	}

	const normalizedActivity = _.cloneDeep(activity);
	if (!normalizedActivity.id) {
		return normalizedActivity;
	}

	try {
		const currentContent = await getActivityContentForAuthoring(normalizedActivity.id);
		const currentRevision = _.isNumber(currentContent?.revision) ? currentContent.revision : null;
		const localRevision = _.isNumber(normalizedActivity.revision) ? normalizedActivity.revision : null;

		if (_.isNumber(currentRevision) && (!_.isNumber(localRevision) || localRevision > currentRevision)) {
			normalizedActivity.revision = currentRevision;
			if (_.isNumber(currentContent?.revisionTs)) {
				normalizedActivity.revisionTs = currentContent.revisionTs;
			}
		}
	} catch (err) {
		console.warn("Unable to normalize local recovery draft revision", err);
	}

	return normalizedActivity;
}

export async function restoreRecoveryDraft(activity, opts = {}) {
	if (!_.isObject(activity) || !Object.prototype.hasOwnProperty.call(activity, "type")) {
		throw new Error("No valid recovery draft is available to restore.");
	}

	const {
		clearPendingRecovery = false,
		removeArchivedRecovery = false,
		showRestoredNotice = true,
		retainedInRecoveryArchive = false
	} = opts || {};

	try {
		window.restoredFromLs = true;
		await listDriveOnEditActivity();

		const normalizedActivity = await normalizeRecoveryDraftRevision(activity);
		const srcTree = transformToChecklistEntities(normalizedActivity);

		srcTree.root.selected = true;
		srcTree.root.expanded = true;
		resetTree(srcTree.root.children);
		editorActions.resetActivityEditMetaData();
		editorActions.setActivityMetaData("revision", srcTree.root.revision);
		state.set("selectedChecklistId", srcTree.root.id);
		state.set("selectedNodePath", ["tree", "root"]);
		state.set("history", []);
		state.set("historyIndex", -1);
		state.set("tree", srcTree);
		saveUndoState();

		if (clearPendingRecovery) {
			clearLastActivityRecovery();
		}

		if (removeArchivedRecovery) {
			removeArchivedActivityRecovery(srcTree.root.id);
		}

		setSelectedFolderFromDriveRootPath(srcTree.root?.entity?.driveRootPath);

		if (showRestoredNotice) {
			setTimeout(() => {
				if (window.restoredFromLs) {
					const recoveryArchiveNote = retainedInRecoveryArchive
						? "<br/><br/>This recovered draft will remain available under Recover Drafts until you save successfully, discard it manually, or it falls off the recovery queue."
						: "";
					alert("Your activity has been restored.<br/><br/>Important Note: It is not saved yet. You can first review it to make sure it is satisfactory. Auto-save happens at a one-minute interval, so there may be a little data loss." + recoveryArchiveNote);
					delete window.restoredFromLs;
				}
			}, 3000);
		}

		return normalizedActivity;
	} catch (err) {
		if (typeof window !== "undefined" && window.restoredFromLs) {
			delete window.restoredFromLs;
		}
		throw err;
	}
}

export async function saveChecklist(checklist = null, opts = { openEditorAfterSave: true, successMessage: "The activity was successfully saved!" }) {
	state.set(PlayerPaths.RELOAD_ACTIVITIES, true);
	const {
		openEditorAfterSave = true,
		successMessage = "The activity was successfully saved!",
		newDocument = null,
		baseRevision = null,
		lock = openEditorAfterSave,
		simulateFailure = false,
		simulateS3BadDigestFailure = false,
		diagnosticSave = false
	} = opts || {};
	const useDiagnosticSave = diagnosticSave === true || simulateS3BadDigestFailure === true;
	showEditorSpinner(useDiagnosticSave ? "Starting save..." : "");

	return new Promise((resolve, reject) => {
		setTimeout(async () => {
			const providedChecklist = !!checklist;
			const updateSaveStatus = (messageOrStatus) => {
				if (!useDiagnosticSave) {
					return;
				}
				const message = _.isPlainObject(messageOrStatus) ? messageOrStatus.message : messageOrStatus;
				if (_.isString(message) && message.trim() !== "") {
					setEditorSpinnerMessage(message);
				}
			};
			const syncSavedRevisionState = (savedChecklist) => {
				editorActions.setActivityMetaData("revision", savedChecklist.revision);
				if (providedChecklist) {
					return;
				}
				const treeRoot = state.get(["tree", "root"]);
				if (!treeRoot) {
					return;
				}
				state.set(["tree", "root", "revision"], savedChecklist.revision);
				state.set(["tree", "root", "revisionTs"], savedChecklist.revisionTs);
			};
			const persistRecoverySnapshot = () => {
				if (providedChecklist) {
					return;
				}
				try {
					const treeRoot = state.get(["tree", "root"]);
					if (!treeRoot) {
						return;
					}
					const lastActivity = transformFromChecklistEntities(treeRoot);
					if (_.isObject(lastActivity) && lastActivity.hasOwnProperty("type")) {
						preserveLastActivityForRecovery(lastActivity);
					}
				} catch (err) {
					console.warn("Unable to persist latest activity draft for recovery", err);
				}
			};
			const clearRecoveryPending = () => {
				if (!providedChecklist) {
					setLastActivityRecoveryPending(false);
				}
			};
			updateSaveStatus("Checking your session...");
			await refreshCredentials(true);
			try {
				updateSaveStatus("Preparing activity content...");
				console.log("About to save checklist", checklist);
					let _checklist = providedChecklist ? checklist : transformFromChecklistEntities(state.get(["tree", "root"]));
					logItemContainerStats("save_start_activity", _checklist && _checklist.children ? _checklist.children : [], false);
				// if (providedChecklist) {

				const revision = _.isNumber(baseRevision) ? baseRevision : editorActions.getActivityMetaData("revision");
				_checklist.revision = _.isNumber(revision) ? revision + 1 : 1;
				_checklist.revisionTs = Date.now();
				// }

				// First lets figure out if this should be saved?
				let currentContent = null;
				try {
					updateSaveStatus("Checking latest saved revision...");
					currentContent = await getActivityContentForAuthoring(_checklist.id);
				} catch (err) {
					console.warn("Unable to get current content to verify revision integrity, this can be due to the fact that the activity doesn't yet exist in S3", err);
				}

				if (window.refreshFromS3 || currentContent === null || currentContent.revision === (_checklist.revision - 1)) {
					// Ok all good!
					updateSaveStatus("Cleaning activity references...");
					cleanUpExternalResources(_checklist);
					cleanUpRelatedItemReferences(_checklist);
					updateSaveStatus("Publishing activity runtime content...");
					await utils.publishActivity(_checklist);

						// let srcTree = transformUtils.transformToChecklistEntities(checklist, null);
						// state.set("tree", srcTree);

						//Usually we redirect before the save is done, then wait for the save to finish to remove the busy spinner, sometimes we
						//want the save to be done before doing anything else so we resolve a promise for those cases
						updateSaveStatus("Compiling activity for save...");
						const runtimeChecklist = await compileChecklistBankRefsForRuntimeSave(_checklist);
						if (simulateFailure) {
							throw buildSimulatedSaveFailureError(_checklist);
						}
						awsS3.updateChecklistsAndPushToS3(_checklist, newDocument, { message: successMessage, runtimeChecklist, lock, onSaveStatus: useDiagnosticSave ? updateSaveStatus : null, simulateS3BadDigestFailure, diagnosticSave: useDiagnosticSave }).then(() => {
							updateSaveStatus("Save completed.");
							syncSavedRevisionState(_checklist);
							editorActions.markActivitySavedHistoryIndex(state.get("historyIndex"));
							clearRecoveryPending();
							removeArchivedActivityRecovery(_checklist.id);
							delete window.refreshFromS3;
							if (!openEditorAfterSave) {
								hideEditorSpinner();
							}
							resolve();
						}).catch((e) => {
							console.error(e);
							persistRecoverySnapshot();
							reject(e);
						});

					if (providedChecklist && openEditorAfterSave) {
						// Open it for editing
						prepareActivityAndEdit(_checklist, _checklist.id, getIdentityId(), true);
					}
				} else {
					let errorMsg = `("Unable to save changes, the content on S3 is more recent than the in-memory activity, current revision: ${currentContent.revision}, checklist revision: ${_checklist.revision}`;
					console.error(errorMsg);

					hideEditorSpinner();

					showConfirm("Unable to save activity, the content in the editor is out of date, that means you or someone else saved changes elsewhere while you were editing in this window. This can happen if you have multiple windows open and saved in a different one. If you really no what you are doing you can click Ok, but it is highly recommended to click Cancel.", "Save Activity", async () => {
						// Ok all good!
						updateSaveStatus("Cleaning activity references...");
						cleanUpExternalResources(_checklist);
						cleanUpRelatedItemReferences(_checklist);
						logItemContainerStats("save_after_cleanup_activity", _checklist && _checklist.children ? _checklist.children : [], false);
						updateSaveStatus("Publishing activity runtime content...");
						await utils.publishActivity(_checklist);

							// let srcTree = transformUtils.transformToChecklistEntities(checklist, null);
							// state.set("tree", srcTree);

							//Usually we redirect before the save is done, then wait for the save to finish to remove the busy spinner, sometimes we
							//want the save to be done before doing anything else so we resolve a promise for those cases
							updateSaveStatus("Compiling activity for save...");
							const runtimeChecklist = await compileChecklistBankRefsForRuntimeSave(_checklist);
							logItemContainerStats("save_runtime_payload", runtimeChecklist && runtimeChecklist.children ? runtimeChecklist.children : [], false);
							if (simulateFailure) {
								const simulatedFailureError = buildSimulatedSaveFailureError(_checklist);
								persistRecoverySnapshot();
								reject(simulatedFailureError);
								return;
							}
							awsS3.updateChecklistsAndPushToS3(_checklist, newDocument, { message: successMessage, runtimeChecklist, lock, onSaveStatus: useDiagnosticSave ? updateSaveStatus : null, simulateS3BadDigestFailure, diagnosticSave: useDiagnosticSave }).then(() => {
								updateSaveStatus("Save completed.");
								syncSavedRevisionState(_checklist);
								editorActions.markActivitySavedHistoryIndex(state.get("historyIndex"));
								clearRecoveryPending();
								if (!openEditorAfterSave) {
									hideEditorSpinner();
								}
								resolve();
							}).catch((e) => {
								console.error(e);
								persistRecoverySnapshot();
								reject(e);
							});

						if (providedChecklist && openEditorAfterSave) {
							// Open it for editing
							await prepareActivityAndEdit(_checklist, _checklist.id, getIdentityId(), true);
						}
					});

					// showError("Save Activity", "Unable to save activity, the content in the editor is out of date, that means you or someone else saved changes elsewhere while you were editing in this window. This can happen if you have multiple windows open and saved in a different one.", () => {
					// 	hideEditorSpinner();
					// });
					persistRecoverySnapshot();
					reject(new Error(errorMsg));
				}

			} catch (e) {
				console.error(e);
				persistRecoverySnapshot();
				hideEditorSpinner();
				reject(e);
			}
		}, 100);
	});

}

async function resolvePreviewNodeBankRefs(node) {
	if (!_.isObject(node)) {
		return node;
	}

	let resolvedNode = _.cloneDeep(node);
	let resolvedFromBankRef = false;
	const authorProps = getAuthorPropertiesObject(resolvedNode);
	const bankRef = _.get(authorProps, "bankRef");
	if (_.isObject(bankRef) && !_.isEmpty(bankRef)) {
		try {
			const resolved = await resolveBankRefContent(bankRef, {
				ownerOrgId: getOrgId(),
				maxDepth: 12,
				bypassCache: true
			});
			const effectiveDefinition = _.isObject(resolved.effectiveDefinition) ? resolved.effectiveDefinition : {};
			resolvedNode = _.merge({}, resolvedNode, _.cloneDeep(effectiveDefinition));
			const mergedAuthorProps = {
				...getAuthorPropertiesObject(resolvedNode),
				bankRef
			};
			resolvedNode.authorProperties = mergedAuthorProps;
			resolvedFromBankRef = true;
		} catch (err) {
			console.error("Failed to resolve bank ref for preview", err);
		}
	}

	if (resolvedFromBankRef) {
		return resolvedNode;
	}

	const children = _.isArray(resolvedNode.children) ? resolvedNode.children : [];
	if (children.length > 0) {
		const resolvedChildren = [];
		for (let i = 0; i < children.length; i += 1) {
			resolvedChildren.push(await resolvePreviewNodeBankRefs(children[i]));
		}
		resolvedNode.children = resolvedChildren;
	}

	return resolvedNode;
}

async function resolveChecklistBankRefsForPreview(checklist) {
	if (!_.isObject(checklist) || !_.isArray(checklist.children) || checklist.children.length === 0) {
		return checklist;
	}

	const resolvedChecklist = _.cloneDeep(checklist);
	const resolvedChildren = [];
	for (let i = 0; i < resolvedChecklist.children.length; i += 1) {
		resolvedChildren.push(await resolvePreviewNodeBankRefs(resolvedChecklist.children[i]));
	}
	resolvedChecklist.children = resolvedChildren;
	return resolvedChecklist;
}

function inferFallbackNodeType(parentType = "") {
	const normalizedParentType = _.isString(parentType) ? parentType : "";
	if (normalizedParentType === "checklist" || normalizedParentType === "list") {
		return "section";
	}
	if (normalizedParentType === "section" || normalizedParentType.startsWith("item")) {
		return "item";
	}
	return "item";
}

function sanitizeRuntimeNodeShape(node, parentType = "") {
	if (!_.isObject(node)) {
		return null;
	}

	const sanitized = _.cloneDeep(node);
	const nodeType = _.isString(sanitized.type) && sanitized.type.trim() !== ""
		? sanitized.type
		: inferFallbackNodeType(parentType);
	sanitized.type = nodeType;

	const children = _.isArray(sanitized.children) ? sanitized.children : [];
	if (children.length > 0) {
		sanitized.children = children
			.map((child) => sanitizeRuntimeNodeShape(child, nodeType))
			.filter((child) => _.isObject(child));
	}

	return sanitized;
}

function sanitizeChecklistRuntimeShape(checklist) {
	if (!_.isObject(checklist)) {
		return checklist;
	}

	const sanitizedChecklist = _.cloneDeep(checklist);
	const children = _.isArray(sanitizedChecklist.children) ? sanitizedChecklist.children : [];
	sanitizedChecklist.children = children
		.map((child) => sanitizeRuntimeNodeShape(child, "checklist"))
		.filter((child) => _.isObject(child));
	return sanitizedChecklist;
}

function isChecklistItemType(type = "") {
	return _.isString(type) && _.startsWith(type, "item");
}

function getChildIndexPathFromTreePath(treePath = []) {
	if (!Array.isArray(treePath) || treePath.length === 0) {
		return [];
	}

	const result = [];
	for (let i = 0; i < treePath.length; i += 1) {
		if (treePath[i] === "children" && Number.isInteger(treePath[i + 1])) {
			result.push(treePath[i + 1]);
			i += 1;
		}
	}
	return result;
}

function getChecklistNodeByIndexPath(checklist, indexPath = []) {
	if (!_.isObject(checklist)) {
		return null;
	}

	let cursor = checklist;
	for (let i = 0; i < indexPath.length; i += 1) {
		const idx = indexPath[i];
		const children = Array.isArray(cursor && cursor.children) ? cursor.children : [];
		if (!Number.isInteger(idx) || idx < 0 || idx >= children.length) {
			return null;
		}
		cursor = children[idx];
	}

	return _.isObject(cursor) ? cursor : null;
}

function findFirstDescendantItemIndexPath(node, basePath = []) {
	if (!_.isObject(node)) {
		return [];
	}

	const nodeType = _.get(node, "type", "");
	if (isChecklistItemType(nodeType)) {
		return Array.isArray(basePath) ? basePath.slice() : [];
	}

	const children = Array.isArray(node.children) ? node.children : [];
	for (let i = 0; i < children.length; i += 1) {
		const resolvedPath = findFirstDescendantItemIndexPath(children[i], basePath.concat(i));
		if (resolvedPath.length > 0) {
			return resolvedPath;
		}
	}

	return [];
}

function buildPreviewSelectionFromOutline(checklist) {
	if (!_.isObject(checklist)) {
		return null;
	}

	const outlineRoot = state.get(["tree", "root"]);
	const firstLevel = utils.getFirstLevelItemType(outlineRoot);
	let normalizedFirstLevel = "";
	if (_.isString(firstLevel) && firstLevel !== "") {
		normalizedFirstLevel = _.startsWith(firstLevel, "item") ? "item" : firstLevel;
	}
	if (normalizedFirstLevel === "") {
		return null;
	}

	const selectedNodePath = state.get("selectedNodePath");
	const selectedNodePathKey = Array.isArray(selectedNodePath) ? selectedNodePath.join(",") : "";
	const virtualSelection = state.get(["appState", "previewChecklist", "virtualOutlineSelection"]);

	let targetIndexPath = getChildIndexPathFromTreePath(selectedNodePath);
	if (
		virtualSelection &&
		virtualSelection.anchorPath === selectedNodePathKey &&
		Array.isArray(virtualSelection.virtualPath) &&
		virtualSelection.virtualPath.length > 0
	) {
		targetIndexPath = targetIndexPath.concat(
			virtualSelection.virtualPath.filter((idx) => Number.isInteger(idx) && idx >= 0)
		);
	}

	const requiredDepth =
		normalizedFirstLevel === "list"
			? 3
			: normalizedFirstLevel === "section"
				? 2
				: 1;

	let resolvedIndexPath = targetIndexPath.slice();
	if (resolvedIndexPath.length >= requiredDepth) {
		resolvedIndexPath = resolvedIndexPath.slice(0, requiredDepth);
	} else {
		let startNode = getChecklistNodeByIndexPath(checklist, resolvedIndexPath);
		let searchBasePath = resolvedIndexPath.slice();
		if (!startNode) {
			startNode = checklist;
			searchBasePath = [];
		}
		const firstItemPath = findFirstDescendantItemIndexPath(startNode, searchBasePath);
		if (firstItemPath.length < requiredDepth) {
			return null;
		}
		resolvedIndexPath = firstItemPath.slice(0, requiredDepth);
	}

	if (normalizedFirstLevel === "item") {
		return {
			selected: {
				listIndex: 0,
				sectionIndex: 0,
				itemIndex: resolvedIndexPath[0]
			},
			selectedListIndex: 0
		};
	}

	if (normalizedFirstLevel === "section") {
		return {
			selected: {
				listIndex: 0,
				sectionIndex: resolvedIndexPath[0],
				itemIndex: resolvedIndexPath[1]
			},
			selectedListIndex: 0
		};
	}

	return {
		selected: {
			listIndex: resolvedIndexPath[0],
			sectionIndex: resolvedIndexPath[1],
			itemIndex: resolvedIndexPath[2]
		},
		selectedListIndex: resolvedIndexPath[0]
	};
}

function applyPreviewSelectionFromOutline(checklist) {
	if (!_.isObject(checklist)) {
		return checklist;
	}

	const resolvedSelection = buildPreviewSelectionFromOutline(checklist);
	if (!resolvedSelection || !_.isObject(resolvedSelection.selected)) {
		return checklist;
	}

	checklist.selected = {
		...(_.isObject(checklist.selected) ? checklist.selected : {}),
		...resolvedSelection.selected
	};
	checklist.selectedListIndex = resolvedSelection.selectedListIndex;
	return checklist;
}

function clearPreviewSelection(checklist) {
	if (!_.isObject(checklist)) {
		return checklist;
	}

	delete checklist.selected;
	delete checklist.selectedListIndex;
	return checklist;
}

function stripNodeBankRefAuthorProperties(node) {
	if (!_.isObject(node)) {
		return node;
	}

	const authorProps = getAuthorPropertiesObject(node);
	if (_.isObject(authorProps) && Object.prototype.hasOwnProperty.call(authorProps, "bankRef")) {
		const sanitizedAuthorProps = _.omit(authorProps, ["bankRef"]);
		if (_.isEmpty(sanitizedAuthorProps)) {
			delete node.authorProperties;
		} else {
			node.authorProperties = sanitizedAuthorProps;
		}
	}

	const children = _.isArray(node.children) ? node.children : [];
	for (let i = 0; i < children.length; i += 1) {
		stripNodeBankRefAuthorProperties(children[i]);
	}

	return node;
}

async function resolveRuntimeNodeBankRefsForSave(node) {
	if (!_.isObject(node)) {
		return node;
	}

	let resolvedNode = _.cloneDeep(node);
	const sourceAuthorProps = getAuthorPropertiesObject(node);
	const bankRef = _.get(sourceAuthorProps, "bankRef");
	if (_.isObject(bankRef) && !_.isEmpty(bankRef)) {
		const resolved = await resolveBankRefContent(bankRef, {
			ownerOrgId: getOrgId(),
			maxDepth: 12,
			bypassCache: true
		});
		const effectiveDefinition = _.isObject(resolved.effectiveDefinition) ? resolved.effectiveDefinition : {};
		resolvedNode = _.merge({}, resolvedNode, _.cloneDeep(effectiveDefinition));
		const mergedAuthorProps = _.merge(
			{},
			getAuthorPropertiesObject(resolvedNode),
			_.omit(sourceAuthorProps, ["bankRef"])
		);
		if (_.isEmpty(mergedAuthorProps)) {
			delete resolvedNode.authorProperties;
		} else {
			delete mergedAuthorProps.bankRef;
			resolvedNode.authorProperties = mergedAuthorProps;
		}
		return stripNodeBankRefAuthorProperties(resolvedNode);
	}

	const children = _.isArray(resolvedNode.children) ? resolvedNode.children : [];
	if (children.length > 0) {
		const resolvedChildren = [];
		for (let i = 0; i < children.length; i += 1) {
			resolvedChildren.push(await resolveRuntimeNodeBankRefsForSave(children[i]));
		}
		resolvedNode.children = resolvedChildren;
	}

	return resolvedNode;
}

async function compileChecklistBankRefsForRuntimeSave(checklist) {
	if (!_.isObject(checklist)) {
		return checklist;
	}

	const runtimeChecklist = _.cloneDeep(checklist);
	const children = _.isArray(runtimeChecklist.children) ? runtimeChecklist.children : [];
	if (children.length > 0) {
		const runtimeChildren = [];
		for (let i = 0; i < children.length; i += 1) {
			runtimeChildren.push(await resolveRuntimeNodeBankRefsForSave(children[i]));
		}
		runtimeChecklist.children = runtimeChildren;
	}

	const sanitizedRuntimeChecklist = stripNodeBankRefAuthorProperties(sanitizeChecklistRuntimeShape(runtimeChecklist));
	return enrichRuntimeChecklistExternalResources(sanitizedRuntimeChecklist);
}

function normalizePreviewActivityVarsProfile(profile = {}, index = 0) {
	const source = _.isPlainObject(profile) ? profile : {};
	const activityVars = _.isPlainObject(source.activityVars)
		? source.activityVars
		: (_.isPlainObject(source.vars) ? source.vars : {});
	return {
		key: _.toString(source.key || source.id || `profile-${index + 1}`).trim() || `profile-${index + 1}`,
		name: _.toString(source.name || source.label || source.key || `Profile ${index + 1}`).trim(),
		activityVars: _.cloneDeep(activityVars)
	};
}

export function getPreviewActivityVarsState(checklist = {}) {
	const authorProperties = getAuthorPropertiesObject(checklist);
	const config = _.isPlainObject(authorProperties.previewActivityVars) ? authorProperties.previewActivityVars : {};
	let profiles = _.isArray(config.profiles) ? config.profiles : [];

	if (profiles.length === 0 && _.isPlainObject(config.activityVars) && !_.isEmpty(config.activityVars)) {
		profiles = [{
			key: "default",
			name: "Default",
			activityVars: config.activityVars
		}];
	}

	const normalizedProfiles = profiles.map((profile, index) => normalizePreviewActivityVarsProfile(profile, index));
	const requestedDefaultKey = _.toString(config.defaultProfileKey || "").trim();
	const defaultProfile = normalizedProfiles.find(profile => profile.key === requestedDefaultKey) || normalizedProfiles[0];

	return {
		activityVars: _.cloneDeep(_.get(defaultProfile, "activityVars", {})),
		activityVarsProfileKey: _.get(defaultProfile, "key", "")
	};
}

export function applyPreviewActivityVarsToState(checklist = {}) {
	const previewActivityVarsState = getPreviewActivityVarsState(checklist);
	state.set(["appState", "previewChecklist", "activityVars"], previewActivityVarsState.activityVars || {});
	state.set(["appState", "previewChecklist", "activityVarsProfileKey"], previewActivityVarsState.activityVarsProfileKey || "");
}

export async function previewChecklist(options = {}) {
	const startFromTop = options && options.startFromTop === true;
	const requestId = previewBuildRequestId + 1;
	previewBuildRequestId = requestId;
	let checklist = transformFromChecklistEntities(state.get(["tree", "root"]));
	checklist = await resolveChecklistBankRefsForPreview(checklist);
	checklist = sanitizeChecklistRuntimeShape(checklist);
	checklist = applyLegacyItemContainerRuntimeFallback(checklist);
	checklist = sanitizeChecklistForPreview(checklist, "previewModal");
	checklist = startFromTop ? clearPreviewSelection(checklist) : applyPreviewSelectionFromOutline(checklist);
	if (requestId !== previewBuildRequestId) {
		return;
	}
	if (checklist.children.length > 0) {
		const previewChecklistState = state.get(["appState", "previewChecklist"]);
		const session = previewChecklistState && _.isNumber(previewChecklistState.session) ? previewChecklistState.session + 1 : 1;
		state.set(["appState", "previewChecklist", "session"], session);
		state.set(["appState", "previewChecklist", "drive"], buildPreviewDrivePayloadForChecklist(checklist, state.get(["drive"])));
		applyPreviewActivityVarsToState(checklist);
		state.set(["appState", "previewChecklist", "checklist"], checklist);
		state.set(["appState", "previewChecklist", "showModal"], true);
	} else {
		alert("No content in your activity yet! Add a List, Section or Item in the outline to get started.");
	}
}

export function setPreviewActivity(activityId) {
	return new Promise((resolve, reject) => {
		const activityInfo = getActivityById(activityId);
		console.log("Load preview activity", {
			activityId,
			identityId: _.get(activityInfo, "identityId", "")
		});
		awsS3.getActivity(activityId, activityInfo.identityId).then((content) => {
			console.log("Setting preview checklist", {
				id: _.get(content, "id", ""),
				childrenCount: _.isArray(_.get(content, "children")) ? content.children.length : 0,
				externalResourcesCount: _.isArray(_.get(content, "externalResources")) ? content.externalResources.length : 0
			});
			const fallbackChecklist = applyLegacyItemContainerRuntimeFallback(content);
			const previewActivity = sanitizeChecklistForPreview(fallbackChecklist, "previewActivity");
			state.set(["appState", "previewChecklist", "drive"], buildPreviewDrivePayloadForChecklist(previewActivity, state.get(["drive"])));
			applyPreviewActivityVarsToState(previewActivity);
			state.set(["appState", "previewChecklist", "checklist"], previewActivity);
			resolve();
		}).catch(err => {
			reject(err);
		});
	});
}

export async function previewChecklistInline() {
	const requestId = previewBuildRequestId + 1;
	previewBuildRequestId = requestId;
	let checklist = transformFromChecklistEntities(state.get(["tree", "root"]));
	checklist = await resolveChecklistBankRefsForPreview(checklist);
	checklist = sanitizeChecklistRuntimeShape(checklist);
	checklist = applyLegacyItemContainerRuntimeFallback(checklist);
	checklist = sanitizeChecklistForPreview(checklist, "previewInline");
	checklist = applyPreviewSelectionFromOutline(checklist);
	if (requestId !== previewBuildRequestId) {
		return;
	}
	if (checklist.children.length > 0) {
		clearPendingPreviewStateUpdates();
			state.unset(["appState", "stateUpdates"]);

			const previewChecklist = state.get(["appState", "previewChecklist"]);
			let session = 1;
			if (previewChecklist && _.isNumber(previewChecklist.session)) {
				session = previewChecklist.session + 1;
			}
			state.set(["appState", "previewChecklist", "session"], session);
			state.set(["appState", "previewChecklist", "drive"], buildPreviewDrivePayloadForChecklist(checklist, state.get(["drive"])));

			applyPreviewActivityVarsToState(checklist);
			state.set(["appState", "previewChecklist", "showInline"], true);
			state.set(["appState", "previewChecklist", "checklist"], checklist);
		// if (state.get(["appState", "previewChecklist", "showInline"])) {
		// 	state.set(["appState", "previewChecklist", "showInline"], false);
		// } else {
		// 	state.set(["appState", "previewChecklist", "showInline"], true);
		// }
		// setTimeout(state.set(["appState", "previewChecklist", "showInline"], true), 10000);
	} else {
		alert("No content in your activity yet! Add a List, Section or Item in the outline to get started.");
	}
}

export function closeChecklistInline() {
	state.set(["appState", "previewChecklist", "showInline"], false);
	console.log(state.get(["appState", "previewChecklist", "showInline"]));

}

export async function replaceWithCode(identityId, activity) {
	if (activity.shareCodeReceived === "") {
		const shareCodeReceived = prompt("Please enter a share code (e.g. N51212)", "");

		if (shareCodeReceived !== null) {
			try {
				const data = await dynamoDb.getPrivateSharePromise(shareCodeReceived);
				if (!_.isEmpty(data)) {
					const shareCodeObject = data.Item;
					if (shareCodeObject.publisher === "checkmate" && (activity.publisher !== "checkmate" || (activity.publisher === "checkmate" && activity.cloned))) {
						alert("This checklist does not have a CheckMate license. Please purchase a checklist with a CheckMate license from the Home or Search page before replacing.");
					} else {
						activity.shareCodeReceived = shareCodeReceived; // eslint-disable-line

						await dynamoDb.putPrivateShareReplacedPromise({ shareCode: shareCodeReceived, checklistId: activity.id, identityId: identityId, publisher: activity.publisher });

						updateActivity(activity);

						replaceActivity(activity, shareCodeObject.identityId, shareCodeObject.checklistId);
					}
				} else {
					alert("The Share Code " + shareCodeReceived + " was not found.");
				}
			} catch (e) {
				console.error(e);
				alert(e);
			}
		}

	} else {
		try {
			const shareCodeReceived = activity.shareCodeReceived;
			const data = await dynamoDb.getPrivateSharePromise(shareCodeReceived);
			if (!_.isEmpty(data)) {
				const shareCodeObject = data.Item;
				// We now have the identityId and checkistId we need to replace checklist
				replaceActivity(activity, shareCodeObject.identityId, shareCodeObject.checklistId);
			} else {
				alert("The Share Code " + shareCodeReceived + " was not found.");
			}
		} catch (e) {
			console.error(e);
			alert(e);
		}
	}
}

export function toggleForceShowNav() {
	state.set(["appState", "editor", "forceShowNav"], !state.get(["appState", "editor", "forceShowNav"]));
}

// export function receiveDocuments(documents) {
// 	let newDocument = {
// 		"id": utils.generateUUID(),
// 		"newDoc": true,
// 		"name": "",
// 		"description": "",
// 		"genre": "",
// 		"tags": [],
// 		"publisher": "self",
// 		"store": "",
// 		"productPlaneId": "",
// 		"shareCode": "",
// 		"shareCodeReceived": "",
// 		"version": "1.0",
// 		"cloned": false,
// 		"visible": true,
// 		"speedType": "KIAS"
// 	};
// 	documents.unshift(newDocument);
// 	console.log("In receive documents!");
// 	if (!state.get(["appState", "documents", "initialSpinnerShown"])) {
// 		state.set(["appState", "documents", "showSpinner"], true);
// 	}	
// 	window.setTimeout(() => {
// 		injectShares(documents).then(finalDocuments => {
// 			console.log("Setting final documents", finalDocuments);
// 			setActivities(finalDocuments);
// 			state.set(["appState", "documents", "showSpinner"], false);
// 		}).catch(err => {
// 			showError("Receive Activities", "Failed to receive activities.");
// 			console.error(err);
// 		});
// 	}, 100);



// 	// Route to editor
// 	//const path = "/search";
// 	//browserHistory.push(path);	
// }

export function goHome(tree) {
	tree.unset(["appState", "urlParams", "subscriptionPlan"]);
	tree.set(["appState", "navPanel", "selected"], "home");
	// const path = "/home";
	const path = "/checklists"; // For now
	browserHistory.push(path);
}

export function prepareActivityForAuthoringEntities(activity, identityId = null, options = {}) {
	const debugLabel = _.trim(_.get(options, "debugLabel", "")) || "load";
	const debugWindowKey = _.trim(_.get(options, "debugWindowKey", "")) || "__itemContainerLoadDebug";
	const sourceActivity = _.cloneDeep(activity);
	normalizeLegacyInlineEditorResources(sourceActivity);
	const sourceChildren = _.get(sourceActivity, "children", []);
	logItemContainerStats(`${debugLabel}_raw_activity`, sourceChildren, false);
	const srcTree = transformToChecklistEntities(sourceActivity, identityId);
	logItemContainerStats(`${debugLabel}_after_transform_entities`, _.get(srcTree, "root.children", []), true);
	const repairedItemContainerCount = repairMissingItemContainerEntityChildren(
		sourceChildren,
		_.get(srcTree, "root.children", []),
		identityId
	);
	if (repairedItemContainerCount > 0) {
		console.warn(`[itemContainer][${debugLabel}_repair] Hydrated ${repairedItemContainerCount} container(s) with missing transformed children.`);
		logItemContainerStats(`${debugLabel}_after_repair_entities`, _.get(srcTree, "root.children", []), true);
	}
	if (isItemContainerDebugEnabled() && typeof window !== "undefined") {
		window[debugWindowKey] = {
			timestamp: Date.now(),
			label: debugLabel,
			source: collectItemContainerStats(sourceChildren, [], "", false),
			transformed: collectItemContainerStats(_.get(srcTree, "root.children", []), [], "", true),
			repairedItemContainerCount
		};
	}

	return srcTree;
}

export async function prepareActivityAndEdit(srcTree, checklistId, identityId = null, startupModalDontShowAgain = false) {
	// Load the drive if not yet initialized
	await listDriveOnEditActivity();

	srcTree = prepareActivityForAuthoringEntities(srcTree, identityId);

	// Let's have this act on dstTree, not srcTree
	srcTree.root.selected = true;
	srcTree.root.expanded = true;
		resetTree(srcTree.root.children);
		resetEditorSessionState(state, { preserveClipboard: true });
	editorActions.resetActivityEditMetaData();
	editorActions.setActivityMetaData("revision", srcTree.root.revision);
	state.set("selectedChecklistId", srcTree.root.id);
	state.set("selectedNodePath", ["tree", "root"]);
	state.set("history", []);
	state.set("historyIndex", -1);
	//state.set("clipboard",{});
	//state.set("clipboardMode","");
	state.set("tree", srcTree);

	// JJB: DO WE NEED?
	// utils.recursePopulateIdsForEntities(srcTree.root.children, state, null, null);

	saveUndoState();
	editorActions.markActivitySavedHistoryIndex(state.get("historyIndex"));

	// Force reset for testing
	//utils.setLs(state.get(["user", "username"]) + ";startupModalDontShowAgain", false);

	const _startupModalDontShowAgain = startupModalDontShowAgain || utils.getLs(state.get(["user", "username"]) + ";startupModalDontShowAgain");

	state.set(["appState", "startupModal", "showModal"], !_startupModalDontShowAgain);

	setSelectedFolderFromDriveRootPath(srcTree.root?.entity?.driveRootPath);

	// Route to editor
	const path = "/editor/" + checklistId;
	browserHistory.push(path);
}

function normalizeLegacyInlineEditorResources(activity) {
	if (!activity || !_.isPlainObject(activity)) {
		return;
	}

	const normalizeCollection = (collectionProp, inlineProp) => {
		const entries = _.isArray(activity[collectionProp]) ? activity[collectionProp] : [];
		if (_.isEmpty(entries)) {
			return;
		}

		const externalEntries = [];
		const inlineEntries = [];

		entries.forEach((entry) => {
			if (_.isString(entry) || (_.isPlainObject(entry) && entry.type === "resource/ref")) {
				externalEntries.push(entry);
			} else if (_.isPlainObject(entry)) {
				inlineEntries.push(entry);
			}
		});

		if (_.isEmpty(inlineEntries)) {
			return;
		}

		const existingInline = _.isPlainObject(activity[inlineProp]) ? activity[inlineProp] : {};
		activity[inlineProp] = _.merge({}, ...inlineEntries, existingInline);
		activity[collectionProp] = externalEntries;
		console.warn(`[authoring] Normalized ${inlineEntries.length} inline ${collectionProp} entr${inlineEntries.length === 1 ? "y" : "ies"} into ${inlineProp}.`);
	};

	normalizeCollection("themes", "theme");
	normalizeCollection("stylesheets", "stylesheet");
}

export function forceLogin(browserHistory, origin) {
	let normalizedOrigin = _.toString(origin || "").trim();
	if (normalizedOrigin === "/editor") {
		normalizedOrigin = "/checklists";
	}

	if (typeof window !== "undefined" && window.location && normalizedOrigin) {
		const currentPathname = _.toString(window.location.pathname || "");
		const currentSearch = _.toString(window.location.search || "");
		const currentHash = _.toString(window.location.hash || "");
		const hasQueryOrHash = normalizedOrigin.indexOf("?") !== -1 || normalizedOrigin.indexOf("#") !== -1;
		if (!hasQueryOrHash && normalizedOrigin === currentPathname) {
			normalizedOrigin = `${normalizedOrigin}${currentSearch}${currentHash}`;
		}
	}

	state.set(["user", "entryPoint"], normalizedOrigin);
	if (normalizedOrigin) {
		utils.setLs("origin", normalizedOrigin);
	}

	const path = "/login";
	browserHistory.push(path);

}

export function saveUndoState() {
	// Always splice anything to right
	if (state.get("history").length >= 0 && (state.get("historyIndex") < state.get("history").length - 1)) {
		state.get("history").splice([state.get("historyIndex") + 1]);
	}

	state.get("history").push(
		{
			tree: state.get("tree"),
			selectedNodePath: Object.assign([], state.get("selectedNodePath")),
			typeahead: state.get("typeahead")
		}
	);
	state.set("historyIndex", state.get("historyIndex") + 1);

	changePropertyCount = 0;
}

export function resetTree(arr) {
	for (let i = 0; i < arr.length; i++) {
		arr[i].selected = false;
		const entityType = _.get(arr[i], "entity.type", "");
		const hasChildren = Array.isArray(arr[i].children) && arr[i].children.length > 0;
		arr[i].expanded = isItemContainerType(entityType) && hasChildren;
		if (arr[i].hasOwnProperty("children")) {
			resetTree(arr[i].children);
		}
	}
}

export function idExists(tree, id) {
	let typeahead = tree.get("typeahead");
	for (let i = 0; i < typeahead.length; i++) {
		if (typeahead[i].id === id) {
			return true;
		}
	}
}

export function handleChangeItemType(tree, value) {
	// const user = tree.get(["user"]);

	// if (!user.subscriptionPlan.startsWith("pro-plan") && value !== "item") {
	// 	alert("This item type is only supported for Pro plan subscribers. If you want to test the capability, you can turn on Preview Pro in the mobile app to see how these work.");
	// }

	let arrPath = tree.select("selectedNodePath").get();
	let oldItem = tree.select(arrPath).get(["entity"]);

	let newItem = _.cloneDeep(oldItem);

	newItem.type = value;

	let deltaProps;
	// Set default content for each type
	if (value === "itemTextInput" || value === "itemTextInputMultiline") {
		deltaProps =
		{
			textInputPlaceholder: newItem.hasOwnProperty("textInputPlaceholder") ? newItem.textInputPlaceholder : "",
			textInputDefaultValue: newItem.hasOwnProperty("textInputDefaultValue") ? newItem.textInputDefaultValue : "",
			textInputMaxLength: newItem.hasOwnProperty("textInputMaxLength") ? newItem.textInputMaxLength : 1000,
			textInputKeyboardType: newItem.hasOwnProperty("textInputKeyboardType") ? newItem.textInputKeyboardType : "default",
			textInputKeyboardAutoCapitalize: newItem.hasOwnProperty("textInputKeyboardAutoCapitalize") ? newItem.textInputKeyboardAutoCapitalize : "sentences",
			textInputKeyboardAutoCorrect: newItem.hasOwnProperty("textInputKeyboardAutoCorrect") ? newItem.textInputKeyboardAutoCorrect : true,
			textInputKeyboardReturnKeyType: newItem.hasOwnProperty("textInputKeyboardReturnKeyType") ? newItem.textInputKeyboardReturnKeyType : "default",
			textInputKeyboardReturnKeySubmitsItem: newItem.hasOwnProperty("textInputKeyboardReturnKeySubmitsItem") ? newItem.textInputKeyboardReturnKeySubmitsItem : true,
			textInputMaskType: newItem.hasOwnProperty("textInputMaskType") ? newItem.textInputMaskType : "",
			textInputCustomMask: newItem.hasOwnProperty("textInputCustomMask") ? newItem.textInputCustomMask : "",
			textInputCustomMas2: newItem.hasOwnProperty("textInputCustomMask2") ? newItem.textInputCustomMask2 : "",
			textInputCurrencySymbol: newItem.hasOwnProperty("textInputCurrencySymbol") ? newItem.textInputCurrencySymbol : "$",
			textInputCurrencySeparator: newItem.hasOwnProperty("textInputCurrencySeparator") ? newItem.textInputCurrrencySeparator : ",",
			textInputNumberOfLines: newItem.hasOwnProperty("textInputNumberOfLines") ? newItem.textInputNumberOfLines : 4,
			inputType: newItem.hasOwnProperty("inputType") ? newItem.inputType : "",
			inputMin: newItem.hasOwnProperty("inputMin") ? newItem.inputMin : "",
			inputMax: newItem.hasOwnProperty("inputMax") ? newItem.inputMax : "",
			inputStep: newItem.hasOwnProperty("inputStep") ? newItem.inputStep : "",
			inputPrecision: newItem.hasOwnProperty("inputPrecision") ? newItem.inputPrecision : ""
		};
	} else if (value === "itemDate" || value === "itemTime" || value === "itemDateTime") {
		deltaProps = {
			dateTimeType: newItem.hasOwnProperty("dateTimeType") ? newItem.dateTimeType : "local",
			dateTimeInitialDate: newItem.hasOwnProperty("dateTimeInitialDate") ? newItem.dateTimeInitialDate : "today",
			dateTimeMinuteInterval: newItem.hasOwnProperty("dateTimeMinuteInterval") ? newItem.dateTimeMinuteInterval : 1,
			dateTimeAdvanceOnSelect: newItem.hasOwnProperty("dateTimeAdvanceOnSelect") ? newItem.dateTimeAdvanceOnSelect : false,
			dateTimePickerInline: newItem.hasOwnProperty("dateTimePickerInline") ? newItem.dateTimePickerInline : false,
		};
	} else if (value === "itemYesNo") {
		deltaProps = {
			yesNoLinkOnSelect: newItem.hasOwnProperty("yesNoLinkOnSelect") ? newItem.yesNoLinkOnSelect : false,
			yesNoLinkActionType: newItem.hasOwnProperty("yesNoLinkActionType") ? newItem.yesNoLinkActionType : "goto",
			yesLinkActionType: newItem.hasOwnProperty("yesLinkActionType") ? newItem.yesLinkActionType : "inherit",
			noLinkActionType: newItem.hasOwnProperty("noLinkActionType") ? newItem.noLinkActionType : "inherit",
			naLinkActionType: newItem.hasOwnProperty("naLinkActionType") ? newItem.naLinkActionType : "inherit",
			yesNoYesLinkId: newItem.hasOwnProperty("yesNoYesLinkId") ? newItem.yesNoYesLinkId : "",
			yesNoNoLinkId: newItem.hasOwnProperty("yesNoNoLinkId") ? newItem.yesNoNoLinkId : "",
			yesNoNaLinkId: newItem.hasOwnProperty("yesNoNaLinkId") ? newItem.yesNoNaLinkId : "",
			yesNoShowNa: newItem.hasOwnProperty("yesNoShowNa") ? newItem.yesNoShowNa : false,
			yesNoAdvanceOnSelect: newItem.hasOwnProperty("yesNoAdvanceOnSelect") ? newItem.yesNoAdvanceOnSelect : true,
		};
	} else if (value === "itemPicker") {
		deltaProps = {
			pickerItemViewType: newItem.hasOwnProperty("pickerItemViewType") ? newItem.pickerItemViewType : "picker",
			pickerVisualStyle: newItem.hasOwnProperty("pickerVisualStyle") ? newItem.pickerVisualStyle : "auto",
			pickerVisualColumns: newItem.hasOwnProperty("pickerVisualColumns") ? newItem.pickerVisualColumns : "auto",
			pickerVisualItemMaxWidth: newItem.hasOwnProperty("pickerVisualItemMaxWidth") ? newItem.pickerVisualItemMaxWidth : "",
			pickerVisualItemMaxWidthWeb: newItem.hasOwnProperty("pickerVisualItemMaxWidthWeb") ? newItem.pickerVisualItemMaxWidthWeb : "",
			pickerVisualItemMaxWidthMobile: newItem.hasOwnProperty("pickerVisualItemMaxWidthMobile") ? newItem.pickerVisualItemMaxWidthMobile : "",
			pickerVisualImageKey: newItem.hasOwnProperty("pickerVisualImageKey") ? newItem.pickerVisualImageKey : "",
			pickerVisualColorKey: newItem.hasOwnProperty("pickerVisualColorKey") ? newItem.pickerVisualColorKey : "",
			pickerItemDataFields: newItem.hasOwnProperty("pickerItemDataFields") ? newItem.pickerItemDataFields : [],
			pickerItemDataFieldAutoValueFormat: newItem.hasOwnProperty("pickerItemDataFieldAutoValueFormat") ? newItem.pickerItemDataFieldAutoValueFormat : "dashed",
			pickerItemsManualConfig: newItem.hasOwnProperty("pickerItemsManualConfig") ? newItem.pickerItemsManualConfig : {
				allKeys: [],
				commonKeys: [],
				valueKeys: [],
				labelKeys: [],
				labelTemplate: "",
				authorRuleLabelTemplate: "",
				selectionMemoryMode: "valueOnly",
				selectionMemoryFieldKeys: [],
				dependency: null
			},
			pickerItemPlaceholder: newItem.hasOwnProperty("pickerItemPlaceholder") ? newItem.pickerItemPlaceholder : "",
			pickerItemDefaultValue: newItem.hasOwnProperty("pickerItemDefaultValue") ? newItem.pickerItemDefaultValue : "",
			pickerItems: newItem.hasOwnProperty("pickerItems") ? newItem.pickerItems : [],
			pickerAdvanceOnSelect: newItem.hasOwnProperty("pickerAdvanceOnSelect") ? newItem.pickerAdvanceOnSelect : false,
			pickerLinkOnSelect: newItem.hasOwnProperty("pickerLinkOnSelect") ? newItem.pickerLinkOnSelect : false,
			pickerLinkActionType: newItem.hasOwnProperty("pickerLinkActionType") ? newItem.pickerLinkActionType : "goto"
		};
	} else if (value === "itemRanking") {
		deltaProps = {
			config: newItem.hasOwnProperty("config") ? newItem.config : "",
			items: newItem.hasOwnProperty("items") ? newItem.items : [],
		};
	} else if (value === "itemChoiceSingle") {
		deltaProps = {
			choiceItems: newItem.hasOwnProperty("choiceItems") ? newItem.choiceItems : [],
			choiceItemsManualConfig: newItem.hasOwnProperty("choiceItemsManualConfig") ? newItem.choiceItemsManualConfig : {
				allKeys: [],
				commonKeys: [],
				selectionMemoryMode: "valueOnly",
				selectionMemoryFieldKeys: []
			},
			choiceItemDataFields: newItem.hasOwnProperty("choiceItemDataFields") ? newItem.choiceItemDataFields : [],
			choiceItemDataFieldAutoValueFormat: newItem.hasOwnProperty("choiceItemDataFieldAutoValueFormat") ? newItem.choiceItemDataFieldAutoValueFormat : "dashed",
			choiceAdvanceOnSelect: newItem.hasOwnProperty("choiceAdvanceOnSelect") ? newItem.choiceAdvanceOnSelect : false,
			choiceLinkOnSelect: newItem.hasOwnProperty("choiceLinkOnSelect") ? newItem.choiceLinkOnSelect : false,
			choiceLinkActionType: newItem.hasOwnProperty("choiceLinkActionType") ? newItem.choiceLinkActionType : "goto"
		};
	} else if (value === "itemChoiceMulti") {
		deltaProps = {
			choiceItems: newItem.hasOwnProperty("choiceItems") ? newItem.choiceItems : [],
			choiceItemsManualConfig: newItem.hasOwnProperty("choiceItemsManualConfig") ? newItem.choiceItemsManualConfig : {
				allKeys: [],
				commonKeys: [],
				selectionMemoryMode: "valueOnly",
				selectionMemoryFieldKeys: []
			},
			choiceItemDataFields: newItem.hasOwnProperty("choiceItemDataFields") ? newItem.choiceItemDataFields : [],
			choiceItemDataFieldAutoValueFormat: newItem.hasOwnProperty("choiceItemDataFieldAutoValueFormat") ? newItem.choiceItemDataFieldAutoValueFormat : "dashed"
		};
	} else if (value === "itemBarcodeScanner") {
		deltaProps = {
			barcodeTypes: newItem.hasOwnProperty("barcodeTypes") ? newItem.barcodeTypes : [],
			barcodeManualEntryMultiline: newItem.hasOwnProperty("barcodeManualEntryMultiline") ? newItem.barcodeManualEntryMultiline : false,
			barcodeAllowEditScannedValue: newItem.hasOwnProperty("barcodeAllowEditScannedValue") ? newItem.barcodeAllowEditScannedValue : false,
			barcodeNormalizeTrim: newItem.hasOwnProperty("barcodeNormalizeTrim") ? newItem.barcodeNormalizeTrim : true,
			barcodeNormalizeStripLineBreaks: newItem.hasOwnProperty("barcodeNormalizeStripLineBreaks") ? newItem.barcodeNormalizeStripLineBreaks : true,
			barcodeNormalizeCase: newItem.hasOwnProperty("barcodeNormalizeCase") ? newItem.barcodeNormalizeCase : "none",
			barcodeNormalizeUpcAFromEan13: newItem.hasOwnProperty("barcodeNormalizeUpcAFromEan13") ? newItem.barcodeNormalizeUpcAFromEan13 : true,
			barcodeExpectedValue: newItem.hasOwnProperty("barcodeExpectedValue") ? newItem.barcodeExpectedValue : "",
			barcodeExpectedMatchMode: newItem.hasOwnProperty("barcodeExpectedMatchMode") ? newItem.barcodeExpectedMatchMode : "exact",
			barcodeValidationPattern: newItem.hasOwnProperty("barcodeValidationPattern") ? newItem.barcodeValidationPattern : "",
			barcodeValidationMessage: newItem.hasOwnProperty("barcodeValidationMessage") ? newItem.barcodeValidationMessage : "",
			textInputKeyboardType: newItem.hasOwnProperty("textInputKeyboardType") ? newItem.textInputKeyboardType : "numbers-and-punctuation",
			textInputKeyboardAutoCapitalize: newItem.hasOwnProperty("textInputKeyboardAutoCapitalize") ? newItem.textInputKeyboardAutoCapitalize : "none",
			textInputKeyboardReturnKeyType: newItem.hasOwnProperty("textInputKeyboardReturnKeyType") ? newItem.textInputKeyboardReturnKeyType : "done",
			textInputKeyboardReturnKeySubmitsItem: newItem.hasOwnProperty("textInputKeyboardReturnKeySubmitsItem") ? newItem.textInputKeyboardReturnKeySubmitsItem : false
		};
	} else if (value === "itemAddress") {
		deltaProps = {
			addressDefaultValue: newItem.hasOwnProperty("addressDefaultValue") ? newItem.addressDefaultValue : null
		};
	} else if (value === "itemImagePicker") {
		deltaProps = {
			imagePickerMediaType: newItem.hasOwnProperty("imagePickerMediaType") ? newItem.imagePickerMediaType : "photo",
			imagePickerAddMediaButton: newItem.hasOwnProperty("imagePickerAddMediaButton") ? newItem.imagePickerAddMediaButton : "Add Photo",
			imagePickerUploadTitle: newItem.hasOwnProperty("imagePickerUploadTitle") ? newItem.imagePickerUploadTitle : "Upload",
			imagePickerCaptureMediaTitle: newItem.hasOwnProperty("imagePickerCaptureMediaTitle") ? newItem.imagePickerCaptureMediaTitle : "Take Photo..."
		};
	} else if (value === "itemSketchPad") {
		deltaProps = {
			sketchPadBackgroundColor: newItem.hasOwnProperty("sketchPadBackgroundColor") ? newItem.sketchPadBackgroundColor : "",
			sketchPadPenColor: newItem.hasOwnProperty("sketchPadPenColor") ? newItem.sketchPadPenColor : "",
			sketchPadPenWidth: newItem.hasOwnProperty("sketchPadPenWidth") ? newItem.sketchPadPenWidth : 5,
			sketchPadHeight: newItem.hasOwnProperty("sketchPadHeight") ? newItem.sketchPadHeight : 190
		};
	}

	let newItemMerged = _.merge({}, newItem, deltaProps);

	tree.select(arrPath).set(["entity"], newItemMerged);

	// Future use for blocks of undo
	changePropertyCount++;

	saveUndoState();
}

export function handleAddPickerItem(tree, prop, label, value, image, properties, data = null) {
	try {
		if (properties && properties !== "") {
			JSON.parse(properties);
		}

		console.log("****** ADD: " + JSON.stringify(image));

		let arrPath = tree.select("selectedNodePath").get();
		const newItem = { label: label, value: value, image: image, properties: properties };
		if (_.isPlainObject(data) && !_.isEmpty(data)) {
			newItem.data = data;
		}
		tree.select(arrPath).push(prop, newItem);

		// Future use for blocks of undo
		changePropertyCount++;

		saveUndoState();
	} catch (e) {
		alert("The properties must be valid JSON.");
	}

}

export function updatePickerItem(idx, prop, label, value, image, properties, data = null) {
	try {
		if (properties && properties !== "") {
			JSON.parse(properties);
		}

		let arrPath = state.select("selectedNodePath").get();
		const currentItem = state.select(_.concat(arrPath, prop, idx)).get() || {};
		const updatedItem = _.assign({}, currentItem, { label: label, value: value, image: image, properties: properties });
		if (_.isPlainObject(data) && !_.isEmpty(data)) {
			updatedItem.data = data;
		} else if (updatedItem.hasOwnProperty("data")) {
			delete updatedItem.data;
		}
		state.select(_.concat(arrPath, prop)).splice([idx, 1, updatedItem]);

		// Future use for blocks of undo
		changePropertyCount++;

		saveUndoState();
	} catch (e) {
		alert("The properties must be valid JSON.");
	}

}

export function handleDeletePickerItem(tree, prop, index) {
	let arrPath = tree.select("selectedNodePath").get();
	tree.select(arrPath).splice(prop, [index, 1]);

	// Future use for blocks of undo
	changePropertyCount++;

	saveUndoState();
}

export function handleMovePickerItemUp(tree, prop, index) {
	let arrPath = tree.select("selectedNodePath").get();

	let moveItem = tree.select(arrPath).get(prop)[index];

	tree.select(arrPath).splice(prop, [index, 1]);
	tree.select(arrPath).splice(prop, [index - 1, 0, moveItem]);

	// Future use for blocks of undo
	changePropertyCount++;

	saveUndoState();
}

export function handleMovePickerItemDown(tree, prop, index) {
	let arrPath = tree.select("selectedNodePath").get();

	let moveItem = tree.select(arrPath).get(prop)[index];

	tree.select(arrPath).splice(prop, [index, 1]);
	tree.select(arrPath).splice(prop, [index + 1, 0, moveItem]);

	// Future use for blocks of undo
	changePropertyCount++;

	saveUndoState();
}

export function findNodePath(nodeId, context = ["tree", "root"], tree = state) {
	const currentNode = tree.get(context);
	if (!currentNode) {
		return;
	}
	if (currentNode.id === nodeId) {
		return context;
	} else {
		if (currentNode.children) {
			for (let i = 0; i < currentNode.children.length; i++) {
				const _context = Object.assign([], context);
				_context.push("children", i);
				const result = findNodePath(nodeId, _context, tree);
				if (result) {
					return result;
				}
			}
		}
	}
}

let expectedAnchorTarget = null;
let anchorRequestId = 0;
const PROPERTY_PANEL_EDITOR_SELECTOR = ".ambifi-property-panel-editor";
const PROPERTY_PANEL_CONTROLS_SELECTOR = "[data-property-panel-controls=\"true\"]";
const PROPERTY_PANEL_ANCHOR_SCROLL_PADDING = 12;

function setExpectedAnchorTarget(anchor) {
	expectedAnchorTarget = anchor;
	anchorRequestId += 1;
	state.set(["edit", "anchor"], anchor);
	state.set(["edit", "anchorRequestId"], anchorRequestId);
}

export function handleAnchor(anchorTarget) {
	if (anchorTarget && anchorTarget === expectedAnchorTarget) {
		scrollToExpectedAnchor(anchorTarget);
	}
}

function getAnchorElement(anchorTarget) {
	if (!anchorTarget || !window.document) {
		return null;
	}

	const exactMatch = window.document.getElementById(anchorTarget);
	if (exactMatch) {
		return exactMatch;
	}

	const normalizedTarget = normalizePanelKey(anchorTarget);
	if (!normalizedTarget) {
		return null;
	}

	const root = window.document.querySelector(PROPERTY_PANEL_EDITOR_SELECTOR);
	const propertyLabelPrefix = "property-label-";
	if (normalizedTarget.indexOf(propertyLabelPrefix) === 0) {
		const propertyLabelKey = normalizedTarget.slice(propertyLabelPrefix.length);
		const propertyRoot = root || window.document;
		const propertyMatch = propertyRoot.querySelector(`[data-property-panel-label-key="${propertyLabelKey}"]`);
		if (propertyMatch) {
			return propertyMatch;
		}
	}

	const candidates = root && root.querySelectorAll
		? root.querySelectorAll("[id]")
		: window.document.querySelectorAll("[id]");
	return Array.from(candidates).find((node) => {
		const normalizedId = normalizePanelKey(node.getAttribute("id"));
		return normalizedId === normalizedTarget || normalizedId.endsWith(`-${normalizedTarget}`);
	}) || null;
}

function getScrollableAnchorContainer(el) {
	let node = el ? el.parentElement : null;
	while (node && node !== document.body && node !== document.documentElement) {
		const style = window.getComputedStyle ? window.getComputedStyle(node) : null;
		const overflowY = style ? style.overflowY : "";
		if ((overflowY === "auto" || overflowY === "scroll") && node.scrollHeight > node.clientHeight) {
			return node;
		}
		node = node.parentElement;
	}
	return window;
}

function getPropertyPanelAnchorOffset(el, scrollContainer) {
	if (!el || !el.closest || !el.getBoundingClientRect) {
		return 0;
	}
	const propertyEditor = el.closest(PROPERTY_PANEL_EDITOR_SELECTOR);
	const controls = propertyEditor && propertyEditor.querySelector
		? propertyEditor.querySelector(PROPERTY_PANEL_CONTROLS_SELECTOR)
		: null;
	if (!controls || !controls.getBoundingClientRect) {
		return 0;
	}
	const controlsRect = controls.getBoundingClientRect();
	const containerTop = scrollContainer === window
		? 0
		: scrollContainer.getBoundingClientRect().top;
	return Math.max(0, controlsRect.bottom - containerTop) + PROPERTY_PANEL_ANCHOR_SCROLL_PADDING;
}

function scrollAnchorIntoView(el) {
	const scrollContainer = getScrollableAnchorContainer(el);
	const offset = getPropertyPanelAnchorOffset(el, scrollContainer);

	if (!offset) {
		el.scrollIntoView();
		return;
	}

	const targetRect = el.getBoundingClientRect();
	if (scrollContainer === window) {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		window.scrollTo(0, Math.max(0, targetRect.top + scrollTop - offset));
		return;
	}

	const containerRect = scrollContainer.getBoundingClientRect();
	const nextScrollTop = targetRect.top - containerRect.top + scrollContainer.scrollTop - offset;
	if (scrollContainer.scrollTo) {
		scrollContainer.scrollTo(0, Math.max(0, nextScrollTop));
	} else {
		scrollContainer.scrollTop = Math.max(0, nextScrollTop);
	}
}

function scrollToExpectedAnchor(anchorTarget, attempt = 0) {
	window.setTimeout(() => {
		if (!anchorTarget || anchorTarget !== expectedAnchorTarget) {
			return;
		}
		const el = getAnchorElement(anchorTarget);
		if (el) {
			scrollAnchorIntoView(el);
			// state.unset(["edit", "anchor"]); Will have to think about this, using this information to keep the panel open
			expectedAnchorTarget = null;
			return;
		}
		if (attempt < 8) {
			scrollToExpectedAnchor(anchorTarget, attempt + 1);
			return;
		}
		expectedAnchorTarget = null;
	}, attempt === 0 ? 300 : 150);
}

export function setImageHotspots(imageHotspots) {
	// Author Properties are a string so need to deal with that
	let arrPath = getSelectedNodePath();
	const propPath = _.concat(arrPath, "entity");

	let authorProperties = {};

	const entity = state.get(propPath);

	if (entity.authorProperties) {
		try {
			authorProperties = JSON.parse(entity.authorProperties);
		} catch (err) {
			authorProperties = {};
		}
	}

	authorProperties.imageHotspots = imageHotspots;

	state.set(_.concat(propPath, "authorProperties"), JSON.stringify(authorProperties, null, 2));
}

export function setImageKenBurnsEffect(cameras) {
	// Author Properties are a string so need to deal with that
	let arrPath = getSelectedNodePath();
	const propPath = _.concat(arrPath, "entity");

	let authorProperties = {};

	const entity = state.get(propPath);

	if (entity.authorProperties) {
		try {
			authorProperties = JSON.parse(entity.authorProperties);
		} catch (err) {
			authorProperties = {};
		}
	}

	authorProperties.imageKenBurnsEffect = cameras;

	state.set(_.concat(propPath, "authorProperties"), JSON.stringify(authorProperties, null, 2));
}

export function setImageKenBurnsEffectVariants(variants) {
	let arrPath = getSelectedNodePath();
	const propPath = _.concat(arrPath, "entity");

	let authorProperties = {};

	const entity = state.get(propPath);

	if (entity.authorProperties) {
		try {
			authorProperties = JSON.parse(entity.authorProperties);
		} catch (err) {
			authorProperties = {};
		}
	}

	if (_.isPlainObject(variants) && !_.isEmpty(variants)) {
		authorProperties.imageKenBurnsEffectVariants = variants;
	} else {
		delete authorProperties.imageKenBurnsEffectVariants;
	}

	state.set(_.concat(propPath, "authorProperties"), JSON.stringify(authorProperties, null, 2));
}

export function setProp(path, key, value, expectedId = null) {
	let _path = Object.assign([], path);
	let doSetProp = true;
	if (expectedId) {
		const existingObj = state.get(path);
		if (existingObj.id !== expectedId) {
			_path = findNodePath(expectedId);
			doSetProp = !!_path;
		}
	}
	if (doSetProp) {
		state.set(_.concat(_path, key), value);
	}
}
export function setNodeStateProp(node, key, value) {
	state.set(["appState", node.id, key], value);
}
export function getNodeStateProp(node, key, value) {
	return state.get(["appState", node.id, key], value);
}
export function getNodeState(node) {
	let result = {};
	if (node && node.id) {
		const appStateNodePath = ["appState", "nodes", node.id];
		const appStateNodeCursor = state.select(appStateNodePath);
		if (!appStateNodeCursor.exists()) {
			state.set(appStateNodePath, {});
		} else {
			result = appStateNodeCursor.get();
		}
	}
	return result;
}
export function getSelectedNodePath() {
	const result = Object.assign([], state.get("selectedNodePath"));
	return result;
}

function slugifyId(text = "") {
	return text.toString().trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, "-")
		.replace(/^-+|-+$/g, "")
		.replace(/-+/g, "-");
}

function applyIdTemplate(template, context) {
	if (!template || typeof template !== "string") { return ""; }
	return template.replace(/\$\{([^}]+)\}/g, (_match, key) => {
		const value = context[key];
		return _.isNil(value) ? "" : value;
	});
}

export function handleToggleBetweenLogicEditors(tree) {
	let arrPath = getSelectedNodePath();
	const propPath = _.concat(arrPath, "entity", "conditionalVisible");
	if (tree.exists(propPath) && _.isObject(tree.get(propPath))) {
		const currentMode = tree.get(_.concat(arrPath, "entity", "conditionalVisible", "ifThis", "mode"));

		if (currentMode === "basic") {
			tree.set(_.concat(arrPath, "entity", "conditionalVisible", "ifThis", "mode"), "advanced");
		} else {
			tree.set(_.concat(arrPath, "entity", "conditionalVisible", "ifThis", "mode"), "basic");
		}

		tree.commit();

		saveUndoState();
	}
}

export function handleToggleLogicEditor(tree, prop) {
	let arrPath = getSelectedNodePath();
	const propPath = _.concat(arrPath, "entity", prop);
	if (tree.exists(propPath) && _.isObject(tree.get(propPath))) {
		// Reset it
		tree.unset(_.concat(arrPath, "entity", prop));
	} else {
		const calcId = generateUUID();
		const ifThis = {
			id: calcId,
			mode: "basic",
			type: "calculation",
			definition: getBlankVisibleIf(true)
		};
		const thenThat = {
			id: generateUUID(),
			type: "rule",
			sourceId: calcId,
			actions: [
				{
					"type": "valueAssignment",
					"source": "result",
					"target": [
						"currentChecklist", "overrides", "${self.id}", "visible" // eslint-disable-line
					]
				}
			]
		};

		tree.set(_.concat(arrPath, "entity", prop), {
			id: generateUUID(),
			type: "ifttt",
			ifThis,
			thenThat
		});
	}
}

export function handleToggleCalcEditor(tree, prop) {
	let arrPath = getSelectedNodePath();
	const propPath = _.concat(arrPath, "entity", prop);
	if (tree.exists(propPath) && _.isObject(tree.get(propPath))) {
		// Reset it
		tree.unset(_.concat(arrPath, "entity", prop));
	} else {
		const calcId = generateUUID();
		const ifThis = {
			id: calcId,
			type: "calculation",
			definition: getBlankArithemticOperator()
		};
		const thenThat = {
			id: generateUUID(),
			type: "rule",
			sourceId: calcId,
			actions: [
				{
					"type": "valueAssignment",
					"source": "result",
					"target": [
						"currentChecklist", "overrides", "${self.id}", "value" // eslint-disable-line
					]
				}
			]
		};

		tree.set(_.concat(arrPath, "entity", prop), {
			id: generateUUID(),
			type: "ifttt",
			ifThis,
			thenThat
		});
	}
}


export function getProperty(tree, property, value, nodePath = null, expectedId = null) {
	let arrPath = nodePath ? nodePath : getSelectedNodePath();
	const existingObject = tree.select(arrPath);
	if (expectedId && existingObject.id !== expectedId) {
		// Find new path
		arrPath = findNodePath(expectedId);
	}
	return tree.get(_.concat(arrPath, ["entity", property]));
}

export function handleScanForVariables(tree = state, property, nodeOrPath = null) {
	let existingObject = null;
	if (_.isPlainObject(nodeOrPath)) {
		existingObject = { entity: nodeOrPath };
	} else if (nodeOrPath === null || _.isArray(nodeOrPath)) {
		let arrPath = nodeOrPath ? nodeOrPath : getSelectedNodePath();
		existingObject = tree.get(arrPath);
	}

	if (existingObject) {
		const value = existingObject.entity[property];
		const guid = existingObject.entity.guid;
		let guidVariables = {};
		const inlineVariablePath = ["editActivityMetaData", "inlineVariables", guid, property];
		// Declarations will track where a variable has been declared, this will allow us to highlight any
		// issues that relate to variables being declared multiple times.
		// const inlineVariableDeclarationsPath = ["editActivityMetaData", "inlineVariableDeclarations"];
		const inlineVariablesMapMonkeyPath = ["editActivityMetaData", "inlineVariablesMap"];
		const inlineVariablesMap = tree.get(inlineVariablesMapMonkeyPath);
		const variables = tree.get(["tree", "variables"]);
		const variablesMap = {};
		variables.forEach(_var => {
			variablesMap[_var.id] = true;
		});
		// When declaring a variable track this info, this way we can make sure BEFORE adding
		// variables that we don't have a naming conflict, if declared in a different location
		const declarationInfo = {
			guid,
			property,
			content: value // Capture this so we can show it in visible if
		};
		if (_.isString(value) && value.indexOf("${") !== -1 && value.indexOf("}") !== -1) {
			// Candidate!
			const matches = [...value.matchAll(/\$\{.*?globalVar\.(.+?)=/g)];

			let duplicatesDetected = {};

			for (const _match of matches) {
				const _var = _match[1];

				const existingVar = inlineVariablesMap ? inlineVariablesMap[_var] : null;
				if ((existingVar && (existingVar.guid !== guid || existingVar.property !== property)) || (variablesMap && variablesMap[_var])) {
					// Track which variables are actual dupes, we will use this later on to reconsile markers
					duplicatesDetected[_var] = true;
					// Adding the marker for a dupe also adds a key `dup-var-${_var}` - this is to ensure that only one marker is ever added for this issue and it doesn't
					// keep adding them
					// The metaData attached we will use later on to filter out dupes that are no longer dupes.

					let additionalInfo = "";
					if (existingVar) {
						additionalInfo = `In text: "${existingVar.content}"`;
					} else {
						additionalInfo = "By assigning ID to an item.";
					}

					editorActions.addEntityMarker(guid, editorActions.createErrorMarker(`A variable with name ${_var} has already been declared elsewhere. ${additionalInfo}`, `dup-var-${_var}`, {
						type: "duplicate-variable",
						variable: _var
					}), property);
					// Skip the rest
					continue;
				}
				guidVariables[_var] = _.assign({}, declarationInfo, { id: _var });
			}

			// In this step, since we could've made changes elsewhere that would warrant markers from being removed we have to check
			// and make sure that all markers are still valid. For example there might be a marker that claims that variable "a" is a duplicate
			// however that may have changed and "a" is now available for assignment.
			editorActions.removeEntityMarkers(guid, property, (marker) => {
				let res = true; // Return unless we prove this to be something that should be removed
				const { metaData } = marker;
				if (metaData && metaData.type && metaData.type === "duplicate-variable" && !duplicatesDetected[metaData.variable]) {
					res = false;
				}
				return res;
			});

			tree.set(inlineVariablePath, guidVariables);
		} else if (tree.exists(inlineVariablePath)) {
			// No longer any variables so remove them
			tree.unset(inlineVariablePath);
		}
		const currentInlineVariables = state.get(["editActivityMetaData", "inlineVariables"]);
		if (_.isEmpty(currentInlineVariables)) {
			// No more inline variables ...
			tree.unset(inlineVariablesMapMonkeyPath); // PERFORMANCE, remove unnecessary monkey ... no variables!
		} else {
			tree.set(inlineVariablesMapMonkeyPath, monkey({
				cursors: {
					inlineVariables: ["editActivityMetaData", "inlineVariables"]
				},
				get: ({ inlineVariables }) => {
					if (inlineVariables) {
						const res = {};
						_.keys(inlineVariables).forEach(guid => {

							const entity = inlineVariables[guid];
							_.keys(entity).forEach(property => {
								const variables = entity[property];
								_.keys(variables).forEach(_var => {
									res[_var] = variables[_var];
								});
							});
						});
						return res;
					} else {
						return {};
					}
				}
			}));
		}
	}
}
// These need to pass in node working on instead of selected node
export function handleChangeProperty(tree = state, property, value, nodePath = null, expectedId = null) {
	let arrPath = nodePath ? nodePath : getSelectedNodePath();
	let existingObject = tree.select(arrPath);
	if (expectedId && existingObject.get("id") !== expectedId) {
		// A buffered editor update can arrive after selection or structure changes.
		// Resolve its original target, and drop it if that node was removed.
		arrPath = findNodePath(expectedId, ["tree", "root"], tree);
		if (!arrPath) {
			return;
		}
		existingObject = tree.select(arrPath);
	}
	// console.log("Changing property", property, value);

	let targetPath = ["entity", property];
	if (_.isArray(property)) {
		targetPath = _.concat(["entity"], property);
	}

	tree.select(arrPath).set(targetPath, value);
	if (property === "id") {
		const entityId = existingObject.get(["entity", "entityId"]);
		// Ok have a variable for that
		if (!tree.get("tree", "variablesMap", entityId)) {
			if (value.trim() !== "") {
				tree.set(["tree", "variablesMap", entityId], true);
				tree.push(["tree", "variables"], {
					id: value,
					entityId
				});
			}
		} else if (value.trim() !== "") {
			// The id has a value
			let varIdx = -1;
			tree.get(["tree", "variables"]).forEach((variable, idx) => {
				if (variable.entityId === entityId) {
					varIdx = idx;
				}
			});
			if (varIdx > -1) {
				tree.set(["tree", "variables", varIdx, "id"], value);
			}
		} else {
			// The id is empty and needs to be removed
			tree.unset(["tree", "variablesMap", entityId]);
			let varIdx = -1;
			tree.get(["tree", "variables"]).forEach((variable, idx) => {
				if (variable.entityId === entityId) {
					varIdx = idx;
				}
			});
			if (varIdx > -1) {
				tree.splice(["tree", "variables"], [varIdx, 1]);
			}
		}
	}
	// console.log("Current variable states", tree.get(["tree", "variables"]), tree.get(["tree", "variablesMap"]));

	// JJB: MONITOR IF A PROBLEM COMMENTING OUT
	tree.commit();

	// Future use for blocks of undo
	changePropertyCount++;

	// JJB: DO WE NEED?
	// Need to rethink...should be better place to do
	// utils.recursePopulateIdsForEntities(tree.get(["tree"]).root.children, tree, null, null);

	saveUndoState();
}

export function handleCopyPasteProperty(tree, srcProperty, dstProperty) {
	let arrPath = tree.select("selectedNodePath").get();
	let value = tree.select(arrPath).get(["entity", srcProperty]);
	tree.select(arrPath).set(["entity", dstProperty], value);
	tree.commit();

	// Future use for blocks of undo
	changePropertyCount++;

	saveUndoState();
}

export function handleCopyPastePropertyFromContent(tree, content, dstProperty) {
	let arrPath = tree.select("selectedNodePath").get();
	tree.select(arrPath).set(["entity", dstProperty], content);
	tree.commit();

	tree.set(["appState", "forceEditorRefresh"], tree.get(["appState", "forceEditorRefresh"]) + 1);

	// Future use for blocks of undo
	changePropertyCount++;

	saveUndoState();
}

export function handleChangePrintProperty(tree, property, value) {
	const arrPath = tree.select("selectedNodePath").get();
	tree.select(arrPath).set(["entity", "printProperties", property], value);

	// Future use for blocks of undo
	changePropertyCount++;

	saveUndoState();
}

export function handleChangePropertyForComments(tree, value) {
	let arrPath = tree.select("selectedNodePath").get();
	//tree.select(arrPath).set(["entity","commentsAuthor"],value);
	tree.select(arrPath).set(["entity", "commentsAuthor"], "");
	tree.select(arrPath).set(["entity", "comments"], utils.createMarkupForComments(value));

	// Future use for blocks of undo
	changePropertyCount++;

	saveUndoState();
}

export function handleChangeValuesProperty(tree, property, value) {
	let arrPath = tree.select("selectedNodePath").get();
	tree.select(arrPath).set(["entity", "values", property], value);

	changePropertyCount++;

	saveUndoState();
}

export function handleDeleteTag(tree, i) {
	let arrPath = tree.select("selectedNodePath").get();
	let tags = tree.select(arrPath).select(["entity", "tags"]);

	tags.splice([i, 1]);
}

export function handleAddTag(tree, tag) {
	let arrPath = tree.select("selectedNodePath").get();
	let tags = tree.select(arrPath).select(["entity", "tags"]);

	tags.push(tag);
}

export function handleDeleteGroupName(tree, i) {
	const arrPath = tree.select("selectedNodePath").get();
	let groupNames = tree.select(arrPath).select(["entity", "groupNames"]);

	groupNames.splice([i, 1]);

	// Also remove from global state
	// Would need to check if any other items are referencing
}

export function handleAddGroupName(tree, groupName) {
	if (groupName.indexOf(" ") > -1) {
		alert("Sorry, a group name should not have any spaces.");
		return;
	}

	const arrPath = tree.select("selectedNodePath").get();
	let groupNames = tree.select(arrPath).select(["entity", "groupNames"]);

	groupNames.push(groupName);

	// Also add to global state
	let globalGroupNames = tree.get("groupNames");
	if (globalGroupNames.indexOf(groupName) === -1) {
		globalGroupNames.push(groupName);
	}
	tree.set(["groupNames"], globalGroupNames);
}

export function handleDeleteFilterTag(tree, i) {
	const arrPath = tree.select("selectedNodePath").get();
	let filterTags = tree.select(arrPath).select(["entity", "filterTags"]);

	filterTags.splice([i, 1]);

	// Also remove from global state
	// Would need to check if any other items are referencing
}

export function handleCopyGroupNames(tree) {
	const arrPath = tree.select("selectedNodePath").get();
	let groupNames = tree.select(arrPath).get(["entity", "groupNames"]);

	global.groupNames = groupNames; // eslint-disable-line
}

export function handlePasteGroupNames(tree) {
	const arrPath = tree.select("selectedNodePath").get();
	let groupNames = tree.select(arrPath).get(["entity", "groupNames"]);
	let groupNamesCursor = tree.select(arrPath).select(["entity", "groupNames"]);

	for (let i = 0; i < global.groupNames.length; i++) { // eslint-disable-line
		let groupName = global.groupNames[i]; // eslint-disable-line

		if (groupNames.indexOf(groupName) === -1) {
			groupNamesCursor.push(groupName);
		}
	}

	saveUndoState();
}

export function handleAddFilterTag(tree, filterTag) {
	const arrPath = tree.select("selectedNodePath").get();
	let filterTags = tree.select(arrPath).select(["entity", "filterTags"]);

	filterTags.push(filterTag);

	// Also add to global state
	let globalFilterTags = tree.get("filterTags");
	if (globalFilterTags.indexOf(filterTag) === -1) {
		globalFilterTags.push(filterTag);
	}
	tree.set(["filterTags"], globalFilterTags);
}

export function handleCopyFilterTags(tree) {
	const arrPath = tree.select("selectedNodePath").get();
	let filterTags = tree.select(arrPath).get(["entity", "filterTags"]);

	global.filterTags = filterTags; // eslint-disable-line no-undef
}

export function handlePasteFilterTags(tree) {
	const arrPath = tree.select("selectedNodePath").get();
	let filterTags = tree.select(arrPath).get(["entity", "filterTags"]);
	let filterTagsCursor = tree.select(arrPath).select(["entity", "filterTags"]);
	/* eslint-disable no-undef */
	for (let i = 0; i < global.filterTags.length; i++) {
		let filterTag = global.filterTags[i];
		/* eslint-enable no-undef */
		if (filterTags.indexOf(filterTag) === -1) {
			filterTagsCursor.push(filterTag);
		}
	}

	saveUndoState();
}

export function handleCopyConditionalVisible(tree) {
	const arrPath = tree.select("selectedNodePath").get();
	let conditionalVisible = tree.select(arrPath).get(["entity", "conditionalVisible"]);

	global.conditionalVisible = conditionalVisible; // eslint-disable-line no-undef
}

export function handlePasteConditionalVisible(tree) {
	const arrPath = tree.select("selectedNodePath").get();
	// let conditionalVisible = tree.select(arrPath).get(["entity", "conditionalVisible"]);
	let conditionalVisibleCursor = tree.select(arrPath).select(["entity", "conditionalVisible"]);

	// Need to fix id's

	/* eslint-disable no-undef */
	conditionalVisibleCursor.set(global.conditionalVisible);

	// Need to fix id's
	let newNode = _.cloneDeep(tree.get(arrPath));

	newNode.entity = fixIftttStructureIds(newNode.entity);

	conditionalVisibleCursor.set(newNode.entity.conditionalVisible);

	saveUndoState();
}

function unselectNode(tree) {
	let oldSelectedNodePath = tree.select("selectedNodePath").get();
	oldSelectedNodePath.push("selected");
	tree.set(oldSelectedNodePath, false);

	tree.set(["selectedNodePath"], []);
}

function resolveSelectableNodePath(tree, arrPath) {
	const fallbackPath = ["tree", "root"];
	if (!Array.isArray(arrPath) || arrPath.length === 0) {
		return fallbackPath;
	}
	let candidate = _.cloneDeep(arrPath);
	while (candidate.length >= 2) {
		let node = null;
		try {
			node = tree.get(candidate);
		} catch (err) {
			node = null;
		}
		if (node && typeof node === "object") {
			const isRoot = candidate.length === 2 && candidate[0] === "tree" && candidate[1] === "root";
			const hasEntity = node.entity && typeof node.entity === "object" && typeof node.entity.type === "string";
			if (isRoot || hasEntity) {
				return candidate;
			}
		}
		candidate = candidate.slice(0, candidate.length - 1);
	}
	return fallbackPath;
}

export function handleSelectNodeAtPath(tree, arrPath, anchor = null, options = {}) {
	const preserveVirtualSelection = options && options.preserveVirtualSelection === true;
	const skipSetSelectedFlag = options && options.skipSetSelectedFlag === true;
	const safeArrPath = resolveSelectableNodePath(tree, arrPath);
	let oldSelectedNodePath = tree.select("selectedNodePath").get();
	const samePath = Array.isArray(oldSelectedNodePath) && _.isEqual(oldSelectedNodePath, safeArrPath);

	if (samePath) {
		if (!skipSetSelectedFlag) {
			const selectedFlagPath = _.cloneDeep(safeArrPath).concat("selected");
			try {
				if (tree.get(selectedFlagPath) !== true) {
					tree.set(selectedFlagPath, true);
				}
			} catch (err) {
				// Ignore stale/invalid selected flag paths.
			}
		}

		if (!preserveVirtualSelection) {
			const virtualSelectionPath = ["appState", "previewChecklist", "virtualOutlineSelection"];
			if (tree.get(virtualSelectionPath) !== undefined) {
				tree.unset(virtualSelectionPath);
			}
			const pendingVirtualSelectionPath = ["appState", "previewChecklist", "pendingVirtualSelection"];
			if (tree.get(pendingVirtualSelectionPath) !== undefined) {
				tree.unset(pendingVirtualSelectionPath);
			}
		}

		if (anchor) {
			setExpectedAnchorTarget(anchor);
		}

		return safeArrPath;
	}

	if (Array.isArray(oldSelectedNodePath) && oldSelectedNodePath.length > 0) {
		const oldSelectedNodePathWithSelected = _.cloneDeep(oldSelectedNodePath);
		oldSelectedNodePathWithSelected.push("selected");
		try {
			tree.set(oldSelectedNodePathWithSelected, false);
		} catch (err) {
			// Ignore stale/invalid old paths.
		}
	}

	tree.set(["selectedNodePath"], safeArrPath);

	if (!skipSetSelectedFlag) {
		let selectedNodePath = _.cloneDeep(safeArrPath);
		selectedNodePath.push("selected");
		tree.set(selectedNodePath, true);
	}

	if (!preserveVirtualSelection) {
		tree.unset(["appState", "previewChecklist", "virtualOutlineSelection"]);
		tree.unset(["appState", "previewChecklist", "pendingVirtualSelection"]);
	}

	if (anchor) {
		setExpectedAnchorTarget(anchor);
	}

	return safeArrPath;
}

export function handleUndo(tree) {
	let historyIndex = tree.get("historyIndex");
	if (historyIndex > 0) {
		historyIndex--;
		let history = tree.get(["history", historyIndex]);
		tree.set("tree", history.tree);
		tree.set("selectedNodePath", history.selectedNodePath);
		tree.set("historyIndex", historyIndex);
	}
}

export function handleRedo(tree) {
	let historyIndex = tree.get("historyIndex");
	if (historyIndex < tree.get("history").length - 1) {
		historyIndex++;
		let history = tree.get(["history", historyIndex]);
		tree.set("tree", history.tree);
		tree.set("selectedNodePath", history.selectedNodePath);
		tree.set("historyIndex", historyIndex);
	}

}

// Clean up select code
export function handleSelectNodeParent(tree) {
	if (nothingSelected(tree)) {
		return;
	}

	let oldSelectedNodePath = tree.select("selectedNodePath").get();
	let oldSelectedNodeCursor = tree.select(oldSelectedNodePath);

	if (isNothingSelected(oldSelectedNodeCursor)) {
		return;
	}

	let selectedNodeCursor = oldSelectedNodeCursor.up().up();
	if (selectedNodeCursor !== null && selectedNodeCursor.path.length > 0) {
		oldSelectedNodePath.push("selected");
		tree.set(oldSelectedNodePath, false);

		// Weirdness if use path directly
		let arrPath = Object.assign([], selectedNodeCursor.path);
		tree.set(["selectedNodePath"], arrPath);

		let selectedNodePath = arrPath;
		selectedNodePath.push("selected");
		tree.set(selectedNodePath, true);
		scrollSelectedNodeIntoView();
	}
}

export function handleSelectNodeFirstChild(tree) {
	if (nothingSelected(tree)) {
		return;
	}

	let oldSelectedNodePath = tree.select("selectedNodePath").get();
	let oldSelectedNodeCursor = tree.select(oldSelectedNodePath);

	if (!oldSelectedNodeCursor.get().hasOwnProperty("children")) {
		return;
	}

	// Expand if not already
	if (!isNodeExpanded(oldSelectedNodeCursor)) {
		handleToggleNode(oldSelectedNodeCursor);
	}

	let selectedNodeCursor = oldSelectedNodeCursor.select("children").down();
	if (selectedNodeCursor !== null) {
		oldSelectedNodePath.push("selected");
		tree.set(oldSelectedNodePath, false);

		// Weirdness if use path directly
		let arrPath = Object.assign([], selectedNodeCursor.path);
		tree.set(["selectedNodePath"], arrPath);

		let selectedNodePath = arrPath;
		selectedNodePath.push("selected");
		tree.set(selectedNodePath, true);
		scrollSelectedNodeIntoView();
	}
}

function refreshVisible(tree) {
	_visiblePaths = [];
	let cursor = tree.select(["tree", "root"]);
	recurseRefreshVisible(null, cursor);
}

export function handleSelectNodeDownNew(tree) {
	refreshVisible(tree);

	if (nothingSelected(tree)) {
		return;
	}

	let selectedIndex;

	for (let i = 0; i < _visiblePaths.length; i++) {
		if (JSON.stringify(tree.select("selectedNodePath").get()) === JSON.stringify(_visiblePaths[i])) {
			selectedIndex = i;
		}
	}

	let oldSelectedNodePath = tree.select("selectedNodePath").get();
	let oldSelectedNodeCursor = tree.select(oldSelectedNodePath);

	if (isNothingSelected(oldSelectedNodeCursor)) {
		return;
	}
	/*
	 if (isTreeRoot(oldSelectedNodeCursor)) {
	 return;
	 }
	 */

	//	var selectedNodeCursor = oldSelectedNodeCursor.right();
	//	if (selectedNodeCursor !== null) {


	if (selectedIndex < _visiblePaths.length - 1) {
		oldSelectedNodePath.push("selected");
		tree.set(oldSelectedNodePath, false);

		let arrPath = Object.assign([], _visiblePaths[selectedIndex + 1]);
		tree.set(["selectedNodePath"], arrPath);


		let selectedNodePath = arrPath;
		selectedNodePath.push("selected");
		tree.set(selectedNodePath, true);
		scrollSelectedNodeIntoView();
	}

	/*
	 // Weirdness if use path directly
	 var arrPath = Object.assign([],selectedNodeCursor.path);
	 tree.set(['selectedNodePath'],arrPath);


	 var selectedNodePath = arrPath;
	 selectedNodePath.push("selected");
	 tree.set(selectedNodePath,true);
	 */
	//	}
}

export function handleSelectNodeUpNew(tree) {
	_visiblePaths = [];
	let cursor = tree.select(["tree", "root"]);
	recurseRefreshVisible(null, cursor);

	if (nothingSelected(tree)) {
		return;
	}

	let selectedIndex;

	for (let i = 0; i < _visiblePaths.length; i++) {
		if (JSON.stringify(tree.select("selectedNodePath").get()) === JSON.stringify(_visiblePaths[i])) {
			selectedIndex = i;
		}
	}

	let oldSelectedNodePath = tree.select("selectedNodePath").get();
	let oldSelectedNodeCursor = tree.select(oldSelectedNodePath);

	if (isNothingSelected(oldSelectedNodeCursor)) {
		return;
	}

	if (selectedIndex > 0) {
		oldSelectedNodePath.push("selected");
		tree.set(oldSelectedNodePath, false);

		let arrPath = Object.assign([], _visiblePaths[selectedIndex - 1]);
		tree.set(["selectedNodePath"], arrPath);

		let selectedNodePath = arrPath;
		selectedNodePath.push("selected");
		tree.set(selectedNodePath, true);
		scrollSelectedNodeIntoView();
	}
}


export function handleSelectNodeDown(tree = state) {
	if (nothingSelected(tree)) {
		return;
	}

	let oldSelectedNodePath = tree.select("selectedNodePath").get();
	let oldSelectedNodeCursor = tree.select(oldSelectedNodePath);

	if (isNothingSelected(oldSelectedNodeCursor)) {
		return;
	}
	if (isTreeRoot(oldSelectedNodeCursor)) {
		return;
	}

	let selectedNodeCursor = oldSelectedNodeCursor.right();
	if (selectedNodeCursor !== null) {
		oldSelectedNodePath.push("selected");
		tree.set(oldSelectedNodePath, false);

		// Weirdness if use path directly
		let arrPath = Object.assign([], selectedNodeCursor.path);
		tree.set(["selectedNodePath"], arrPath);

		let selectedNodePath = arrPath;
		selectedNodePath.push("selected");
		tree.set(selectedNodePath, true);
		console.log("Same?", selectedNodePath.join(":") === oldSelectedNodePath.join(":"));
		scrollSelectedNodeIntoView();
		return selectedNodePath.join(":") === oldSelectedNodePath.join(":");
	} else {
		return true;
	}
}

export function handleSelectNodeUp(tree) {
	if (nothingSelected(tree)) {
		return;
	}

	let oldSelectedNodePath = tree.select("selectedNodePath").get();
	let oldSelectedNodeCursor = tree.select(oldSelectedNodePath);

	if (isNothingSelected(oldSelectedNodeCursor)) {
		return;
	}
	if (isTreeRoot(oldSelectedNodeCursor)) {
		return;
	}

	let selectedNodeCursor = oldSelectedNodeCursor.left();
	if (selectedNodeCursor !== null) {
		oldSelectedNodePath.push("selected");
		tree.set(oldSelectedNodePath, false);

		// Weirdness if use path directly
		let arrPath = Object.assign([], selectedNodeCursor.path);
		tree.set(["selectedNodePath"], arrPath);

		let selectedNodePath = arrPath;
		selectedNodePath.push("selected");
		tree.set(selectedNodePath, true);
		scrollSelectedNodeIntoView();
	}
}

function getTreeRoot(tree) {
	return tree.select(["tree", "root"]);
}


function nothingSelected(tree) {
	let oldSelectedNodePath = tree.select("selectedNodePath").get();
	let oldSelectedNodeCursor = tree.select(oldSelectedNodePath);

	return isNothingSelected(oldSelectedNodeCursor);
}

function isNothingSelected(cursor) {
	if (state.get("editingNodePath")) {
		return true;
	}

	return cursor.path.length === 0;
}

function isTreeRoot(cursor) {
	return cursor.path.length === 2;
}

function isNodeExpanded(cursor) {
	return cursor.get().expanded === true;
}

export function refreshAll(tree) {
	let cursor = getTreeRoot(tree);

	if (cursor.select("children").isBranch()) {
		cursor.set("expanded", false);
		recurseCollapse(cursor.select("children").down());
	}

	resetTree(state.get(["tree", "root", "children"]));
	state.set("selectedNodePath", ["tree", "root"]);
}

export function handleCollapseAll(tree) {
	const checklist = tree.get(["tree", "root"]);

	if (!checklist.hasOwnProperty("children") || checklist.children.length === 0) {
		return;
	}

	let cursor = tree.select(tree.select("selectedNodePath").get());

	if (cursor.path.length === 0) {
		cursor = getTreeRoot(tree);
	}

	if (cursor.select("children").isBranch()) {
		cursor.set("expanded", false);
		recurseCollapse(cursor.select("children").down());
	}
}

export function handleExpandAll(tree) {
	const checklist = tree.get(["tree", "root"]);

	if (!checklist.hasOwnProperty("children") || checklist.children.length === 0) {
		return;
	}

	let cursor = tree.select(tree.select("selectedNodePath").get());

	if (cursor.path.length === 0) {
		cursor = getTreeRoot(tree);
	}

	if (cursor.select("children").isBranch()) {
		cursor.set("expanded", true);
		recurseExpand(cursor.select("children").down());
	}
}

export function handleExpandNodeAll(cursor) {
	let cursorRoot = state.select(["tree", "root"]);

	cursorRoot.set("expanded", true);
	if (cursor.select("children").isBranch()) {
		cursor.set("expanded", true);
		recurseExpand(cursor.select("children").down());
	}
}

export function handleToggleNode(cursor) {
	cursor.set("expanded", !cursor.get("expanded"));
}

export function initializeNodeState(node) {
	if (node && node.id) {
		const appStateNodePath = ["appState", "nodes", node.id];
		const appStateNodeCursor = state.select(appStateNodePath);
		if (!appStateNodeCursor.exists()) {
			state.set(appStateNodePath, {});
		}
	}
}

export function handleEditNode(path, edit = true) {

	const currentEditingNodePath = state.get("editingNodePath");
	if (edit && currentEditingNodePath && path && currentEditingNodePath.join(":") === path.join(":")) {
		// Don't select again if already selected.
		return;
	}
	if (currentEditingNodePath) {
		const _path = currentEditingNodePath.concat("editing");
		console.log("Unset editor for ", _path);
		state.set(_path, false);
	}
	if (edit) {
		if (!path) {
			path = state.get("selectedNodePath");
		}
		if (path && _.last(path) === "selected") {

			path = _.dropRight(path);
		}
		const cursor = state.select(path);
		const selectPath = _.cloneDeep(path);
		console.log("BEFORE:", path);
		handleSelectNodeAtPath(state, selectPath);
		if (path && _.last(path) === "selected") {

			path = _.dropRight(path);
		}
		console.log("AFTER ", path);
		cursor.set("editing", true);
		state.set("editingNodePath", path);
		const appStateNodePath = ["appState", "nodes", cursor.get("id")];
		console.log("appStateNodePath=", appStateNodePath, cursor.get());
		const appStateNodeCursor = state.select(appStateNodePath);
		if (!appStateNodeCursor.exists()) {
			state.set(appStateNodePath, {});
		}
	} else {
		state.set(["appState", "forceEditorRefresh"], state.get(["appState", "forceEditorRefresh"]) + 1);
		state.set("editingNodePath", null);
	}

}

export function handleExpandNode(cursor) {
	cursor.set("expanded", true);
}

export function handleCollapseNode(cursor) {
	cursor.set("expanded", false);
}

function getAuthorPropertiesObject(entity) {
	if (!entity || !entity.authorProperties) {
		return {};
	}
	if (_.isObject(entity.authorProperties)) {
		return entity.authorProperties;
	}
	if (_.isString(entity.authorProperties)) {
		try {
			const parsed = JSON.parse(entity.authorProperties);
			return _.isObject(parsed) ? parsed : {};
		} catch (err) {
			return {};
		}
	}
	return {};
}

function isReferencedBankContainerNode(node) {
	const entity = _.get(node, "entity");
	const bankRef = _.get(getAuthorPropertiesObject(entity), "bankRef", {});
	const blockType = _.get(bankRef, "blockType", _.get(bankRef, "ref.blockType", ""));
	return blockType === "list" || blockType === "section";
}

function hasReferencedBankContainerAncestor(tree, cursor) {
	if (!tree || !cursor || !_.isArray(cursor.path)) {
		return false;
	}
	let ancestorPath = cursor.path.slice(0, -2);
	while (ancestorPath.length >= 2) {
		const ancestorNode = tree.get(ancestorPath);
		if (isReferencedBankContainerNode(ancestorNode)) {
			return true;
		}
		if (ancestorPath.length <= 2) {
			break;
		}
		ancestorPath = ancestorPath.slice(0, -2);
	}
	return false;
}

export function handleRemoveNode(tree, cursor) {
	if (nothingSelected(tree)) {
		return;
	}
	if (isTreeRoot(cursor)) {
		return;
	}
	if (hasReferencedBankContainerAncestor(tree, cursor)) {
		showError("Read-only inherited node", "This node is inherited from a referenced bank list/section and cannot be deleted directly.");
		return;
	}

	unselectNode(tree);
	const node = cursor.get();
	if (node.entity && !_.isEmpty(node.entity.entityId)) {
		const entityId = node.entity.entityId;
		// The id is empty and needs to be removed
		tree.unset(["tree", "variablesMap", entityId]);
		let varIdx = -1;
		tree.get(["tree", "variables"]).forEach((variable, idx) => {
			if (variable.entityId === entityId) {
				varIdx = idx;
			}
		});
		if (varIdx > -1) {
			tree.splice(["tree", "variables"], [varIdx, 1]);
		}
	}


	let index = cursor.path[cursor.path.length - 1];
	cursor.up().splice([index, 1]);

	saveUndoState();
}

export function handleCut(tree) {
	if (nothingSelected(tree)) {
		return;
	}

	let cursor = tree.select(tree.select("selectedNodePath").get());
	let node = cursor.get();

	// Cutting the root tree node is not allowed
	if (node && node.entity.type !== "checklist") {

		tree.set("clipboardMode", "cut");
		tree.set("clipboard", node);
		tree.set(["clipboardExternalResources"], getExternalResources(true));
		tree.set(["clipboardRelatedItems"], getRelatedItems(true));
		tree.set(["clipboard", "selected"], false);

		let index = cursor.path[cursor.path.length - 1];

		unselectNode(tree);

		cursor.up().splice([index, 1]);

		saveUndoState();
	}
}

export function copyNodeToClipboard(tree, node, externalResources = null, relatedItems = null, options = {}) {
	if (!tree || !node) {
		return;
	}
	const clipboardNode = _.get(options, "cloneNode", false) ? _.cloneDeep(node) : node;
	tree.set("clipboardMode", "copy");
	tree.set("clipboard", clipboardNode);
	tree.set(["clipboardExternalResources"], externalResources || getExternalResources(true));
	tree.set(["clipboardRelatedItems"], relatedItems || getRelatedItems(true));
}

export function handleCopy(tree) {
	if (nothingSelected(tree)) {
		return;
	}

	let cursor = tree.select(tree.select("selectedNodePath").get());
	//tree.set("clipboard",tree.select('selectedNodePath').get());

	copyNodeToClipboard(tree, cursor.get());
	//saveUndoState();
}

function canPaste(tree) {
	let cursor = tree.select(tree.select("selectedNodePath").get());
	let srcNode = cursor.get();

	let pasteNode = tree.get("clipboard");

	if (!pasteNode.hasOwnProperty("entity")) {
		return false;
	} else if (pasteNode.entity.type === "checklist") {
		return false;
		// If pasting on the same type
	} else if (srcNode.entity.type === pasteNode.entity.type) {
		return true;
	} else if (srcNode.entity.type.startsWith("item") && pasteNode.entity.type.startsWith("item")) {
		return true;
	} else {
		if (srcNode.entity.type === "checklist" && srcNode.children.length === 0) {
			return true;
		} else if (pasteNode.entity.type === "list" && srcNode.entity.type === "checklist") {
			if ((srcNode.children.length > 0 && srcNode.children[0].entity.type === "list") || (srcNode.length === 0)) {
				return true;
			}
		} else if (pasteNode.entity.type === "section" && srcNode.entity.type === "checklist") {
			if ((srcNode.children.length > 0 && srcNode.children[0].entity.type === "section") || (srcNode.length === 0)) {
				return true;
			}
		} else if (pasteNode.entity.type.startsWith("item") && srcNode.entity.type.startsWith("item")) {
			if ((srcNode.children.length > 0 && srcNode.children[0].entity.type === "list") || (srcNode.length === 0)) {
				return true;
			}
		} else if (pasteNode.entity.type === "section" && srcNode.entity.type === "list") {
			return true;
		} else if (pasteNode.entity.type.startsWith("item") && srcNode.entity.type === "section") {
			return true;
		}
	}

	showError("Invalid", "You can't paste this here.");

	return false;
}

function isDriveExternalResourceWithGuid(resource) {
	return resource && resource.type === "resource/external/drive" && _.isString(resource.guid) && !_.isEmpty(resource.guid);
}

function rewriteExternalResourceReferenceIds(node, idMap = {}) {
	if (_.isArray(node)) {
		node.forEach((entry) => {
			rewriteExternalResourceReferenceIds(entry, idMap);
		});
		return;
	}

	if (!_.isPlainObject(node)) {
		return;
	}

	if (node.type === "resource/ref" && _.isString(node.refId) && idMap.hasOwnProperty(node.refId)) {
		node.refId = idMap[node.refId];
	}

	_.keys(node).forEach((key) => {
		rewriteExternalResourceReferenceIds(node[key], idMap);
	});
}

function finalizePasteEntries(pastedExternalResources, pastedRelatedItems, pastedNodes = null) {
	// Should have new map of pasted entries, just need to convert to array and add to pasted external references
	// For that convert destination resources to map, merge these, then write back out
	const externalResources = getExternalResources(true);
	const dstExternalResources = Object.assign({}, externalResources);
	const driveResourceIdsByGuid = {};
	const aliasToCanonicalId = {};

	_.forEach(dstExternalResources, (resource, resourceId) => {
		if (resourceId && isDriveExternalResourceWithGuid(resource) && !driveResourceIdsByGuid[resource.guid]) {
			driveResourceIdsByGuid[resource.guid] = resourceId;
		}
	});

	// Reuse already attached Drive resources when the pasted node references the same guid.
	_.forEach(pastedExternalResources, (resource, resourceId) => {
		if (!resource || !resourceId) {
			return;
		}

		if (isDriveExternalResourceWithGuid(resource) && driveResourceIdsByGuid[resource.guid]) {
			const canonicalId = driveResourceIdsByGuid[resource.guid];
			if (canonicalId !== resourceId) {
				aliasToCanonicalId[resourceId] = canonicalId;
			}
			return;
		}

		dstExternalResources[resourceId] = resource;

		if (isDriveExternalResourceWithGuid(resource) && !driveResourceIdsByGuid[resource.guid]) {
			driveResourceIdsByGuid[resource.guid] = resourceId;
		}
	});

	if (!_.isEmpty(aliasToCanonicalId)) {
		rewriteExternalResourceReferenceIds(pastedNodes, aliasToCanonicalId);
		rewriteExternalResourceReferenceIds(pastedRelatedItems, aliasToCanonicalId);
	}

	// Write out external resources
	const _externalResources = [];
	for (const [key, value] of Object.entries(dstExternalResources)) {
		console.log(`${key}: ${value}`);
		_externalResources.push(value);
	}

	console.log("!$!$!$ ARRAY", _externalResources);
	state.set(EXTERNAL_RESOURCES_STATE_PATH, _externalResources);

	const relatedItems = getRelatedItems(true);
	const dstRelatedItems = Object.assign({}, relatedItems, pastedRelatedItems);

	// Write out related items
	const _relatedItems = [];
	for (const [key, value] of Object.entries(dstRelatedItems)) {
		console.log(`${key}: ${value}`);
		_relatedItems.push(value);
	}

	console.log("!$!$!$ ARRAY", _externalResources);
	state.set(RELATED_ITEMS_STATE_PATH, _relatedItems);
}

function collectPasteDependenciesForNode(node, externalResources, relatedItems, pastedExternalResources, pastedRelatedItems) {
	if (!_.isObject(node)) {
		return;
	}

	if (_.isObject(node.entity)) {
		recurseEntityProps(node.entity, externalResources, pastedExternalResources, relatedItems, pastedRelatedItems);
	}

	if (_.isArray(node.children) && node.children.length > 0) {
		recursePasteEntries(node.children, externalResources, pastedExternalResources, relatedItems, pastedRelatedItems);
	}
}

function finalizePasteDependenciesForNodes(nodes, externalResources = {}, relatedItems = {}) {
	const pastedExternalResources = {};
	const pastedRelatedItems = {};
	const list = _.isArray(nodes) ? nodes : [nodes];

	list.forEach((node) => {
		collectPasteDependenciesForNode(node, externalResources, relatedItems, pastedExternalResources, pastedRelatedItems);
	});

	finalizePasteEntries(pastedExternalResources, pastedRelatedItems, nodes);
}

function isItemTypeForPaste(type = "") {
	return _.isString(type) && type.startsWith("item");
}

function shouldPasteItemContainerAsSibling(tree) {
	return tree.get(["appState", "checklistEditor", "itemContainerInsertAsSibling"]) === true;
}

function shouldForcePasteAsSibling(tree, selectedType = "", pastedType = "", requestedPosition = "lastChild") {
	if (requestedPosition !== "lastChild" && requestedPosition !== "firstChild") {
		return false;
	}

	const selectedIsList = selectedType === "list";
	const pastedIsList = pastedType === "list";
	if (selectedIsList && pastedIsList) {
		return true;
	}

	const selectedIsSection = selectedType === "section";
	const pastedIsSection = pastedType === "section";
	if (selectedIsSection && pastedIsSection) {
		return true;
	}

	const selectedIsItemContainer = isItemContainerType(selectedType);
	const selectedIsItem = isItemTypeForPaste(selectedType);
	const pastedIsItem = isItemTypeForPaste(pastedType);
	if (selectedIsItem && pastedIsItem && !selectedIsItemContainer) {
		return true;
	}

	if (selectedIsItemContainer && pastedIsItem && shouldPasteItemContainerAsSibling(tree)) {
		return true;
	}

	return false;
}

function resolvePastePositionType(tree, selectedType = "", pastedType = "", requestedPosition = "lastChild") {
	let effectivePosition = requestedPosition;
	if (shouldForcePasteAsSibling(tree, selectedType, pastedType, requestedPosition)) {
		effectivePosition = "after";
	}

	return effectivePosition;
}

// TODO: Try to be clever for default add when not a category
export function handlePaste(tree, positionType = "lastChild") {
	// Can only paste a list onto a checklist where all children are lists or another list
	// Can only paste a section onto a list where are children are sections or another section
	// Can only paste an item onto a section where all children are items or another item
	if (nothingSelected(tree)) {
		return;
	}
	if (tree.get("clipboard") === null) {
		return;
	}
	if (!canPaste(tree)) {
		return;
	}

	let newNode;

	if (tree.get("clipboardMode") === "copy" || tree.get("clipboardMode") === "cut") {
		//var copiedNodePath = tree.get("clipboard");

		let node = tree.get("clipboard");

		console.log(`Handle paste, clipboardMode: ${tree.get("clipboardMode")}`);

		//console.log(`Handle paste, search for entity in tree by guid: ${node.entity.guid} ${entityUtils.findEntityByGuid(tree.get(["tree", "root"]), node.entity.guid)}`)

		// If node isn't currently in the tree for cut, paste node as-is, otherwise, create copy of the node to avoid duplicate GUIDs
		if (tree.get("clipboardMode") === "cut" && !entityUtils.findEntityByGuid(tree.get(["tree", "root"]), node.entity.guid)) {
			console.log("Handle paste from cut by using clipboard node as-is, entity not found in tree");
			newNode = node;
			finalizePasteDependenciesForNodes(
				newNode,
				tree.get("clipboardExternalResources") || {},
				tree.get("clipboardRelatedItems") || {}
			);
		} else {
			console.log(`Handle paste do copy, clipboardMode: ${tree.get("clipboardMode")}`);
			newNode = deepCloneNodeFromClipboard(tree, node);
			/*
			const srcExternalResources = tree.get("clipboardExternalResources");
			const srcRelatedItems = tree.get("clipboardRelatedItems");

			let entityId = utils.generateUUID();
			const guid = utils.generateUUID();
			newNode = _.cloneDeep(node);
			newNode.entity.entityId = entityId;
			newNode.entity.guid = guid;

			newNode.entity = fixIftttStructureIds(newNode.entity);

			if (newNode.entity.groupNames && newNode.entity.groupNames.indexOf("#internal-templates") > -1) {
				newNode.entity.groupNames.splice(newNode.entity.groupNames.indexOf("#internal-templates"), 1);
			}

			const pastedExternalResources = {};
			const pastedRelatedItems = {};
			recurseEntityProps(newNode.entity, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);

			//newNode.entity.id = entityId;
			newNode.selected = false;

			if (newNode.hasOwnProperty("children")) {
				recurseUpdateIds(newNode.children);
				recursePasteEntries(newNode.children, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);
			}

			finalizePasteEntries(pastedExternalResources, pastedRelatedItems);
			*/
		}
	}

	/*
	} else if (tree.get("clipboardMode") === "cut") {
		newNode = tree.get("clipboard");
	}
	*/

	let index, arrPath;
	if (tree.get("clipboardMode") === "copy" || tree.get("clipboardMode") === "cut") {
		let cursor = tree.select(tree.select("selectedNodePath").get());
		const selectedType = _.get(cursor.get(), "entity.type", "");
		const pastedType = _.get(newNode, "entity.type", "");
		positionType = resolvePastePositionType(tree, selectedType, pastedType, positionType);
		// eslint-disable-next-line default-case
		switch (positionType) {
			case "firstChild":
				cursor.set("expanded", true);
				cursor.select("children").unshift(newNode);
				break;
			case "lastChild":
				cursor.set("expanded", true);
				cursor.select("children").push(newNode);
				break;
			case "before":
				unselectNode(tree);
				index = cursor.path[cursor.path.length - 1];
				cursor.up().splice([index, 0, newNode]);
				arrPath = Object.assign([], cursor.path);
				arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
				handleSelectNodeAtPath(tree, arrPath);
				break;
			case "after":
				index = cursor.path[cursor.path.length - 1];
				cursor.up().splice([index + 1, 0, newNode]);
				break;
		}
	}

	saveUndoState();
}

export function CSVToArray(CSV_string, delimiter) {
	delimiter = (delimiter || ","); // user-supplied delimeter or default comma

	let pattern = new RegExp( // regular expression to parse the CSV values.
		( // Delimiters:
			"(\\" + delimiter + "|\\r?\\n|\\r|^)" +
			// Quoted fields.
			"(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
			// Standard fields.
			"([^\"\\" + delimiter + "\\r\\n]*))"
		), "gi"
	);

	let rows = [[]];  // array to hold our data. First row is column headers.
	// array to hold our individual pattern matching groups:
	let matches = false; // false if we don't find any matches
	// Loop until we no longer find a regular expression match
	while (matches = pattern.exec(CSV_string)) { // eslint-disable-line
		let matched_delimiter = matches[1]; // Get the matched delimiter
		// Check if the delimiter has a length (and is not the start of string)
		// and if it matches field delimiter. If not, it is a row delimiter.
		if (matched_delimiter.length && matched_delimiter !== delimiter) {
			// Since this is a new row of data, add an empty row to the array.
			rows.push([]);
		}
		var matched_value;
		// Once we have eliminated the delimiter, check to see
		// what kind of value was captured (quoted or unquoted):
		if (matches[2]) { // found quoted value. unescape any double quotes.
			matched_value = matches[2].replace(
				new RegExp("\"\"", "g"), "\""
			);
		} else { // found a non-quoted value
			matched_value = matches[3];
		}
		// Now that we have our value string, let's add
		// it to the data array.
		rows[rows.length - 1].push(matched_value);
	}
	return rows; // Return the parsed data Array
}

export function arrayToJson(arr) {
	const arrResult = [];

	// Keys
	const keys = arr[0];

	// Loop through records
	for (let i = 1; i < arr.length; i++) {
		const obj = {};

		const record = arr[i];

		for (let j = 0; j < record.length; j++) {
			const field = record[j];

			obj[keys[j]] = field;
		}

		arrResult.push(obj);
	}

	return arrResult;
}


export function arrayToActivity(arr) {
	try {
		const activity = {
			id: generateUUID(),
			name: "Magic Activity",
			genre: "health",
			defaultView: "vertView",
			children: []
		};

		// Keys
		const keys = arr[0];

		let lastListName = "";

		let list;

		// Loop through records
		for (let i = 1; i < arr.length; i++) {
			const record = arr[i];

			const section = {
				type: "section",
				name: record[2],
				children: []
			};

			for (let j = 3; j < record.length; j++) {
				const field = record[j];

				const item = {
					type: "item",
					labelOnly: true,
					label1: keys[j],
					label2: field
				};

				section.children.push(item);

			}

			// When list name changes need a new list
			if (lastListName !== record[1]) {
				lastListName = record[1];

				list = {
					type: "list",
					name: record[1],
					children: []
				};

				list.children.push(section);
				activity.children.push(list);
			} else {
				list.children.push(section);
			}
		}

		return activity;
	} catch (err) {
		showError("Magic Paste Error", "There was an error performing the Magic Paste. Make sure the content you are pasting is in the correct format. Currently it should be copied from a spreadsheet where the first row defines the fields, and the rest of the rows define the content. Column 1 should be an ID. Column 2 should be the name of the List, and Column 3 should be the name of the Section. All columns after that should be Item content.");
		return null;
	}
}



export function handleMagicPaste(tree) {
	window.confirm("WARNING: The Magic Paste will overwrite all content in this activity. Do you want to proceed?", async () => {
		const text = await readClipboardText();

		try {
			const jsonActivity = JSON.parse(text);

			if (jsonActivity !== null) {
				// Mock example
				// this.context.tree.set(["clipboardPasteText"], text);
				// const srcTree = transformToChecklistEntities({
				// 	id: generateUUID(),
				// 	name: "Test",
				// 	children: [
				// 		{
				// 			type: "list",
				// 			name: "List 1",
				// 			children: [
				// 				{
				// 					type: "section",
				// 					name: "Section 1",
				// 					children: [
				// 						{
				// 							type: "item",
				// 							label1: "Hello World!"
				// 						},
				// 						{
				// 							type: "item",
				// 							label1: "Hello Again"
				// 						}
				// 					]
				// 				}
				// 			]
				// 		}
				// 	]
				// });

				const srcTree = transformToChecklistEntities(jsonActivity);

				const oldSrcTree = tree.get(["tree"]);

				srcTree.root.id = oldSrcTree.root.id;
				srcTree.root.revision = oldSrcTree.root.revision;
				srcTree.root.revisionTs = oldSrcTree.root.revisionTs;

				srcTree.root.entity.aiAssistant = oldSrcTree.root.entity.aiAssistant;
				srcTree.root.entity.aiAssistantId = oldSrcTree.root.entity.aiAssistantId;
				srcTree.root.entity.aiAssistantFiles = oldSrcTree.root.entity.aiAssistantFiles;
				srcTree.root.entity.aiAssistantChecklistFiles = oldSrcTree.root.entity.aiAssistantChecklistFiles;

				srcTree.root.entity.trackData = false;

				srcTree.root.selected = true;
				srcTree.root.expanded = true;
				resetTree(srcTree.root.children);
				editorActions.resetActivityEditMetaData();
				editorActions.setActivityMetaData("revision", srcTree.root.revision);
				tree.set("selectedChecklistId", srcTree.root.id);
				tree.set("selectedNodePath", ["tree", "root"]);
				tree.set("history", []);
				tree.set("historyIndex", -1);
				tree.set(["tree"], srcTree);
			}
		} catch (err) {
			try {
				// Convert content to array
				const arrContent = CSVToArray(text, "\t");
				const jsonActivity = arrayToActivity(arrContent);

				// console.log("JSON ACTIVITY", jsonActivity);

				if (jsonActivity !== null) {
					// Mock example
					// this.context.tree.set(["clipboardPasteText"], text);
					// const srcTree = transformToChecklistEntities({
					// 	id: generateUUID(),
					// 	name: "Test",
					// 	children: [
					// 		{
					// 			type: "list",
					// 			name: "List 1",
					// 			children: [
					// 				{
					// 					type: "section",
					// 					name: "Section 1",
					// 					children: [
					// 						{
					// 							type: "item",
					// 							label1: "Hello World!"
					// 						},
					// 						{
					// 							type: "item",
					// 							label1: "Hello Again"
					// 						}
					// 					]
					// 				}
					// 			]
					// 		}
					// 	]
					// });

					const srcTree = transformToChecklistEntities(jsonActivity);

					const oldSrcTree = tree.get(["tree"]);

					srcTree.root.id = oldSrcTree.root.id;
					srcTree.root.revision = oldSrcTree.root.revision;
					srcTree.root.revisionTs = oldSrcTree.root.revisionTs;

					srcTree.root.entity.aiAssistant = oldSrcTree.root.entity.aiAssistant;
					srcTree.root.entity.aiAssistantId = oldSrcTree.root.entity.aiAssistantId;
					srcTree.root.entity.aiAssistantFiles = oldSrcTree.root.entity.aiAssistantFiles;
					srcTree.root.entity.aiAssistantChecklistFiles = oldSrcTree.root.entity.aiAssistantChecklistFiles;

					srcTree.root.entity.trackData = false;

					srcTree.root.selected = true;
					srcTree.root.expanded = true;
					resetTree(srcTree.root.children);
					editorActions.resetActivityEditMetaData();
					editorActions.setActivityMetaData("revision", srcTree.root.revision);
					tree.set("selectedChecklistId", srcTree.root.id);
					tree.set("selectedNodePath", ["tree", "root"]);
					tree.set("history", []);
					tree.set("historyIndex", -1);
					tree.set(["tree"], srcTree);
				}
			} catch (err) {
				showError2("Error", "There was an error with the Magic Paste. Make sure you had a proper structure you were copying from.\n\n" + err.message);
			}
		}
	});
}

// Only allow to paste as last child if checklist node is selected, nextSibling if List node is selected
export function handlePasteLists(tree, positionType = "lastChild") {
	if (nothingSelected(tree)) {
		return;
	}
	if (tree.get("clipboard") === null) {
		return;
	}

	if (!canPasteLists(tree)) {
		return;
	}

	let newNode;

	if (tree.get("clipboardMode") === "copy" || tree.get("clipboardMode") === "cut") {
		//var copiedNodePath = tree.get("clipboard");

		let node = tree.get("clipboard");

		console.log(`Handle paste lists, clipboardMode: ${tree.get("clipboardMode")}`);

		//console.log(`Handle paste lists, search for entity in tree by guid: ${node.entity.guid} ${entityUtils.findEntityByGuid(tree.get(["tree", "root"]), node.entity.guid)}`)

		// If node isn't currently in the tree for cut, paste node as-is, otherwise, create copy of the node to avoid duplicate GUIDs.
		// Lists for cut can only be done one at a time so we can handle this the same way as handlePaste
		if (tree.get("clipboardMode") === "cut" && !entityUtils.findEntityByGuid(tree.get(["tree", "root"]), node.entity.guid)) {
			console.log("Handle paste lists from cut by using clipboard node as-is, entity not found in tree");
			newNode = node;
			finalizePasteDependenciesForNodes(
				newNode,
				tree.get("clipboardExternalResources") || {},
				tree.get("clipboardRelatedItems") || {}
			);
		} else {
			console.log(`Handle paste lists do copy, clipboardMode: ${tree.get("clipboardMode")}`);
			newNode = deepCloneNodeFromClipboard(tree, node);
			/*
			const srcExternalResources = tree.get("clipboardExternalResources");
			const srcRelatedItems = tree.get("clipboardRelatedItems");

			let entityId = utils.generateUUID();
			const guid = utils.generateUUID();
			newNode = _.cloneDeep(node);
			newNode.entity.entityId = entityId;
			newNode.entity.guid = guid;
			newNode.entity = fixIftttStructureIds(newNode.entity);

			if (newNode.entity.groupNames && newNode.entity.groupNames.indexOf("#internal-templates") > -1) {
				newNode.entity.groupNames.splice(newNode.entity.groupNames.indexOf("#internal-templates"), 1);
			}

			const pastedExternalResources = {};
			const pastedRelatedItems = {};
			recurseEntityProps(newNode.entity, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);

			//newNode.entity.id = entityId;
			newNode.selected = false;

			if (newNode.hasOwnProperty("children")) {
				recurseUpdateIds(newNode.children);
				recursePasteEntries(newNode.children, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);
			}

			finalizePasteEntries(pastedExternalResources, pastedRelatedItems);
			*/
		}
	}

	/*
	} else if (tree.get("clipboardMode") === "cut") {
		newNode = tree.get("clipboard");
	}
	*/

	let index, arrPath;
	if (tree.get("clipboardMode") === "copy" || tree.get("clipboardMode") === "cut") {
		let cursor = tree.select(tree.select("selectedNodePath").get());
		// If pasting on the same type
		if (cursor.get().entity.type === "list") {
			if (positionType === "lastChild") {
				positionType = "after";
			}
		}
		// eslint-disable-next-line default-case
		switch (positionType) {
			case "firstChild":
				cursor.set("expanded", true);
				cursor.select("children").unshift(newNode);
				break;
			case "lastChild":
				cursor.set("expanded", true);
				//cursor.select("children").push(newNode);

				// if selected node is a List then just add the List otherwise add the children	
				if (newNode.entity.type === "list") {
					cursor.select("children").push(newNode);
				} else {
					cursor.select("children").concat(newNode.children);
				}

				break;
			case "before":
				unselectNode(tree);
				index = cursor.path[cursor.path.length - 1];
				cursor.up().splice([index, 0, newNode]);
				arrPath = Object.assign([], cursor.path);
				arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
				handleSelectNodeAtPath(tree, arrPath);
				break;
			case "after":
				// if selected node is a List then just add the List otherwise add the children	
				if (newNode.entity.type === "list") {
					index = cursor.path[cursor.path.length - 1];
					cursor.up().splice([index + 1, 0, newNode]);
				} else {
					let lists = cursor.up().get();

					index = cursor.path[cursor.path.length - 1];

					lists.splice(index + 1, 0, ...newNode.children);

					console.log(lists);

					cursor.up().set(["children"], lists);
				}

				break;
		}
	}

	saveUndoState();
}

function canPasteLists(tree) {
	// Check source content
	// All children must be a List node

	// Check destination
	// If Checklist node then append to children
	// If List node then append after selected

	let cursor = tree.select(tree.select("selectedNodePath").get());
	let selectedNode = cursor.get();
	let clipboardNode = tree.get("clipboard");

	if (!clipboardNode.hasOwnProperty("entity")) {
		return false;
	}

	if (clipboardNode.entity.type !== "checklist" && clipboardNode.entity.type !== "list") {
		alert("You have not copied any Lists to the clipboard.");
		return false;
	}

	if (selectedNode.entity.type === "checklist" || selectedNode.entity.type === "list") {
		return true;

	}

	alert("You can only paste Lists on the Actvitiy node (top-level root node) or another List node.");

	return false;
}

export function handlePasteSections(tree, positionType = "lastChild") {
	if (nothingSelected(tree)) {
		return;
	}
	if (tree.get("clipboard") === null) {
		return;
	}
	if (!canPasteSections(tree)) {
		return;
	}

	let newNode;
	let newSectionsChildren = [];

	if (tree.get("clipboardMode") === "copy" || tree.get("clipboardMode") === "cut") {
		//var copiedNodePath = tree.get("clipboard");

		let node = tree.get("clipboard");
		const authoringActivity = tree.get(["tree", "root"]);

		console.log(`Handle paste sections, clipboardMode: ${tree.get("clipboardMode")}`);

		if (tree.get("clipboardMode") === "cut" &&
			node.entity.type === "section" &&
			!entityUtils.findEntityByGuid(authoringActivity, node.entity.guid)) {
			// If node is section and isn't currently in the tree for cut, paste node as-is

			console.log("Handle paste sections from cut single section clipboard node as-is, entity not found in tree");
			newNode = node;
			finalizePasteDependenciesForNodes(
				newNode,
				tree.get("clipboardExternalResources") || {},
				tree.get("clipboardRelatedItems") || {}
			);

		} else if (tree.get("clipboardMode") === "cut" &&
			node.entity.type === "list") {

			console.log("Handle paste sections cut from from list");

			// Node is list, but still doing a cut, get children and replace existing sections with clones
			newNode = node;

			if (newNode.hasOwnProperty("children")) {
				recurseToSectionsChildren(newNode.children, newSectionsChildren);

				// For each section, check if GUID exists in tree, if so, clone the section
				for (let i = 0; i < newSectionsChildren.length; i++) {
					const section = newSectionsChildren[i];

					if (entityUtils.findEntityByGuid(authoringActivity, section.entity.guid)) {
						// Replace section with clone since it already exists in tree
						console.log(`Pasted section already exists: ${section.entity.guid}, create copy instead`);
						newSectionsChildren[i] = deepCloneNodeFromClipboard(tree, section);
					}
				}
				finalizePasteDependenciesForNodes(
					newSectionsChildren,
					tree.get("clipboardExternalResources") || {},
					tree.get("clipboardRelatedItems") || {}
				);
			}

		} else {
			// Do copy otherwise

			/*
			const srcExternalResources = tree.get("clipboardExternalResources");
			const srcRelatedItems = tree.get("clipboardRelatedItems");

			let entityId = utils.generateUUID();
			const guid = utils.generateUUID();
			newNode = _.cloneDeep(node);
			newNode.entity.entityId = entityId;
			newNode.entity.guid = guid;
			newNode.entity = fixIftttStructureIds(newNode.entity);

			if (newNode.entity.groupNames && newNode.entity.groupNames.indexOf("#internal-templates") > -1) {
				newNode.entity.groupNames.splice(newNode.entity.groupNames.indexOf("#internal-templates"), 1);
			}

			const pastedExternalResources = {};
			const pastedRelatedItems = {};
			recurseEntityProps(newNode.entity, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);

			newNode.selected = false;

			if (newNode.hasOwnProperty("children")) {
				recurseUpdateIds(newNode.children);
				recursePasteEntries(newNode.children, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);
			}

			finalizePasteEntries(pastedExternalResources, pastedRelatedItems);
			*/
			console.log(`Handle paste sections do copy, clipboardMode: ${tree.get("clipboardMode")}`);

			newNode = deepCloneNodeFromClipboard(tree, node);

			if (newNode.hasOwnProperty("children")) {
				// Need to recurse from top and push each section into children arr
				recurseToSectionsChildren(newNode.children, newSectionsChildren);
			}
		}
	}

	/*
	} else if (tree.get("clipboardMode") === "cut") {
		newNode = tree.get("clipboard");
	}
	*/

	let index;
	if (tree.get("clipboardMode") === "copy" || tree.get("clipboardMode") === "cut") {
		let cursor = tree.select(tree.select("selectedNodePath").get());
		// If pasting on the same type
		if (cursor.get().entity.type === "section") {
			if (positionType === "lastChild") {
				positionType = "after";
			}
		}
		// eslint-disable-next-line default-case
		switch (positionType) {
			case "lastChild":
				// if selected node is a Section then just add the Section otherwise add the children	
				if (newNode.entity.type === "section") {
					cursor.select("children").push(newNode);
				} else {
					cursor.select("children").concat(newSectionsChildren);
				}

				cursor.set("expanded", true);
				break;
			case "after":
				// if selected node is a List then just add the List otherwise add the children	
				if (newNode.entity.type === "section") {
					index = cursor.path[cursor.path.length - 1];
					cursor.up().splice([index + 1, 0, newNode]);
				} else {
					let sections = cursor.up().get();

					index = cursor.path[cursor.path.length - 1];

					sections.splice(index + 1, 0, ...newSectionsChildren);

					console.log(sections);

					cursor.up().set(["children"], sections);
				}




				break;
		}
	}

	saveUndoState();
}

function canPasteSections(tree) {
	// Check source content
	// All children must be a Section node

	// Check destination
	// If Checklist node then add list and append to children
	// If List node then append to children
	// If Section node then append after selected
	let cursor = tree.select(tree.select("selectedNodePath").get());
	let selectedNode = cursor.get();
	let clipboardNode = tree.get("clipboard");

	if (!clipboardNode.hasOwnProperty("entity")) {
		return false;
	}

	if (clipboardNode.entity.type !== "checklist" && clipboardNode.entity.type !== "list" && clipboardNode.entity.type !== "section") {
		alert("You have not copied any Sections to the clipboard.");
		return false;
	}

	if (selectedNode.entity.type === "checklist" && (selectedNode.children.length === 0 || selectedNode.children[0].entity.type === "section")) {
		return true;
	}

	if (selectedNode.entity.type === "list" || selectedNode.entity.type === "section") {
		return true;

	}

	alert("You can only paste Sections on a List node or another Section node or an Activity node (top-level root node) that already has Sections or is empty.");

	return false;
}

export function recurseToSectionsChildren(arr, resArr) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].entity.type === "list") {
			console.log("List: " + arr[i].entity.label);
			//resArr = resArr.concat(Object.assign([], arr[i].children));
		} else if (arr[i].entity.type === "section") {
			console.log("Section: " + arr[i].entity.label);
			resArr.push(Object.assign({}, arr[i]));
		} else if (arr[i].entity.type.startsWith("item")) {
			console.log("Item: " + arr[i].entity.label);
		}

		if (arr[i].hasOwnProperty("children")) {
			recurseToSectionsChildren(arr[i].children, resArr);
		}
	}
}

export function handlePasteItems(tree, positionType = "lastChild") {
	if (nothingSelected(tree)) {
		return;
	}
	if (tree.get("clipboard") === null) {
		return;
	}
	if (!canPasteItems(tree)) {
		return;
	}

	let newNode;
	let newItemsChildren = [];

	if (tree.get("clipboardMode") === "copy" || tree.get("clipboardMode") === "cut") {
		//var copiedNodePath = tree.get("clipboard");

		let node = tree.get("clipboard");
		const authoringActivity = tree.get(["tree", "root"]);

		console.log(`Handle paste items, clipboardMode: ${tree.get("clipboardMode")}`);

		if (tree.get("clipboardMode") === "cut" &&
			node.entity.type === "item" &&
			!entityUtils.findEntityByGuid(authoringActivity, node.entity.guid)) {
			// If node is item and isn't currently in the tree for cut, paste node as-is

			console.log("Handle paste items from cut single item clipboard node as-is, entity not found in tree");
			newNode = node;
			finalizePasteDependenciesForNodes(
				newNode,
				tree.get("clipboardExternalResources") || {},
				tree.get("clipboardRelatedItems") || {}
			);

		} else if (tree.get("clipboardMode") === "cut" &&
			(node.entity.type === "list" || node.entity.type === "section")) {

			console.log(`Handle paste sections cut from from ${node.entity.type}`);

			// Node is list or section, but still doing a cut, get children and replace existing sections with clones
			newNode = node;

			if (newNode.hasOwnProperty("children")) {
				recurseToItemsChildren(newNode.children, newItemsChildren);

				// For each section, check if GUID exists in tree, if so, clone the section
				for (let i = 0; i < newItemsChildren.length; i++) {
					const item = newItemsChildren[i];

					if (entityUtils.findEntityByGuid(authoringActivity, item.entity.guid)) {
						// Replace item with clone since it already exists in tree
						console.log(`Pasted item already exists: ${item.entity.guid}, create copy instead`);
						newItemsChildren[i] = deepCloneNodeFromClipboard(tree, item);
					}
				}
				finalizePasteDependenciesForNodes(
					newItemsChildren,
					tree.get("clipboardExternalResources") || {},
					tree.get("clipboardRelatedItems") || {}
				);
			}
		} else {
			/*
			const srcExternalResources = tree.get("clipboardExternalResources");
			const srcRelatedItems = tree.get("clipboardRelatedItems");
	
			let entityId = utils.generateUUID();
			const guid = utils.generateUUID();
			newNode = _.cloneDeep(node);
			newNode.entity.entityId = entityId;
			newNode.entity.guid = guid;
			newNode.selected = false;
			newNode.entity = fixIftttStructureIds(newNode.entity);
	
			if (newNode.entity.groupNames && newNode.entity.groupNames.indexOf("#internal-templates") > -1) {
				newNode.entity.groupNames.splice(newNode.entity.groupNames.indexOf("#internal-templates"), 1);
			}
	
			const pastedExternalResources = {};
			const pastedRelatedItems = {};
			recurseEntityProps(newNode.entity, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);
	
			if (newNode.hasOwnProperty("children")) {
				recurseUpdateIds(newNode.children);
				recursePasteEntries(newNode.children, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);
			}
	
			finalizePasteEntries(pastedExternalResources, pastedRelatedItems);
			*/
			console.log(`Handle paste items do copy, clipboardMode: ${tree.get("clipboardMode")}`);
			newNode = deepCloneNodeFromClipboard(tree, node);

			if (newNode.hasOwnProperty("children")) {
				// Need to recurse from top and push each section into children arr
				recurseToItemsChildren(newNode.children, newItemsChildren);
			}
		}
	}

	/*	
	} else if (tree.get("clipboardMode") === "cut") {
		newNode = tree.get("clipboard");
	}
	*/

	let index;
	if (tree.get("clipboardMode") === "copy" || tree.get("clipboardMode") === "cut") {
		let cursor = tree.select(tree.select("selectedNodePath").get());
		const selectedType = _.get(cursor.get(), "entity.type", "");
		const pastedType = _.get(newNode, "entity.type", "");
		const effectivePastedType = isItemTypeForPaste(pastedType) ? pastedType : "item";
		positionType = resolvePastePositionType(tree, selectedType, effectivePastedType, positionType);
		// eslint-disable-next-line default-case
		switch (positionType) {
			case "lastChild":
				cursor.set("expanded", true);
				// if selected node is an Item then just add the Section otherwise add the children	
				if (newNode.entity.type.startsWith("item")) {
					cursor.select("children").push(newNode);
				} else {
					cursor.select("children").concat(newItemsChildren);
				}
				break;
			case "after":
				// if selected node is an Item then just add the Item otherwise add the children	
				if (newNode.entity.type.startsWith("item")) {
					index = cursor.path[cursor.path.length - 1];
					cursor.up().splice([index + 1, 0, newNode]);
				} else {
					let items = cursor.up().get();

					index = cursor.path[cursor.path.length - 1];

					items.splice(index + 1, 0, ...newItemsChildren);

					console.log(items);

					cursor.up().set(["children"], items);
				}

				break;
		}
	}

	saveUndoState();
}

export function recurseToItemsChildren(arr, resArr) {
	for (let i = 0; i < arr.length; i++) {
		if (arr[i].entity.type === "list") {
			console.log("List: " + arr[i].entity.label);
		} else if (arr[i].entity.type === "section") {
			console.log("Section: " + arr[i].entity.label);
		} else if (arr[i].entity.type.startsWith("item")) {
			console.log("Item: " + arr[i].entity.label);
			resArr.push(Object.assign({}, arr[i]));
		}

		if (arr[i].hasOwnProperty("children")) {
			recurseToItemsChildren(arr[i].children, resArr);
		}
	}
}

function canPasteItems(tree) {
	// Check source content
	// All children must be an Item node

	// Check destination
	// If Checklist node then append list and section then to children
	// If List node then append section then to children
	// If Section node then append to children
	// If Item node then append after selected
	let cursor = tree.select(tree.select("selectedNodePath").get());
	let selectedNode = cursor.get();
	let clipboardNode = tree.get("clipboard");

	if (!clipboardNode.hasOwnProperty("entity")) {
		return false;
	}

	if (clipboardNode.entity.type !== "checklist" && clipboardNode.entity.type !== "list" && clipboardNode.entity.type !== "section" && !clipboardNode.entity.type.startsWith("item")) {
		alert("You have not copied any Items to the clipboard.");
		return false;
	}

	if (selectedNode.entity.type === "checklist" && (selectedNode.children.length === 0 || selectedNode.children[0].entity.type.startsWith("item"))) {
		return true;
	}

	if (selectedNode.entity.type === "section" || selectedNode.entity.type.startsWith("item")) {
		return true;

	}

	alert("You can only paste Items on a Section node or another Item node or an Activity node (top-level root node) that already has Items or is empty.");

	return false;
}

// Need to deal with named id's as well
function recurseUpdateIds(arr, opts) {
	for (let i = 0; i < arr.length; i++) {
		let entityId = utils.generateUUID();
		let guid = utils.generateUUID();
		arr[i].entity.entityId = entityId;
		arr[i].entity.guid = guid;
		arr[i].entity = fixIftttStructureIds(arr[i].entity);
		if (arr[i].hasOwnProperty("children")) {
			recurseUpdateIds(arr[i].children);
		}
	}
}

function recursePasteEntries(arr, externalResources, pastedExternalResources, relatedItems, pastedRelatedItems) {
	for (let i = 0; i < arr.length; i++) {
		recurseEntityProps(arr[i].entity, externalResources, pastedExternalResources, relatedItems, pastedRelatedItems);

		if (arr[i].hasOwnProperty("children")) {
			recursePasteEntries(arr[i].children, externalResources, pastedExternalResources, relatedItems, pastedRelatedItems);
		}
	}
}

function recurseEntityProps(entity, externalResources, pastedExternalResources, relatedItems, pastedRelatedItems) {
	// Loop through every property of an entity
	for (const [key, value] of Object.entries(entity)) {
		console.log(`${key}: ${value}`);

		// If value has an array then can loop through them...e.g. choiceItems, pickerItems
		if (Array.isArray(value)) {
			value.forEach((item) => {
				recurseEntityProps(item, externalResources, pastedExternalResources, relatedItems, pastedRelatedItems);
			});
			// If valid drive entry
		} else if (typeof value === "object" && value !== null && value.hasOwnProperty("type") && value.hasOwnProperty("refId") && externalResources.hasOwnProperty(value.refId)) {
			pastedExternalResources[value.refId] = externalResources[value.refId];
			// If has related item refs	
		} else if (key === "relatedItemRefs" && value !== "") {
			// Can be one to many related item refs
			const relatedItemRefsParts = value.split(",");

			relatedItemRefsParts.forEach((relatedItemRef) => {
				// This is cool, related items can also have drive entries so need to add those if that is the case
				recurseEntityProps(relatedItems[relatedItemRef], externalResources, pastedExternalResources, relatedItems, pastedRelatedItems);

				pastedRelatedItems[relatedItemRef] = relatedItems[relatedItemRef];
			});
		}
	}
}

export function handleMoveNode(tree, type, srcIndex, dstIndex) {
	unselectNode(tree);

	if (type === "root") {
		let arrList = tree.get(["tree", "root", "children"]);

		arrList.splice(dstIndex, 0, arrList.splice(srcIndex, 1)[0]);

		tree.set(["tree", "root", "children"], Object.assign([], arrList));

		let arrPath = Object.assign([], ["tree", "root", "children", dstIndex]);

		handleSelectNodeAtPath(tree, arrPath);

		saveUndoState();
	} else {
		let entityChildren = { found: false };
		entityUtils.findEntityChildrenById(tree.get(["tree", "root", "children"]), type, entityChildren);
		if (entityChildren.found) {
			let arrNode = entityChildren.result;
			arrNode.splice(dstIndex, 0, arrNode.splice(srcIndex, 1)[0]);

			let entity = { found: false };
			entityUtils.findEntityIndicesById(tree.get(["tree", "root", "children"]), type, entity);

			if (entity.found) {
				if (entity.result.type === "list" && entity.result.listIndex > -1) {
					tree.set(["tree", "root", "children", entity.result.listIndex, "children"], Object.assign([], arrNode));
					const arrPathList = Object.assign([], ["tree", "root", "children", entity.result.listIndex, "children", dstIndex]);
					handleSelectNodeAtPath(tree, arrPathList);
				} else if (entity.result.type === "section" && entity.result.listIndex > -1) {
					tree.set(["tree", "root", "children", entity.result.listIndex, "children", entity.result.sectionIndex, "children"], Object.assign([], arrNode));
					const arrPathSection = Object.assign([], ["tree", "root", "children", entity.result.listIndex, "children", entity.result.sectionIndex, "children", dstIndex]);
					handleSelectNodeAtPath(tree, arrPathSection);
				} else if (entity.result.type === "section" && entity.result.listIndex === -1) {
					tree.set(["tree", "root", "children", entity.result.sectionIndex, "children"], Object.assign([], arrNode));
					const arrPathSection = Object.assign([], ["tree", "root", "children", entity.result.sectionIndex, "children", dstIndex]);
					handleSelectNodeAtPath(tree, arrPathSection);
				}

				saveUndoState();
			}
		}
	}
}

export function handleMoveNodeUp(tree, cursor) {
	if (nothingSelected(tree)) {
		return;
	}
	if (isTreeRoot(cursor)) {
		return;
	}

	// TODO: Quick fix...proper way to do is figure out how things get out of sync
	handleCollapseNode(cursor);

	let node = cursor.get();

	let index = cursor.path[cursor.path.length - 1];
	if (index > 0) {
		unselectNode(tree);
		cursor.up().splice([index, 1]);
		cursor.up().splice([index - 1, 0, node]);

		let arrPath = Object.assign([], cursor.path);
		arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] - 1;
		handleSelectNodeAtPath(tree, arrPath);

		saveUndoState();
	}
}

export function handleMoveNodeDown(tree, cursor) {
	if (nothingSelected(tree)) {
		return;
	}
	if (isTreeRoot(cursor)) {
		return;
	}

	// TODO: Quick fix...proper way to do is figure out how things get out of sync
	handleCollapseNode(cursor);
	let node = cursor.get();

	let index = cursor.path[cursor.path.length - 1];
	if (index < (cursor.up().get().length - 1)) {
		unselectNode(tree);
		cursor.up().splice([index, 1]);
		cursor.up().splice([index + 1, 0, node]);

		let arrPath = Object.assign([], cursor.path);
		arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
		handleSelectNodeAtPath(tree, arrPath);

		saveUndoState();
	}
}

export function handleAddCategory(tree, cursor, positionType = "lastChild") {
	if (nothingSelected(tree)) {
		return;
	}

	let entity = entityUtils.addCategoryEntity(utils.generateUUID(), "(New Category)", true);
	let node = entityUtils.addCategoryNode(entity, false);

	if (cursor.get().entity.type !== "category") {
		if (positionType === "lastChild") {
			positionType = "after";
		}
	}
	let index, arrPath;
	switch (positionType) {
		case "firstChild":
			cursor.set("expanded", true);
			cursor.select("children").unshift(node);
			break;
		case "lastChild":
			cursor.set("expanded", true);
			cursor.select("children").push(node);
			break;
		case "before":
			unselectNode(tree);
			index = cursor.path[cursor.path.length - 1];
			cursor.up().splice([index, 0, node]);
			arrPath = Object.assign([], cursor.path);
			arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
			handleSelectNodeAtPath(tree, arrPath);
			break;
		case "after":
			index = cursor.path[cursor.path.length - 1];
			cursor.up().splice([index + 1, 0, node]);
			break;
		default:
	}
	saveUndoState();
}

export function handleAddList(tree, cursor, positionType = "lastChild") {
	if (nothingSelected(tree)) {
		return;
	}

	let entity = entityUtils.addListEntity(utils.generateUUID(), "", true);
	let node = entityUtils.addCategoryNode(entity, true);
	let sectionEntity = entityUtils.addSectionEntity(utils.generateUUID(), "");
	let sectionNode = entityUtils.addCategoryNode(sectionEntity, true);
	node.children.push(sectionNode);
	let itemEntity = entityUtils.addItemEntity(utils.generateUUID(), "", "", false, false, "");
	let itemNode = entityUtils.addItemNode(itemEntity);
	sectionNode.children.push(itemNode);
	if (cursor.get().entity.type === "list") {
		if (positionType === "lastChild") {
			positionType = "after";
		}
	}
	let index, len, arrPath;
	switch (positionType) {
		case "firstChild":
			if (cursor.get().entity.type === "checklist") {
				cursor.set("expanded", true);
				cursor.select("children").unshift(node);
				scrollSelectedNodeIntoView();
				break;
			}
			break;
		case "lastChild":
			if (cursor.get().entity.type === "checklist") {
				if (cursor.get("children").length === 0 || cursor.get("children")[0].entity.type === "list") {
					unselectNode(tree);

					cursor.set("expanded", true);
					cursor.select("children").push(node);

					len = cursor.get("children").length;

					arrPath = Object.assign([], cursor.path);
					arrPath.push("children");
					arrPath.push(len - 1);
					handleSelectNodeAtPath(tree, arrPath);
					scrollSelectedNodeIntoView();
					// Migrate collection of items to this section
				} else if (cursor.get("children")[0].entity.type === "section") {
					node.expanded = true;
					node.children = cursor.get("children");
					cursor.select("children").splice([0, node.children.length]);

					unselectNode(tree);

					cursor.set("expanded", true);
					cursor.select("children").push(node);

					len = cursor.get("children").length;

					arrPath = Object.assign([], cursor.path);
					arrPath.push("children");
					arrPath.push(len - 1);
					handleSelectNodeAtPath(tree, arrPath);
					scrollSelectedNodeIntoView();
				} else if (cursor.get("children")[0].entity.type.startsWith("item")) {
					showError("Invalid", "You can only add a List when all of the children of this node are Sections. First add a Section then you will be able to add a List.");
				} else {
					showError("Invalid", "You can't add a List here. You can only add a List to the root node which is the Checklist.");
				}
				break;
			} else {
				showError("Invalid", "You can't add a List here. You can only add a List to the root node which is the Checklist.");
			}
			break;
		case "before":
			if (cursor.get().entity.type === "list") {
				unselectNode(tree);
				index = cursor.path[cursor.path.length - 1];
				cursor.up().splice([index, 0, node]);
				arrPath = Object.assign([], cursor.path);
				arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
				handleSelectNodeAtPath(tree, arrPath);
				scrollSelectedNodeIntoView();
				break;
			}
			break;
		case "after":
			if (cursor.get().entity.type === "list") {
				unselectNode(tree);

				index = cursor.path[cursor.path.length - 1];
				cursor.up().splice([index + 1, 0, node]);

				arrPath = Object.assign([], cursor.path);
				arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
				handleSelectNodeAtPath(tree, arrPath);
				scrollSelectedNodeIntoView();
				break;
			} else {
				showError("Invalid", "You can't add a List here. You can only add a List to the root node which is the Checklist.");
			}
			break;
		default:
	}
	saveUndoState();
}

export function handleAddSection(tree, cursor, positionType = "lastChild") {
	if (nothingSelected(tree)) {
		return;
	}

	let entity = entityUtils.addSectionEntity(utils.generateUUID(), "", true);
	let node = entityUtils.addCategoryNode(entity, true);
	let itemEntity = entityUtils.addItemEntity(utils.generateUUID(), "", "", false, false, "");
	let itemNode = entityUtils.addItemNode(itemEntity);
	node.children.push(itemNode);

	if (cursor.get().entity.type === "section") {
		if (positionType === "lastChild") {
			positionType = "after";
		}
	}
	let index, len, arrPath;
	switch (positionType) {
		case "firstChild":
			if (cursor.get().entity.type === "checklist" || cursor.get().entity.type === "list") {
				cursor.set("expanded", true);
				cursor.select("children").unshift(node);
				scrollSelectedNodeIntoView();
				break;
			}
			break;
		case "lastChild":
			if (cursor.get().entity.type === "checklist" || cursor.get().entity.type === "list") {
				// Check to see that first child is a isection
				if (cursor.get("children").length === 0 || cursor.get("children")[0].entity.type === "section") {
					unselectNode(tree);

					cursor.set("expanded", true);
					cursor.select("children").push(node);

					len = cursor.get("children").length;

					arrPath = Object.assign([], cursor.path);
					arrPath.push("children");
					arrPath.push(len - 1);
					handleSelectNodeAtPath(tree, arrPath);
					scrollSelectedNodeIntoView();
					// Migrate collection of items to this section
				} else if (cursor.get("children")[0].entity.type.startsWith("item")) {
					node.expanded = true;
					node.children = cursor.get("children");
					cursor.select("children").splice([0, node.children.length]);

					unselectNode(tree);

					cursor.set("expanded", true);
					cursor.select("children").push(node);

					len = cursor.get("children").length;

					arrPath = Object.assign([], cursor.path);
					arrPath.push("children");
					arrPath.push(len - 1);
					handleSelectNodeAtPath(tree, arrPath);
					scrollSelectedNodeIntoView();
				} else {
					showError("Invalid", "You can't add a Section here. A Section should be added to a List.");
				}

				break;
			} else {
				showError("Invalid", "You can't add a Section here. A Section should be added to a List.");
			}
			break;
		case "before":
			if (cursor.get().entity.type === "section") {
				unselectNode(tree);
				index = cursor.path[cursor.path.length - 1];
				cursor.up().splice([index, 0, node]);
				arrPath = Object.assign([], cursor.path);
				arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
				handleSelectNodeAtPath(tree, arrPath);
				scrollSelectedNodeIntoView();
				break;
			}
			break;
		case "after":
			if (cursor.get().entity.type === "section") {
				unselectNode(tree);

				index = cursor.path[cursor.path.length - 1];
				cursor.up().splice([index + 1, 0, node]);

				arrPath = Object.assign([], cursor.path);
				arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
				handleSelectNodeAtPath(tree, arrPath);
				scrollSelectedNodeIntoView();
				break;
			} else {
				showError("Invalid", "You can't add a Section here. A Section should be added to a List.");
			}
			break;
		default:
	}
	saveUndoState();
}

export function handleAddItem(tree, cursor, positionType = "lastChild", type = "item") {
	if (nothingSelected(tree)) {
		return;
	}

	let effectiveCursor = cursor;
	let cursorType = effectiveCursor.get().entity.type;
	let cursorIsItemContainer = isItemContainerType(cursorType);
	let entityId = utils.generateUUID();


	let entity = entityUtils.addItemEntity(entityId, "", "", type === "itemLabelOnly" ? true : false, false, "", type === "itemLabelOnly" ? "item" : type);

	if (type === "itemLabelOnly") {
		type = "item";
	}

	const addingItemContainer = isItemContainerType(type);
	let node = entityUtils.addItemNode(entity, addingItemContainer);

	// If a child item inside a container is selected while adding a container,
	// normalize the cursor to the container parent.
	if (addingItemContainer && _.isString(cursorType) && cursorType.startsWith("item") && !cursorIsItemContainer) {
		const parentCursor = effectiveCursor.up();
		const parentType = parentCursor ? _.get(parentCursor.get(), "entity.type", "") : "";
		if (isItemContainerType(parentType)) {
			effectiveCursor = parentCursor;
			cursorType = effectiveCursor.get().entity.type;
			cursorIsItemContainer = true;
		}
	}

	if (_.isString(cursorType) && cursorType.startsWith("item") && !cursorIsItemContainer) {
		if (positionType === "lastChild") {
			positionType = "after";
		}
	}

	let index, len, arrPath;
	const canAddAsChild = (cursorType === "section" || cursorType === "checklist" || cursorIsItemContainer);
	if (canAddAsChild && !_.isArray(effectiveCursor.get("children"))) {
		effectiveCursor.set("children", []);
	}
	switch (positionType) {
		case "firstChild":
			if (canAddAsChild) {
				effectiveCursor.set("expanded", true);
				effectiveCursor.select("children").unshift(node);
				scrollSelectedNodeIntoView();
				handleChangeItemType(tree, type);
				break;
			} else {
				showError("Invalid", "You can't add an Item here. An Item should be added to a Section or Item Container.");
			}
			break;
		case "lastChild":
			if (canAddAsChild) {
				// Check to see that first child is an item
				if (effectiveCursor.get("children").length === 0 || effectiveCursor.get("children")[0].entity.type.startsWith("item")) {
					unselectNode(tree);

					effectiveCursor.set("expanded", true);
					effectiveCursor.select("children").push(node);

					len = effectiveCursor.get("children").length;

					arrPath = Object.assign([], effectiveCursor.path);
					arrPath.push("children");
					arrPath.push(len - 1);
					handleSelectNodeAtPath(tree, arrPath);
					scrollSelectedNodeIntoView();
					handleChangeItemType(tree, type);

				} else {
					showError("Invalid", "You can't add an Item here. An Item should be added to a Section or Item Container.");
				}
				break;
			} else {
				showError("Invalid", "You can't add an Item here. An Item should be added to a Section or Item Container.");
			}
			break;
		case "before":
			if (effectiveCursor.get().entity.type.startsWith("item")) {
				unselectNode(tree);
				index = effectiveCursor.path[effectiveCursor.path.length - 1];
				effectiveCursor.up().splice([index, 0, node]);
				arrPath = Object.assign([], effectiveCursor.path);
				arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
				handleSelectNodeAtPath(tree, arrPath);
				scrollSelectedNodeIntoView();
				handleChangeItemType(tree, type);
				break;
			}
			break;
		case "after":
			if (effectiveCursor.get().entity.type.startsWith("item")) {
				unselectNode(tree);

				index = effectiveCursor.path[effectiveCursor.path.length - 1];
				effectiveCursor.up().splice([index + 1, 0, node]);

				arrPath = Object.assign([], effectiveCursor.path);
				arrPath[arrPath.length - 1] = arrPath[arrPath.length - 1] + 1;
				handleSelectNodeAtPath(tree, arrPath);
				scrollSelectedNodeIntoView();
				handleChangeItemType(tree, type);
				break;
			} else {
				showError("Invalid", "You can't add an Item here. An Item should be added to a Section.");
			}
			break;
		default:
	}

	saveUndoState();
}

function pushNodesToCursorChildren(cursor, nodes = []) {
	if (!_.isArray(cursor.get("children"))) {
		cursor.set("children", []);
	}
	cursor.set("expanded", true);
	nodes.forEach((node) => cursor.select("children").push(node));
}

function selectFirstInsertedChild(tree, parentCursor, previousLength) {
	const selectedPath = Object.assign([], parentCursor.path);
	selectedPath.push("children");
	selectedPath.push(previousLength);
	unselectNode(tree);
	handleSelectNodeAtPath(tree, selectedPath);
}

export function handleInsertAssetFolder(tree, config = {}) {
	if (nothingSelected(tree)) {
		return false;
	}

	const selectedNodePath = tree.select("selectedNodePath").get();
	const selectedCursor = tree.select(selectedNodePath);
	const selectedNode = selectedCursor.get();
	const selectedType = `${_.get(selectedNode, "entity.type", "")}`.trim();
	const effectiveStructurePreset = getEffectiveAssetFolderStructurePreset(selectedType, config.structurePreset, "outline");
	const buildConfig = {
		...config,
		structurePreset: effectiveStructurePreset,
		createAssetReference: (asset) => {
			const driveObject = asset && asset.driveObject;
			if (!driveObject || !driveObject.guid) {
				return null;
			}
			const refId = addExternalResource(driveObject, createAssetFolderResourceMetadata(asset, config));
			return getResourceReference(refId);
		}
	};
	const nodes = buildAssetFolderNodes(buildConfig);
	if (_.isEmpty(nodes)) {
		showError("Asset Folder Import", "No supported image assets were available to insert.");
		return false;
	}

	let inserted = false;
	let firstInsertedPath = null;

	if (selectedType === "section") {
		const previousLength = _.isArray(selectedCursor.get("children")) ? selectedCursor.get("children").length : 0;
		const itemNodes = effectiveStructurePreset === ASSET_FOLDER_STRUCTURE_ITEMS ? nodes : buildAssetFolderNodes({ ...buildConfig, structurePreset: ASSET_FOLDER_STRUCTURE_ITEMS });
		pushNodesToCursorChildren(selectedCursor, itemNodes);
		selectFirstInsertedChild(tree, selectedCursor, previousLength);
		inserted = true;
	} else if (selectedType.startsWith("item")) {
		const itemNodes = effectiveStructurePreset === ASSET_FOLDER_STRUCTURE_ITEMS ? nodes : buildAssetFolderNodes({ ...buildConfig, structurePreset: ASSET_FOLDER_STRUCTURE_ITEMS });
		const parentCursor = selectedCursor.up();
		const insertIndex = Number(selectedCursor.path[selectedCursor.path.length - 1]) + 1;
		unselectNode(tree);
		parentCursor.splice([insertIndex, 0, ...itemNodes]);
		firstInsertedPath = Object.assign([], parentCursor.path);
		firstInsertedPath.push(insertIndex);
		handleSelectNodeAtPath(tree, firstInsertedPath);
		inserted = true;
	} else if (selectedType === "list") {
		const sectionNodes = effectiveStructurePreset === ASSET_FOLDER_STRUCTURE_SECTIONS ? nodes : buildAssetFolderNodes({ ...buildConfig, structurePreset: ASSET_FOLDER_STRUCTURE_SECTIONS });
		const previousLength = _.isArray(selectedCursor.get("children")) ? selectedCursor.get("children").length : 0;
		pushNodesToCursorChildren(selectedCursor, sectionNodes);
		selectFirstInsertedChild(tree, selectedCursor, previousLength);
		inserted = true;
	} else if (selectedType === "checklist") {
		const previousLength = _.isArray(selectedCursor.get("children")) ? selectedCursor.get("children").length : 0;
		pushNodesToCursorChildren(selectedCursor, nodes);
		selectFirstInsertedChild(tree, selectedCursor, previousLength);
		inserted = true;
	} else {
		showError("Asset Folder Import", "Select an activity, list, section, or item before importing an image folder.");
		return false;
	}

	if (inserted) {
		state.commit();
		saveUndoState();
		scrollSelectedNodeIntoView();
	}

	return inserted;
}

export function handleInsertPowerPointImport(tree, config = {}) {
	if (nothingSelected(tree)) {
		return false;
	}

	const selectedNodePath = tree.select("selectedNodePath").get();
	const selectedCursor = tree.select(selectedNodePath);
	const selectedNode = selectedCursor.get();
	const selectedType = `${_.get(selectedNode, "entity.type", "")}`.trim();
	const effectiveStructurePreset = getEffectiveAssetFolderStructurePreset(selectedType, config.structurePreset, "outline");
	const buildConfig = {
		...config,
		structurePreset: effectiveStructurePreset,
		createAssetReference: (asset) => {
			const driveObject = asset && asset.driveObject;
			if (!driveObject || !driveObject.guid) {
				return null;
			}
			const refId = addExternalResource(driveObject, createAssetFolderResourceMetadata(asset, config));
			return getResourceReference(refId);
		}
	};
	const nodes = buildPowerPointImportNodes(buildConfig);
	if (_.isEmpty(nodes)) {
		showError("PowerPoint Import", "No PowerPoint slides were available to insert.");
		return false;
	}

	let inserted = false;
	let firstInsertedPath = null;

	if (selectedType === "section") {
		const previousLength = _.isArray(selectedCursor.get("children")) ? selectedCursor.get("children").length : 0;
		const itemNodes = effectiveStructurePreset === ASSET_FOLDER_STRUCTURE_ITEMS ? nodes : buildPowerPointImportNodes({ ...buildConfig, structurePreset: ASSET_FOLDER_STRUCTURE_ITEMS });
		pushNodesToCursorChildren(selectedCursor, itemNodes);
		selectFirstInsertedChild(tree, selectedCursor, previousLength);
		inserted = true;
	} else if (selectedType.startsWith("item")) {
		const itemNodes = effectiveStructurePreset === ASSET_FOLDER_STRUCTURE_ITEMS ? nodes : buildPowerPointImportNodes({ ...buildConfig, structurePreset: ASSET_FOLDER_STRUCTURE_ITEMS });
		const parentCursor = selectedCursor.up();
		const insertIndex = Number(selectedCursor.path[selectedCursor.path.length - 1]) + 1;
		unselectNode(tree);
		parentCursor.splice([insertIndex, 0, ...itemNodes]);
		firstInsertedPath = Object.assign([], parentCursor.path);
		firstInsertedPath.push(insertIndex);
		handleSelectNodeAtPath(tree, firstInsertedPath);
		inserted = true;
	} else if (selectedType === "list") {
		const sectionNodes = effectiveStructurePreset === ASSET_FOLDER_STRUCTURE_SECTIONS ? nodes : buildPowerPointImportNodes({ ...buildConfig, structurePreset: ASSET_FOLDER_STRUCTURE_SECTIONS });
		const previousLength = _.isArray(selectedCursor.get("children")) ? selectedCursor.get("children").length : 0;
		pushNodesToCursorChildren(selectedCursor, sectionNodes);
		selectFirstInsertedChild(tree, selectedCursor, previousLength);
		inserted = true;
	} else if (selectedType === "checklist") {
		const previousLength = _.isArray(selectedCursor.get("children")) ? selectedCursor.get("children").length : 0;
		pushNodesToCursorChildren(selectedCursor, nodes);
		selectFirstInsertedChild(tree, selectedCursor, previousLength);
		inserted = true;
	} else {
		showError("PowerPoint Import", "Select an activity, list, section, or item before importing a PowerPoint.");
		return false;
	}

	if (inserted) {
		state.commit();
		saveUndoState();
		scrollSelectedNodeIntoView();
	}

	return inserted;
}

function isOffScreen(el, scrollView) {
	// console.log(el.offsetHeight, el.offsetTop, el.scrollTop, scrollView.offsetHeight, scrollView.clientHeight, scrollView.scrollHeight, scrollView.scrollTop);

	const elOffsetTop = el.offsetTop;
	const elOffsetHeight = el.offsetHeight;
	const scrollViewScrollTop = scrollView.scrollTop;
	// const scrollViewScrollHeight = scrollView.scrollHeight;
	const scrollViewOffsetHeight = scrollView.offsetHeight;

	return (elOffsetTop < scrollViewScrollTop) || (elOffsetHeight + elOffsetTop > scrollViewScrollTop + scrollViewOffsetHeight);
}

export function scrollSelectedNodeIntoView() {
	setTimeout(() => {
		const path = state.get("selectedNodePath");
		if (path && _.isArray(path)) {
			const scrollView = document.getElementById("editor-scroll-view");
			const el = document.getElementById(`node-${path.join(".")}`);
			if (el) {
				const offScreen = isOffScreen(el, scrollView);
				// const fullyVisible = inViewport(el, { offset: -100 });
				console.log("Off screen", offScreen);
				if (el && el.scrollIntoView && offScreen) {
					el.scrollIntoView({ behavior: "smooth", block: "start" });
				}
			}
		}
	}, 100);
}

function recurseCollapse(cursor) {
	while (cursor !== null) {
		cursor.set("expanded", false);

		if (cursor.get().hasOwnProperty("children") && cursor.get().children.length > 0) {
			recurseCollapse(cursor.select("children").down());
		}

		cursor = cursor.right();
	}
}

function recurseExpand(cursor) {
	while (cursor !== null) {
		cursor.set("expanded", true);

		if (cursor.get().hasOwnProperty("children") && cursor.get().children.length > 0) {
			recurseExpand(cursor.select("children").down());
		}

		cursor = cursor.right();
	}
}

function recurseRefreshVisible(cursorParent, cursor) {
	while (cursor !== null) {
		if (cursor.get("expanded") === true || (cursorParent !== null && cursorParent.get("expanded") === true)) {
			//console.log(cursor.path);
			_visiblePaths.push(cursor.path);
		}

		if (cursor.get().hasOwnProperty("children") && cursor.get().children.length > 0) {
			recurseRefreshVisible(cursor, cursor.select("children").down());
		}

		if (cursor.path.length > 2) {
			cursor = cursor.right();
		} else {
			cursor = null;
		}
	}
}

export function receiveHistory(identityId) {
	awsS3.getHistory(state, identityId);

	// When gets history will set state which will cause re-render of history view
}

export function clearHistory(tree) {
	tree.set(["checklistHistory"], null);
}

export function openPreviewModal(tree, hit, scope) {
	// Get JSON and after retrieved set state

	awsS3.previewJsonFromS3(tree, env.s3.contentBucket, hit.id + ".json", scope, hit).then(() => {
		console.log("Select activity");
		tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, hit.id);
	});
}

export function showDocumentsSpinner() {
	state.set(["appState", "documents", "showSpinner"], true);
}

export function hideDocumentsSpinner() {
	state.set(["appState", "documents", "showSpinner"], false);
}

export function setDocumentsSpinnerMessage(message) {
	state.set(["appState", "documents", "spinnerMessage"], message);
}

export function openPreviewModalForActivities(tree, identityId, activityId, scope) {
	// Get JSON and after retrieved set state
	showDocumentsSpinner();
	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, activityId);

	// Get JSON and after retrieved set state
	awsS3.previewJsonForIdentityFromS3(tree, env.s3.contentBucket, identityId, activityId + ".json", scope).finally(() => {
		hideDocumentsSpinner();
	});
}

export function closePreviewModal(tree) {
	try {
		if (window.speechSynthesis) {
			window.speechSynthesis.cancel();
		}
		if (window.audioFaultInterval) {
			clearInterval(window.audioFaultInterval);
			window.audioFaultInterval = null;
		}
		const audioElement = document.getElementById("page_audio");
		if (audioElement) {
			if (!audioElement.paused) {
				audioElement.pause();
				audioElement.currentTime = 0;
			}
			delete audioElement.src;
		}
	} catch (e) {
		console.warn(e);
	}
	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, "");
	// tree.set(["appState", "previewChecklist", "showModal"], false);
	clearAppState(tree);
}

export function openStartupModal(tree) {
	tree.set(["appState", "startupModal", "showModal"], true);
}

export function closeStartupModal(tree, startupModalDontShowAgain) {
	// Use local storage
	utils.setLs(tree.get(["user", "username"]) + ";startupModalDontShowAgain", startupModalDontShowAgain);
	tree.set(["appState", "startupModal", "showModal"], false);
}


export function showWorkflowModalForMultiple(tree) {
	awsS3.showWorkflowForMultiple(tree, env.s3.contentBucket);
}

export async function saveWorkflowForMultiple(tree, data, fileName) {
	return await awsS3.saveWorkflow(env.s3.contentBucket, fileName, data);
}

export function closeWorkflowModalForMultiple(tree) {
	tree.set(["appState", "showWorkflowForMultiple", "showModal"], false);
}

export function showWorkflowModal(tree, url) {
	// Get JSON and after retrieved set state
	awsS3.showWorkflow(tree, env.s3.contentBucket, url);
}

export async function saveWorkflow(tree, data) {
	const fileName = tree.get(["appState", "showWorkflow", "url"]);

	return await awsS3.saveWorkflow(env.s3.contentBucket, fileName, data);
}

// Close either modal at once
export function closeWorkflowModal(tree) {
	tree.set(["appState", "showWorkflow", "showModal"], false);
	// tree.set(["appState", "showWorkflow", "checklist"], {});
	tree.set(["appState", "showWorkflow", "url"], "");
	tree.set(["appState", "showWorkflowForMultiple", "showModal"], false);
	// tree.set(["appState", "showWorkflowForMultiple", "checklist"], {});
}

export function showNotesModal(tree, hit) {
	// Get JSON and after retrieved set state
	tree.set(["appState", "showNotes", "instance"], hit);

	// Need to pass in sessionNameResolved as well
	awsS3.showNotes(tree, env.s3.contentBucket, hit.url, hit.sessionName);
}

export function closeNotesModal(tree) {
	tree.set(["appState", "showNotes", "showModal"], false);
}

export function showStatusSpinner(tree = state) {
	console.log("SHOW STATUS SPINNER");
	tree.set(["appState", "status", "showSpinner"], true);
}
export function hideStatusSpinner(tree = state, delay = 0) {
	console.log("HIDE STATUS SPINNER");
	if (delay === 0) {
		tree.set(["appState", "status", "showSpinner"], false);
	} else {
		setTimeout(() => {
			tree.set(["appState", "status", "showSpinner"], false);
		}, delay);
	}
}
export function showDetailedStatusModal(tree, hit, allowEdit = true) {
	showStatusSpinner(tree);
	setTimeout(() => {
		tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, hit.id);
		tree.set(PlayerPaths.SELECTED_ACTIVITY_INSTANCE_ID, hit.instanceId);
		tree.set(PlayerPaths.SELECTED_ACTIVITY_IDENTITY_ID, hit.identityId);

		let statusDetailSessions = {};
		statusDetailSessions[hit.id] = [hit];

		tree.set(PlayerPaths.STATUS_DETAIL_SESSIONS, statusDetailSessions);

		// Get JSON and after retrieved set state
		awsS3.showDetailedStatus(tree, env.s3.contentBucket, hit.url, allowEdit);
	});

}

export function closeDetailedStatusModal(tree) {
	try {
		if (window.speechSynthesis) {
			window.speechSynthesis.cancel();
		}
		if (window.audioFaultInterval) {
			clearInterval(window.audioFaultInterval);
			window.audioFaultInterval = null;
		}
		const audioElement = document.getElementById("page_audio");
		if (audioElement) {
			if (!audioElement.paused) {
				audioElement.pause();
				audioElement.currentTime = 0;
			}
			delete audioElement.src;
		}
	} catch (e) {
		console.warn(e);
	}
	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, "");
	tree.set(["appState", "showDetailedStatus", "showModal"], false);
}

export function showDetailedHistoryModal(tree, hit) {
	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, hit.id);

	// Get JSON and after retrieved set state
	awsS3.showDetailedHistory(tree, env.s3.contentBucket, hit.url);
}

export function deleteStatusItem(instanceId, url) {
	let payload;
	try {
		payload = buildStatusDeleteRequest({
			isAdministrator: isOrganizationAdministrator(),
			orgId: getOrgId(),
			instanceId,
			url
		});
	} catch (err) {
		return Promise.reject(err);
	}

	return request
		.delete(`${env.apiGateway.baseUrl}/user/status/item`)
		.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
		.send(payload)
		.then(res => res.body)
		.catch(err => {
			err.message = getStatusDeleteErrorMessage(err);
			throw err;
		});
}

export function closeDetailedHistoryModal(tree) {
	tree.set(PlayerPaths.SELECTED_ACTIVITY_ID, "");
	tree.set(["appState", "showDetailedHistory", "showModal"], false);
}

export async function channelForSelfIfMember(id, { forceRefresh = false } = {}) {
	const channelId = String(id === undefined || id === null ? "" : id).trim();
	if (!channelId) {
		return null;
	}
	const channels = await getChannelsFromInstances([channelId], {
		batchSize: 1,
		messageLimit: 0,
		forceRefresh
	});
	return Array.isArray(channels) && channels.length > 0 ? channels[0] : null;
}


export async function channelExists(id) {
	return new Promise(async (resolve, reject) => {
		try {
			const filter = { id };
			const sort = [{ last_message_at: -1 }];
			const channels = await chatClient.queryChannels(filter, sort, {
				watch: false, // this is the default 
				state: false
			});
			if (channels.length > 0) {
				resolve(channels[0]);
			} else {
				resolve(null);
			}
		} catch (err) {
			console.log("ERROR " + err.message);
			reject(err);
		}
	});
}



const VISIBLE_CHANNEL_CACHE_TTL_MS = 10000;
const VISIBLE_CHANNEL_CACHE_MAX_ENTRIES = 50;
const VISIBLE_CHANNEL_MAX_BATCH_SIZE = 3;
const VISIBLE_CHANNEL_RETRY_LIMIT = 2;
const visibleChannelQueryCache = new Map();
const visibleChannelQueriesInFlight = new Map();
let visibleChannelQueryQueue = Promise.resolve();
let visibleChannelQueryBlockedUntil = 0;
const sleep = (ms) => new Promise(r => setTimeout(r, ms));

const normalizeVisibleChannelIds = (instanceIds = []) => [...new Set(
	(Array.isArray(instanceIds) ? instanceIds : [])
		.map(id => String(id === undefined || id === null ? "" : id).trim())
		.filter(Boolean)
		.map(id => (id.indexOf("instance-") === 0 ? id : `instance-${id}`))
)];

const formatVisibleChannelResult = (ids, channels, includeMissing) => {
	const safeChannels = Array.isArray(channels) ? channels : [];
	if (includeMissing) {
		const found = new Set(safeChannels.map(channel => {
			const rawId = String((channel && (channel.id || channel.cid)) || "");
			return rawId.indexOf(":") === -1 ? rawId : rawId.slice(rawId.indexOf(":") + 1);
		}).filter(Boolean));
		return {
			channels: safeChannels,
			missing: ids.filter(id => !found.has(id))
		};
	}
	return safeChannels.length ? safeChannels : null;
};

const cacheVisibleChannelQuery = (key, channels) => {
	visibleChannelQueryCache.delete(key);
	visibleChannelQueryCache.set(key, {
		channels: Array.isArray(channels) ? channels : [],
		expiresAt: Date.now() + VISIBLE_CHANNEL_CACHE_TTL_MS
	});
	while (visibleChannelQueryCache.size > VISIBLE_CHANNEL_CACHE_MAX_ENTRIES) {
		visibleChannelQueryCache.delete(visibleChannelQueryCache.keys().next().value);
	}
};

/**
 * Fetch channels for the given instance IDs, only if the current user is a member.
 * Returns: Channel[] or null (same shape you had before).
 * Set includeMissing=true if you want { channels, missing } instead.
 */
export async function getChannelsFromInstances(
	instanceIds,
	{
		channelType = "team",
		batchSize = VISIBLE_CHANNEL_MAX_BATCH_SIZE,
		messageLimit = 1,
		interBatchDelayMs = 350,
		includeMissing = false,   // optional richer output
		forceRefresh = false,
	} = {}
) {
	const ids = normalizeVisibleChannelIds(instanceIds);
	if (ids.length === 0) {
		return includeMissing ? { channels: [], missing: [] } : null;
	}

	const userId = (chatClient && (chatClient.userID || (chatClient.user && chatClient.user.id))) || null;
	if (!userId) {
		// Never broaden this visible-page lookup during logout/reconnect. A
		// missing user must not turn a member-scoped query into an org-wide one.
		return includeMissing ? { channels: [], missing: ids } : null;
	}

	const normalizedBatchSize = Math.max(1, Math.min(
		VISIBLE_CHANNEL_MAX_BATCH_SIZE,
		Number.isFinite(Number(batchSize)) ? Math.trunc(Number(batchSize)) : VISIBLE_CHANNEL_MAX_BATCH_SIZE
	));
	const normalizedMessageLimit = Math.max(0, Number.isFinite(Number(messageLimit)) ? Math.trunc(Number(messageLimit)) : 1);
	const sortedIds = ids.slice().sort();
	const requestKey = [userId, channelType, normalizedMessageLimit, sortedIds.join("|")].join("::");
	const cached = visibleChannelQueryCache.get(requestKey);
	if (!forceRefresh && cached && cached.expiresAt > Date.now()) {
		return formatVisibleChannelResult(ids, cached.channels, includeMissing);
	}
	if (cached && cached.expiresAt <= Date.now()) {
		visibleChannelQueryCache.delete(requestKey);
	}

	let queryPromise = visibleChannelQueriesInFlight.get(requestKey);
	if (!queryPromise) {
		const executeQuery = async () => {
			const all = [];
			const safeQuery = async (fn) => {
				for (let attempt = 0; ; attempt += 1) {
					const blockedFor = visibleChannelQueryBlockedUntil - Date.now();
					if (blockedFor > 0) {
						await sleep(blockedFor);
					}
					try {
						return await fn();
					} catch (err) {
						if (!isStreamRateLimitError(err) || attempt >= VISIBLE_CHANNEL_RETRY_LIMIT) {
							throw err;
						}
						const retryDelayMs = getStreamRetryDelayMs(err, { attempt });
						visibleChannelQueryBlockedUntil = Math.max(visibleChannelQueryBlockedUntil, Date.now() + retryDelayMs);
					}
				}
			};

			for (let i = 0; i < sortedIds.length; i += normalizedBatchSize) {
				const batch = sortedIds.slice(i, i + normalizedBatchSize);
				const filter = {
					cid: { $in: batch.map(id => `${channelType}:${id}`) },
					members: { $in: [userId] }
				};
				const sort = [{ last_message_at: -1 }];
				const opts = {
					state: true,
					watch: false,
					presence: false,
					limit: batch.length,
					message_limit: normalizedMessageLimit
				};
				const page = await safeQuery(() => chatClient.queryChannels(filter, sort, opts));
				all.push(...(Array.isArray(page) ? page : []));
				if (i + normalizedBatchSize < sortedIds.length) {
					await sleep(Math.max(0, Number(interBatchDelayMs) || 0));
				}
			}
			return all;
		};

		// Serialize distinct page lookups. Identical callers share the same
		// promise, while a handled queue rejection can never become an orphaned
		// "Uncaught (in promise)" error in the browser console.
		queryPromise = visibleChannelQueryQueue.catch(() => null).then(executeQuery);
		visibleChannelQueryQueue = queryPromise.catch(() => null);
		visibleChannelQueriesInFlight.set(requestKey, queryPromise);
	}

	try {
		const channels = await queryPromise;
		cacheVisibleChannelQuery(requestKey, channels);
		return formatVisibleChannelResult(ids, channels, includeMissing);
	} finally {
		if (visibleChannelQueriesInFlight.get(requestKey) === queryPromise) {
			visibleChannelQueriesInFlight.delete(requestKey);
		}
	}
}



export async function getChannelsFromInstances2(instanceIds) {
	return new Promise(async (resolve, reject) => {
		try {
			const filter = { id: { $in: instanceIds } };

			const channels = await chatClient.queryChannels(filter, [{ last_message_at: -1 }], {
				watch: false, // this is the default 
				state: true,
				limit: 30
			});
			if (channels.length > 0) {
				resolve(channels);
			} else {
				resolve(null);
			}
		} catch (err) {
			console.log("ERROR " + err.message);
			reject(err);
		}
	});

}

function createEmptyChatModalState(overrides = {}) {
	return {
		activeChannelId: null,
		activeChannelCid: null,
		checklist: {},
		session: null,
		loading: false,
		saving: false,
		instance: {},
		openPinsOnLoad: false,
		showModal: false,
		isEditing: false,
		url: "",
		sessions: {},
		...overrides
	};
}

export async function showCreateChatChannelModal(tree, hit = {}) {
	let chatSession = createPricingSession(hit.url, generateUUID());
	if (!chatSession || (hit.instanceId && `${hit.instanceId}` !== chatSession.instanceId)) {
		showError("Unable to Open Job", "The selected job identity could not be verified. Refresh Status and try again.");
		return null;
	}

	let sessionHit = {
		...hit,
		url: chatSession.url,
		instanceId: chatSession.instanceId
	};
	const previousChatSaveWasPending = tree.get(["appState", "showCreateChatChannel", "saving"]) === true;
	tree.set(["appState", "showCreateChatChannel"], createEmptyChatModalState({
		session: chatSession,
		loading: true,
		instance: sessionHit,
		url: chatSession.url
	}));
	tree.set(["appState", "activitySummary"], {});
	tree.set(["appState", "activityInvoiceItems"], []);
	tree.commit();
	if (previousChatSaveWasPending) {
		hideStatusSpinner(tree);
	}

	return new Promise((resolve, reject) => {
		refreshCredentials().then(async () => {
			const currentHit = await resolveCurrentJobHit(sessionHit, tree);
			if (!isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, chatSession)) {
				resolve(null);
				return;
			}
			sessionHit = currentHit;
			chatSession = createPricingSession(currentHit.url, chatSession.sessionId);
			tree.set(["appState", "showCreateChatChannel", "session"], chatSession);
			tree.set(["appState", "showCreateChatChannel", "instance"], sessionHit);
			tree.set(["appState", "showCreateChatChannel", "url"], chatSession.url);
			tree.commit();
			const bucket = new AWS.S3({ useDualStack: true, params: { Bucket: env.s3.contentBucket, ResponseContentType: "application/json", ResponseCacheControl: "no-cache" } });
			bucket.getObject({ Key: chatSession.url }, async (err, data) => {
				if (!isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, chatSession)) {
					resolve(null);
					return;
				}
				if (err) {
					tree.set(["appState", "showCreateChatChannel", "loading"], false);
					showError("Unable to Open Job", "The selected job could not be loaded. Refresh Status and try again.");
					reject(err);
					return;
				}

				let jsonChecklist;
				try {
					jsonChecklist = normalizeActivity(JSON.parse(data.Body.toString()));
				} catch (parseErr) {
					tree.set(["appState", "showCreateChatChannel", "loading"], false);
					showError("Unable to Open Job", "The selected job contains invalid data. Refresh Status and try again.");
					reject(parseErr);
					return;
				}

				const identityValidation = validatePricingChecklistForSession(jsonChecklist, chatSession);
				if (!identityValidation.valid) {
					tree.set(["appState", "showCreateChatChannel", "loading"], false);
					showError("Unable to Open Job", "The selected job identity did not match its saved activity. No job was opened.");
					reject(new Error(identityValidation.message));
					return;
				}

				let channel = null;
				try {
					channel = await channelForSelfIfMember(`instance-${chatSession.instanceId}`);
				} catch (_channelErr) {
					channel = null;
				}
				if (!isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, chatSession)) {
					resolve(null);
					return;
				}

				const hitPinnedCount = _.toInteger(_.get(sessionHit, "chatPinnedCount", 0));
				const channelPinnedCount = _.toInteger(_.get(channel, "state.pinnedMessages.length", 0));
				const openPinsOnLoad = Math.max(hitPinnedCount, channelPinnedCount) > 0;
				tree.set(["appState", "showCreateChatChannel", "checklist"], jsonChecklist);
				tree.set(["appState", "showCreateChatChannel", "activeChannelId"], channel !== null ? channel.id : null);
				tree.set(["appState", "showCreateChatChannel", "activeChannelCid"], channel !== null ? channel.cid : null);
				tree.set(["appState", "showCreateChatChannel", "openPinsOnLoad"], openPinsOnLoad);
				tree.set(["appState", "showCreateChatChannel", "loading"], false);
				tree.set(["appState", "showCreateChatChannel", "showModal"], true);
				tree.set(["appState", "tabChat"], "customer");
				tree.set(["appState", "activityInvoiceItems"], _.cloneDeep(jsonChecklist.invoiceItems || []));

				const sessions = {};
				sessions[jsonChecklist.id || sessionHit.id || chatSession.activityId] = [sessionHit];
				tree.set(["appState", "showCreateChatChannel", "sessions"], sessions);
				await awsS3.setActivitySummary(tree, env.s3.contentBucket, chatSession.url, false, jsonChecklist, chatSession);
				resolve(jsonChecklist);
			});
		}).catch((err) => {
			if (isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, chatSession)) {
				tree.set(["appState", "showCreateChatChannel", "loading"], false);
				console.error(err);
				showError("Unable to Open Job", err.message || "The current job could not be verified. Refresh the Job Board and try again.");
			}
			reject(err);
		});
	});
}

// actions.js
export async function changeChatChannel(tree, targetChannelId, expectedChatSession = null) {
	const chatSession = expectedChatSession
		|| getPricingSessionSnapshot(tree.get(["appState", "showCreateChatChannel"]) || {});
	if (!chatSession
		|| !isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, chatSession)) {
		return false;
	}
	let channel = null;
	try {
		// Must return a Stream Channel instance for the current user (or null)
		channel = await channelForSelfIfMember(targetChannelId);
	} catch (err) {
		channel = null;
	}

	if (!channel) {
		return false;
	}
	if (!isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, chatSession)) {
		return false;
	}

	// Ensure the client is subscribed; this guarantees messages populate
	if (!channel.state.watcher_count && !channel.initialized) {
		await channel.watch(); // important
	}
	if (!isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, chatSession)) {
		return false;
	}

	// Stream's canonical identifier is cid (`<type>:<id>`). Keep both.
	const { id, cid } = channel;
	tree.set(["appState", "showCreateChatChannel", "activeChannelId"], id);
	tree.set(["appState", "showCreateChatChannel", "activeChannelCid"], cid);

	return true;
}

export function refreshActivitySummary(url, showAll = false, expectedChatSession = null) {
	return awsS3.setActivitySummary(state, env.s3.contentBucket, url, showAll, null, expectedChatSession);
}

export function closeCreateChatChannelModal(tree, expectedChatSession = null) {
	if (expectedChatSession
		&& !isPricingSessionActive(tree.get(["appState", "showCreateChatChannel"]) || {}, expectedChatSession)) {
		return false;
	}
	const shouldReleaseSpinner = tree.get(["appState", "showCreateChatChannel", "saving"]) === true;
	tree.set(["appState", "showCreateChatChannel"], createEmptyChatModalState());

	tree.set(["appState", "activitySummary"], {});
	tree.set(["appState", "activityInvoiceItems"], []);
	tree.set(["appState", "showNotes", "checklist"], {});
	tree.set(["appState", "showNotes", "sessionName"], "");
	if (shouldReleaseSpinner) {
		hideStatusSpinner(tree);
	}
	return true;
}

export function toggleMultiSelect(tree) {
	let enabled = tree.select(["appState", "editor", "multiSelectMode"]).get();
	tree.set(["appState", "editor", "multiSelectMode"], !enabled);
}

export function setLastLocation(tree, location) {
	tree.set(["appState", "lastLocation"], location);
}

export function editDetailedStatus(tree) {
	tree.set(["appState", "showDetailedStatus", "edit"], true);

	//clone original checklist and save it
	let cloned = tree.select(PlayerPaths.CHECKLIST).deepClone();
	tree.set(["player", "checklistOriginal"], cloned);
}

export function cancelEditDetailedStatus(tree) {
	tree.set(["appState", "showDetailedStatus", "edit"], false);
	let original = tree.select(PlayerPaths.CHECKLIST_ORIGINAL).get();
	tree.set(PlayerPaths.CHECKLIST, original);
}

export function saveDetailedStatusSuccess(tree) {
	tree.set(["appState", "showDetailedStatus", "modal", "showSpinner"], false);
	tree.set(["appState", "showDetailedStatus", "edit"], false);
}

export function changeStatusLayout(layout) {
	state.set(["appState", "statusViewType"], layout);
	utils.setLs(state.get(["user", "username"]) + ";statusViewType", layout);
}


export async function addActivityInstance(activityId, { id, sync, openDate, lastUpdatedDate, submitted = null }) {
	let instanceIdx = -1;

	if (!state.get(["instances", activityId])) {
		state.set(["instances", activityId], []);
	}

	state.get(["instances", activityId]).forEach((instance, idx) => {
		if (instance.id === id) {
			instanceIdx = idx;
		}
	});


	if (instanceIdx === -1) {
		state.push(["instances", activityId],
			{
				id,
				sync,
				openDate,
				lastUpdatedDate,
				submitted
			});
	} else {
		state.set(["instances", activityId, instanceIdx], {
			id,
			sync,
			openDate,
			lastUpdatedDate,
			submitted
		});
	}
}

export function handleShowGenerateTtsAudioModal(tree) {
	initGenerateTtsAudioConfig(tree);
	tree.set(["audio", "modals", "generateTts", "show"], true);
}

export function handleHideGenerateTtsAudioModal(tree) {
	tree.set(["audio", "modals", "generateTts", "show"], false);
}

export function handleShowIdGeneratorModal(tree, defaults = null) {
	tree.set(["appState", "idGeneratorModal", "defaults"], defaults || null);
	tree.set(["appState", "idGeneratorModal", "show"], true);
}

export function handleHideIdGeneratorModal(tree) {
	tree.set(["appState", "idGeneratorModal", "defaults"], null);
	tree.set(["appState", "idGeneratorModal", "show"], false);
}

export function handleShowAiOutlineModal(tree, defaults = null) {
	tree.set(["appState", "aiOutlineModal", "defaults"], defaults || null);
	tree.set(["appState", "aiOutlineModal", "show"], true);
}

export function handleHideAiOutlineModal(tree) {
	tree.set(["appState", "aiOutlineModal", "defaults"], null);
	tree.set(["appState", "aiOutlineModal", "show"], false);
}

export function handleShowBulkEditModal(tree, defaults = null) {
	tree.set(["appState", "bulkEditModal", "defaults"], defaults || null);
	tree.set(["appState", "bulkEditModal", "show"], true);
}

export function handleHideBulkEditModal(tree) {
	tree.set(["appState", "bulkEditModal", "defaults"], null);
	tree.set(["appState", "bulkEditModal", "show"], false);
}

export function handleShowAiBulkEditModal(tree, defaults = null) {
	tree.set(["appState", "aiBulkEditModal", "defaults"], defaults || null);
	tree.set(["appState", "aiBulkEditModal", "show"], true);
}

export function handleHideAiBulkEditModal(tree) {
	tree.set(["appState", "aiBulkEditModal", "defaults"], null);
	tree.set(["appState", "aiBulkEditModal", "show"], false);
}

export function handleApplyBulkEdit(tree, options = {}) {
	const selectedPath = getSelectedNodePath();
	const selectedNode = tree.get(selectedPath);
	if (!selectedNode || !selectedPath || selectedPath.length === 0) {
		return;
	}

	const targetTypes = options.targetTypes || { list: false, section: false, item: true };
	const textFilter = (options.textFilter || "").toLowerCase();
	const newItemType = options.newItemType || "";

	const matchesFilter = (label) => {
		if (!textFilter) { return true; }
		return (label || "").toLowerCase().includes(textFilter);
	};

	let changed = 0;
	const walk = (path) => {
		const node = tree.get(path);
		if (!node || !node.entity) { return; }
		const { type, label, name, label1 } = node.entity;
		const labelText = label || name || label1 || "";
		const typeKey = type === "list" ? "list" : type === "section" ? "section" : (type && type.startsWith("item") ? "item" : "");

		if (typeKey === "item" && targetTypes.item && newItemType && matchesFilter(labelText)) {
			node.entity.type = newItemType;
			changed += 1;
		}
		if (typeKey === "list" && targetTypes.list && matchesFilter(labelText)) {
			changed += 0; // placeholder for future list-level changes
		}
		if (typeKey === "section" && targetTypes.section && matchesFilter(labelText)) {
			changed += 0; // placeholder for future section-level changes
		}

		if (node.children && node.children.length) {
			node.children.forEach((_child, idx) => {
				walk(_.concat(path, ["children", idx]));
			});
		}
	};

	walk(selectedPath);
	saveUndoState();
	tree.commit();
	alert(`Bulk edit complete. Changed ${changed} item(s).`);
}

export async function generateAiBulkEditInstructions(tree, options = {}) {
	const selectedPath = getSelectedNodePath();
	const effectiveSelectedPath = Array.isArray(options.selectedPath) && options.selectedPath.length > 0 ? options.selectedPath : selectedPath;
	const selectedNode = tree.get(effectiveSelectedPath);
	if (!selectedNode || !effectiveSelectedPath || effectiveSelectedPath.length === 0) {
		throw new Error("No valid target is selected for AI bulk edit.");
	}

	const userPrompt = options.prompt || "Update nodes under the selected parent. Return only JSON instructions per the schema.";
	const rawUserPrompt = options.rawUserPrompt || options.userPrompt || userPrompt;
	const lowerRawUserPrompt = `${rawUserPrompt || ""}`.toLowerCase();
	const maxOpsOpt = parseInt(options.maxOps, 10);
	const maxOps = _.isFinite(maxOpsOpt) && maxOpsOpt > 0 ? Math.min(maxOpsOpt, 100) : 100;
	const showSpinner = options.showSpinner !== false;
	const userAskedDelete = /\b(delete|remove)\b/i.test(rawUserPrompt || "");
	const userAskedAppend = /\b(add|append|insert|create)\b/i.test(rawUserPrompt || "");
	const allowTextFilter = /\b(label|name|title|text)\b[\s\S]{0,24}\b(contains|containing|matches|matching|equals|equal to|starts with|ends with)\b/i.test(rawUserPrompt) ||
		/\bcontains\b[\s\S]{0,24}\b(label|name|title|text)\b/i.test(rawUserPrompt) ||
		/\bwhose\s+(?:label|name|title|text)\b/i.test(rawUserPrompt);

	const itemTypesArr = (tree && tree.get && tree.get(["itemTypes"])) || (state && state.get && state.get(["itemTypes"])) || [];
	const allowedItemTypes = new Set(
		(Array.isArray(itemTypesArr) ? itemTypesArr.map((t) => t.type || t) : []).filter(Boolean).concat([
			"item",
			"itemYesNo",
			"itemPicker",
			"itemTextInput",
			"itemTextInputMultiline",
			"itemBarcodeScanner",
			"itemChoiceSingle",
			"itemChoiceMulti"
		])
	);
	const isAllowedItemType = (t) => allowedItemTypes.has((t || "").trim());

	const schema = `Allowed nodeTypes: activity, list, section, item.
Instruction schema (array):
[
  {
    "targetTypes": ["activity" | "list" | "section" | "item"],
    "textContains": "optional substring match against label/name (lowercase); omit or blank to target all",
    "setLabel": "optional new label string (for items/lists/sections only; activity label cannot be set here)",
    "setItemType": "optional item type such as item, itemYesNo, itemPicker, itemTextInput, itemBarcodeScanner, itemChoiceSingle, itemChoiceMulti",
    "setVisible": true | false,
    "setEnabled": true | false,
    "delete": true | false,
    "appendNodes": [
      {
        "type": "list" | "section" | "item",
        "itemType": "optional valid AmbiFi item type when type is item",
        "label": "required label for the new node",
        "setProps": { "anyEntityProp": "string | number | boolean" },
        "children": [ "optional nested node specs using this same shape" ]
      }
    ],
    "setProps": { "anyEntityProp": "string | number | boolean" },
    "_note": "when setting label text (label1/name/title), use setLabel. Only use setProps for non-text properties (e.g., color). For label-only rows use setItemType: 'item' plus setProps: { 'labelOnly': true }. Use delete: true to remove matching descendant nodes while leaving the bulk edit target itself in place. Use appendNodes when adding new lists/sections/items under the selected bulk edit target. Do not rename existing nodes when the user asked to add new nodes."
  }
]
Placeholders: you may copy existing values using {fieldName}, e.g., setLabel: "{label}" or setProps: { "color": "{label}" }. Bare strings (e.g., "label") are treated as literals unless wrapped in {}.
Examples:
- setProps: { "color": "{label}" } // copies current label into color
- setLabel: "{color}" // copies current color into label
- { "targetTypes": ["item"], "textContains": "", "delete": true } // deletes descendant items but leaves sections/lists in place
- { "targetTypes": ["section"], "textContains": "", "appendNodes": [{ "type": "item", "itemType": "item", "label": "Red" }, { "type": "item", "itemType": "item", "label": "Blue" }] } // appends two new items under the selected section
Common fields: id, guid, entityId, label (aka name/title/label1), label2 (if used), visible, enabled, groupNames, showFor, styles (json-string), classes (json-string).
Item fields: type (item*), label/label1, label2 (if used), labelOnly, labelOnlyBackgroundColor, labelAudio/labelSsml/labelPrint/labelAudioFile, labelAlexaPlain/Rich, label1NarrationOverride, label1SsmlOverride, label1PrintOverride, styles, classes, visible, enabled, ignoreCompletion, suppressAudio*, procedureViewType, relatedItemRefs, item type examples above.
List/section fields: label (aka name/title), excludeFromNavigation, relatedItemRefs, labelAlexa*, labelAudio*, labelSsml, labelPrint, labelAudioFile, defaultView, startInBirdseyeView (list), styles, classes, color/backgroundColor/borderColor, suppressPrint/audio*, procedureViewType, hideStatus, itemsOnSingleLine.
Activity fields (examples): checklistId, description, lang, labelAlexa*, labelAudio*, labelSsml, labelPrint, authorProperties, theme/styles/stylesheet*, fonts/themeColors, workflowStatesDs, media fields (backgroundImage/video/image/audio/backgroundAudio...), genre/tags/contributors, showMode/focusedMode/procedureViewType, suppressAudio*, trackData/location, dataSources/externalResources, submitLabel/lockOnSubmit, functions/contentModel, ignoreCompletion/hideStatus, printCustomProperties/printTemplate, commentsVisibility/listViewMode/checkbarVisibility/defaultView/itemsOnSingleLine, aiAssistant flags.`;

	const parentType = selectedNode.entity.type || "node";
	const parentLabel = (selectedNode.entity.label || selectedNode.entity.name || selectedNode.entity.label1 || "parent").trim();
	const normalizedParentType = parentType === "checklist"
		? "activity"
		: parentType.startsWith("item")
			? "item"
			: parentType;

	const buildDeterministicDeleteInstructions = () => {
		if (!userAskedDelete || userAskedAppend) {
			return [];
		}

		const targetTypes = [];
		if (/\bitems?\b/.test(lowerRawUserPrompt)) {
			targetTypes.push("item");
		} else if (/\bsections?\b/.test(lowerRawUserPrompt) && !/\bleave\s+the?\s*sections?\b/.test(lowerRawUserPrompt)) {
			targetTypes.push("section");
		} else if (/\blists?\b/.test(lowerRawUserPrompt) && !/\bleave\s+the?\s*lists?\b/.test(lowerRawUserPrompt)) {
			targetTypes.push("list");
		} else if (/\bactivity\b|\bchecklist\b/.test(lowerRawUserPrompt) && !/\bleave\b/.test(lowerRawUserPrompt)) {
			targetTypes.push("activity");
		}

		const uniqueTargetTypes = Array.from(new Set(targetTypes)).filter((type) => ["activity", "list", "section", "item"].includes(type));
		if (uniqueTargetTypes.length === 0) {
			return [];
		}

		return [{
			targetTypes: uniqueTargetTypes,
			textContains: "",
			delete: true
		}];
	};

	const prompt = `${userPrompt}
Parent type: "${parentType}", label: "${parentLabel}".
Return ONLY JSON matching this instruction schema (array):
${schema}
Do not include any other keys. Do not include prose. If unsure, return []. Max instructions: ${maxOps}.`;

	if (showSpinner) {
		showEditorSpinner();
	}
	let instructions = [];
	try {
		const makePrompt = (strict = false) => {
			const strictSuffix = strict
				? "Return ONLY a valid JSON array per the schema (no keys, no extra text). If you cannot comply, return []."
				: "Return only the JSON array.";
			return {
				messages: [
					{
						role: "system",
						content: "You generate clean bulk-edit instructions for AmbiFi outline nodes."
					},
					{
						role: "user",
						content: `${prompt}\n${strictSuffix}`
					}
				],
				model: "gpt-5.4"
			};
		};

		const parseResp = (resp) => {
			if (!resp) { return []; }
			let raw = resp;
			if (typeof raw === "string") { raw = raw.trim(); }
			let parsed = null;
			if (typeof raw === "string") {
				try { parsed = JSON.parse(raw); } catch (_e) {
					const m = raw.match(/\[([\s\S]*)\]/);
					if (m && m[0]) {
						try { parsed = JSON.parse(m[0]); } catch (_e2) { parsed = null; }
					}
				}
			} else if (typeof raw === "object") {
				parsed = raw;
			}
			if (Array.isArray(parsed)) { return parsed; }
			if (parsed && Array.isArray(parsed.instructions)) { return parsed.instructions; }
			return [];
		};

		const primary = await getChatCompletionsLambda(JSON.stringify(makePrompt(false)));
		if (primary) {
			console.log("AI bulk edit primary response:", primary);
		}
		instructions = parseResp(primary);
		if (instructions.length === 0) {
			const strict = await getChatCompletionsLambda(JSON.stringify(makePrompt(true)));
			if (strict) {
				console.log("AI bulk edit strict response:", strict);
			}
			instructions = parseResp(strict);
		}
	} catch (err) {
		console.error("AI bulk edit failed", err);
		throw new Error("AI bulk edit failed. Please try again.");
	} finally {
		if (showSpinner) {
			hideEditorSpinner();
		}
	}

	const allowedTypes = new Set(["activity", "list", "section", "item"]);
	const coerceVal = (v) => {
		if (typeof v === "string") {
			const lower = v.toLowerCase();
			if (lower === "true") { return true; }
			if (lower === "false") { return false; }
			const num = Number(v);
			if (!Number.isNaN(num) && v.trim() !== "") {
				return num;
			}
			return v;
		}
		return v;
	};
	const coerceArray = (arr) => Array.isArray(arr) ? arr.map(coerceVal) : arr;

	const parseRequestedCount = (promptText = "") => {
		const explicitNumber = `${promptText}`.match(/\b(\d{1,3})\b/);
		if (explicitNumber) {
			return Math.max(1, Math.min(parseInt(explicitNumber[1], 10), maxOps));
		}

		const numberWords = {
			one: 1,
			two: 2,
			three: 3,
			four: 4,
			five: 5,
			six: 6,
			seven: 7,
			eight: 8,
			nine: 9,
			ten: 10,
			eleven: 11,
			twelve: 12,
			thirteen: 13,
			fourteen: 14,
			fifteen: 15,
			sixteen: 16,
			seventeen: 17,
			eighteen: 18,
			nineteen: 19,
			twenty: 20
		};

		const lowerPrompt = `${promptText}`.toLowerCase();
		for (const word of Object.keys(numberWords)) {
			if (new RegExp(`\\b${word}\\b`).test(lowerPrompt)) {
				return Math.min(numberWords[word], maxOps);
			}
		}

		return 1;
	};

	const inferRequestedAppendNodeType = (promptText = "") => {
		const lowerPrompt = `${promptText}`.toLowerCase();
		if (/\bsections?\b/.test(lowerPrompt)) { return "section"; }
		if (/\blists?\b/.test(lowerPrompt)) { return "list"; }
		return "item";
	};

	const inferRequestedAppendItemConfig = (promptText = "") => {
		const lowerPrompt = `${promptText}`.toLowerCase();
		if (/\blabel[\s-]?only\b/.test(lowerPrompt)) {
			return {
				itemType: "item",
				setProps: {
					labelOnly: true
				}
			};
		}
		if (/\bregular\b[\s-]*(checkbox|check)\b|\bcheckbox item\b|\bcheck item\b/.test(lowerPrompt)) {
			return {
				itemType: "item",
				setProps: {
					labelOnly: false
				}
			};
		}
		if (/\byes\s*\/?\s*no\b/.test(lowerPrompt)) {
			return {
				itemType: "itemYesNo",
				setProps: null
			};
		}
		if (/\bpicker\b/.test(lowerPrompt)) {
			return {
				itemType: "itemPicker",
				setProps: null
			};
		}
		if (/\bmultiline\b|\bmulti[-\s]?line\b/.test(lowerPrompt)) {
			return {
				itemType: "itemTextInputMultiline",
				setProps: null
			};
		}
		if (/\btext input\b|\btext item\b/.test(lowerPrompt)) {
			return {
				itemType: "itemTextInput",
				setProps: null
			};
		}
		if (/\bbarcode\b/.test(lowerPrompt)) {
			return {
				itemType: "itemBarcodeScanner",
				setProps: null
			};
		}
		if (/\bsingle choice\b|\bradio\b/.test(lowerPrompt)) {
			return {
				itemType: "itemChoiceSingle",
				setProps: null
			};
		}
		if (/\bmultiple choice\b|\bmulti[-\s]?choice\b|\bmulti[-\s]?select\b/.test(lowerPrompt)) {
			return {
				itemType: "itemChoiceMulti",
				setProps: null
			};
		}
		return {
			itemType: "item",
			setProps: null
		};
	};

	const buildDeterministicCrayolaLabels = (count, promptText = "") => {
		const crayolaColors = [
			"Carnation Pink", "Vivid Tangerine", "Wild Blue Yonder", "Mango Tango", "Electric Lime",
			"Razzmic Berry", "Jazzberry Jam", "Moonstone", "Sheen Green", "Purple Pizzazz",
			"Magic Mint", "Macaroni and Cheese", "Cerulean", "Robin's Egg Blue", "Inchworm",
			"Outer Space", "Sunglow", "Atomic Tangerine", "Wisteria", "Shamrock"
		];
		const seedSource = `${promptText}`.toLowerCase() || "crayola";
		let seed = 0;
		for (let i = 0; i < seedSource.length; i++) {
			seed = (seed * 31 + seedSource.charCodeAt(i)) >>> 0;
		}
		const rand = () => {
			seed = (seed * 1664525 + 1013904223) >>> 0;
			return seed / 4294967296;
		};
		const pool = crayolaColors.slice();
		for (let i = pool.length - 1; i > 0; i--) {
			const j = Math.floor(rand() * (i + 1));
			const tmp = pool[i];
			pool[i] = pool[j];
			pool[j] = tmp;
		}
		const labels = [];
		for (let i = 0; i < count; i++) {
			labels.push(pool[i % pool.length]);
		}
		return labels;
	};

	const inferAppendFallbackInstructions = () => {
		const lower = lowerRawUserPrompt;
		const isAddPrompt = /\b(add|append|insert|create)\b/.test(lower);
		if (!isAddPrompt) {
			return [];
		}

		const appendType = inferRequestedAppendNodeType(lower);
		const count = parseRequestedCount(lower);
		const labels = /\brandom\s+crayola\s+colors?\b/.test(lower)
			? buildDeterministicCrayolaLabels(count, rawUserPrompt)
			: Array.from({ length: count }, (_unused, index) => {
				if (appendType === "section") { return `Section ${index + 1}`; }
				if (appendType === "list") { return `List ${index + 1}`; }
				return `Item ${index + 1}`;
			});
		const itemConfig = inferRequestedAppendItemConfig(lower);
		const appendNodes = labels.map((label) => {
			const base = {
				type: appendType,
				label
			};
			if (appendType === "item") {
				base.itemType = itemConfig.itemType;
				if (itemConfig.setProps && Object.keys(itemConfig.setProps).length > 0) {
					base.setProps = itemConfig.setProps;
				}
			}
			return base;
		});

		return [{
			targetTypes: [allowedTypes.has(normalizedParentType) ? normalizedParentType : "section"],
			textContains: "",
			appendNodes
		}];
	};

	const synonymMap = {
		"labelonly": "labelOnly",
		"label only": "labelOnly",
		"label-only": "labelOnly",
		"labelonlybackgroundcolor": "labelOnlyBackgroundColor",
		"label only background color": "labelOnlyBackgroundColor",
		"label1": "label",
		"label 1": "label",
		"labelone": "label",
		"label2": "label2",
		"label 2": "label2",
		"label": "label",
		"name": "label",
		"title": "label",
		"type": "type",
		"item type": "type",
		"visible": "visible",
		"visibility": "visible",
		"enabled": "enabled",
		"enablement": "enabled",
		"id": "id",
		"guid": "guid",
		"entityid": "entityId",
		"groupnames": "groupNames",
		"filtertags": "filterTags",
		"styles": "styles",
		"classes": "classes",
		"relateditemrefs": "relatedItemRefs",
		"exclude from navigation": "excludeFromNavigation",
		"defaultview": "defaultView",
		"startinbirdseyeview": "startInBirdseyeView",
		"suppressprint": "suppressPrint",
		"hide status": "hideStatus"
	};

	const normalizeKey = (k) => {
		if (!k) { return k; }
		const trimmed = `${k}`.trim();
		const lower = trimmed.toLowerCase().replace(/[^a-z0-9]+/g, " ").replace(/\s+/g, " ").trim();
		const noSpace = lower.replace(/\s+/g, "");
		return synonymMap[lower] || synonymMap[noSpace] || trimmed;
	};

	const normalizeRequestedItemType = (value) => {
		if (typeof value !== "string") {
			return {
				value,
				impliedProps: null
			};
		}

		const trimmed = value.trim();
		if (trimmed === "") {
			return {
				value: trimmed,
				impliedProps: null
			};
		}

		if (isAllowedItemType(trimmed)) {
			return {
				value: trimmed,
				impliedProps: null
			};
		}

		const compact = trimmed.toLowerCase().replace(/[^a-z0-9]+/g, "");
		if (["itemlabelonly", "labelonly", "labelonlyitem", "labelonlycheckitem", "labelonlycheckitems"].includes(compact)) {
			return {
				value: "item",
				impliedProps: {
					labelOnly: true
				}
			};
		}
		if (["itemtextinputmultiline", "multilinetext", "multilinetextinput"].includes(compact)) {
			return {
				value: "itemTextInputMultiline",
				impliedProps: null
			};
		}

		return {
			value: trimmed,
			impliedProps: null
		};
	};

	const validateInstruction = (inst) => {
		const normalizeType = (t) => {
			const lower = (t || "").toLowerCase();
			if (lower === "items") { return "item"; }
			if (lower === "sections") { return "section"; }
			if (lower === "lists") { return "list"; }
			if (lower === "activities") { return "activity"; }
			return lower;
		};

		if (!inst || typeof inst !== "object" || Array.isArray(inst)) { return null; }

		const targets = Array.isArray(inst.targetTypes)
			? inst.targetTypes.map(normalizeType).filter(t => allowedTypes.has(t))
			: [];
		if (targets.length === 0) { return null; }

			const allowedKeys = new Set(["targetTypes", "textContains", "setLabel", "setItemType", "setVisible", "setEnabled", "setProps", "delete", "appendNodes"]);
		const setPropsRaw = (inst.setProps && typeof inst.setProps === "object") ? inst.setProps : null;
		let setProps = null;
		if (setPropsRaw) {
			setProps = {};
			for (const k of Object.keys(setPropsRaw)) {
				const normKey = normalizeKey(k);
				setProps[normKey] = coerceArray(setPropsRaw[k]);
			}
		}

		const coerceBool = (v) => {
			const c = coerceVal(v);
			if (typeof c === "boolean") { return c; }
			return undefined;
		};

		for (const k of Object.keys(inst)) {
			if (!allowedKeys.has(k)) {
				return null;
			}
		}

		const setLabelVal = Array.isArray(inst.setLabel) ? coerceArray(inst.setLabel) : (typeof inst.setLabel === "string" ? inst.setLabel : undefined);
		let setItemTypeVal = Array.isArray(inst.setItemType) ? coerceArray(inst.setItemType) : (typeof inst.setItemType === "string" ? inst.setItemType : undefined);
		if (setItemTypeVal) {
			const rawArray = Array.isArray(setItemTypeVal) ? setItemTypeVal : [setItemTypeVal];
			const normalizedArray = rawArray.map((candidate) => normalizeRequestedItemType(candidate));
			const normalizedValues = normalizedArray.map((entry) => entry.value);
			if (!normalizedValues.every(isAllowedItemType)) { return null; }
			const impliedProps = normalizedArray.reduce((acc, entry) => {
				if (entry && entry.impliedProps && typeof entry.impliedProps === "object") {
					return {
						...acc,
						...entry.impliedProps
					};
				}
				return acc;
			}, {});
			if (Object.keys(impliedProps).length > 0) {
				setProps = {
					...(setProps || {}),
					...impliedProps
				};
			}
			setItemTypeVal = Array.isArray(setItemTypeVal) ? normalizedValues : normalizedValues[0];
		}

		return {
			targetTypes: targets,
			textContains: allowTextFilter ? (inst.textContains || "").toLowerCase() : "",
			setLabel: setLabelVal,
			setItemType: setItemTypeVal,
			setVisible: coerceBool(inst.setVisible),
			setEnabled: coerceBool(inst.setEnabled),
			setProps,
			delete: coerceBool(inst.delete),
			appendNodes: Array.isArray(inst.appendNodes) ? inst.appendNodes : undefined
		};
	};

	let sanitizedInstructions = Array.isArray(instructions)
		? instructions.map(validateInstruction).filter((inst) => !!inst)
		: [];

	if (userAskedDelete && !userAskedAppend) {
		const deterministicDeleteInstructions = buildDeterministicDeleteInstructions();
		sanitizedInstructions = Array.isArray(deterministicDeleteInstructions)
			? deterministicDeleteInstructions.map(validateInstruction).filter((inst) => !!inst)
			: [];
	} else if (userAskedDelete && Array.isArray(sanitizedInstructions)) {
			for (let i = 0; i < sanitizedInstructions.length; i++) {
				const inst = sanitizedInstructions[i];
				const onlyVisibilityChange = inst && inst.delete === undefined && inst.setLabel === undefined && inst.setItemType === undefined && !inst.setProps && inst.setEnabled === undefined && inst.setVisible === false;
				if (onlyVisibilityChange) {
					sanitizedInstructions[i] = { ...inst, delete: true, setVisible: undefined };
				}
			}

			const hasExplicitDeleteInstruction = sanitizedInstructions.some((inst) => inst && inst.delete === true);
			const hasContradictoryNonDeleteInstructions = sanitizedInstructions.some((inst) => inst && (
				(Array.isArray(inst.appendNodes) && inst.appendNodes.length > 0) ||
				inst.setLabel !== undefined ||
				inst.setItemType !== undefined ||
				inst.setEnabled !== undefined ||
				inst.setVisible === true ||
				(inst.setProps && Object.keys(inst.setProps).length > 0)
			));

			if (!hasExplicitDeleteInstruction && hasContradictoryNonDeleteInstructions) {
				instructions = buildDeterministicDeleteInstructions();
				sanitizedInstructions = Array.isArray(instructions)
					? instructions.map(validateInstruction).filter((inst) => !!inst)
					: [];
			}
		}

	if (userAskedAppend) {
		const hasAppendInstructions = Array.isArray(sanitizedInstructions) &&
			sanitizedInstructions.some((inst) => Array.isArray(inst.appendNodes) && inst.appendNodes.length > 0);
		if (!hasAppendInstructions) {
			const appendFallback = inferAppendFallbackInstructions();
			if (appendFallback.length > 0) {
				instructions = appendFallback;
				sanitizedInstructions = appendFallback.map(validateInstruction).filter((inst) => !!inst);
			}
		}
	}

	if ((!Array.isArray(sanitizedInstructions) || sanitizedInstructions.length === 0) && userAskedDelete) {
		instructions = buildDeterministicDeleteInstructions();
	}

	const fallbackSanitizedInstructions = Array.isArray(instructions)
		? instructions.map(validateInstruction).filter((inst) => !!inst)
		: [];

	const usableInstructions = Array.isArray(sanitizedInstructions) && sanitizedInstructions.length > 0
		? sanitizedInstructions
		: fallbackSanitizedInstructions;

	if (!Array.isArray(usableInstructions) || usableInstructions.length === 0) {
		throw new Error("AI bulk edit returned no usable instructions.");
	}

	if (usableInstructions.length > maxOps) {
		throw new Error(`AI bulk edit returned ${usableInstructions.length} instructions which exceeds the limit (${maxOps}).`);
	}

	const previewStr = JSON.stringify(usableInstructions, null, 2);
	const previewMsg = `Preview instructions (apply to nodes under "${parentLabel}"):\n\n${previewStr}\n\nApply these changes?`;

	return {
		selectedPath: effectiveSelectedPath,
		selectedLabel: parentLabel,
		selectedType: parentType,
		instructions: usableInstructions,
		rawResponse: instructions,
		previewJson: previewStr,
		previewMessage: previewMsg,
		maxOps
	};
}

export function applyAiBulkEditInstructions(tree, instructions = [], options = {}) {
	const selectedPath = Array.isArray(options.selectedPath) && options.selectedPath.length > 0 ? options.selectedPath : getSelectedNodePath();
	const showSpinner = options.showSpinner !== false;
	const selectedNode = tree.get(selectedPath);
	if (!selectedNode || !selectedPath || selectedPath.length === 0) {
		throw new Error("No valid target is selected for applying AI bulk edit instructions.");
	}

	const itemTypesArr = (tree && tree.get && tree.get(["itemTypes"])) || (state && state.get && state.get(["itemTypes"])) || [];
	const allowedItemTypes = new Set(
		(Array.isArray(itemTypesArr) ? itemTypesArr.map((t) => t.type || t) : []).filter(Boolean).concat([
			"item",
			"itemYesNo",
			"itemPicker",
			"itemTextInput",
			"itemTextInputMultiline",
			"itemBarcodeScanner",
			"itemChoiceSingle",
			"itemChoiceMulti"
		])
	);
	const isAllowedItemType = (t) => allowedItemTypes.has((t || "").trim());

	if (!Array.isArray(instructions) || instructions.length === 0) {
		throw new Error("No usable AI bulk edit instructions are available to apply.");
	}

	if (showSpinner) {
		showEditorSpinner();
	}

	try {
		// Bulk edit performs some direct subtree mutation for recursive delete/append operations.
		// Freeze the current history snapshot first so Undo can reliably restore the pre-apply state.
		const currentHistoryIndex = tree.get("historyIndex");
		if (Number.isInteger(currentHistoryIndex) && currentHistoryIndex >= 0) {
			const historyEntryPath = ["history", currentHistoryIndex];
			const currentHistoryEntry = tree.get(historyEntryPath);
			if (currentHistoryEntry) {
				tree.set([...historyEntryPath, "tree"], _.cloneDeep(tree.get("tree")));
				tree.set([...historyEntryPath, "selectedNodePath"], Object.assign([], tree.get("selectedNodePath")));
				tree.set([...historyEntryPath, "typeahead"], _.cloneDeep(tree.get("typeahead")));
			}
		}

		let changed = 0;
		const changedIds = new Set();
		const deletePaths = [];
		const leafItemTypes = new Set([
			"item",
			"itemYesNo",
			"itemPicker",
			"itemTextInput",
			"itemTextInputMultiline",
			"itemBarcodeScanner",
			"itemChoiceSingle",
			"itemChoiceMulti",
			"itemDate",
			"itemTime",
			"itemDateTime",
			"itemWeather",
			"itemImagePicker",
			"itemSketchPad",
			"itemRanking",
			"itemAddress",
			"itemLocation",
			"itemSelect",
			"itemSearch",
			"itemButton"
		]);
		const getNormalizedNodeType = (node) => {
			const rawType = _.get(node, "entity.type", _.get(node, "type", ""));
			if (rawType === "checklist") { return "activity"; }
			if (rawType && rawType.startsWith("item") && rawType !== "itemContainer") { return "item"; }
			return rawType;
		};
		const getAllowedAppendChildTypes = (parentNode) => {
			const parentType = getNormalizedNodeType(parentNode);
			if (parentType === "activity") {
				const existingChildren = Array.isArray(parentNode && parentNode.children) ? parentNode.children : [];
				if (existingChildren.length > 0) {
					const firstChildType = getNormalizedNodeType(existingChildren[0]);
					if (firstChildType === "list") { return new Set(["list"]); }
					if (firstChildType === "section") { return new Set(["section"]); }
					if (firstChildType === "item") { return new Set([...leafItemTypes]); }
				}
				return new Set(["list", "section", ...leafItemTypes]);
			}
			if (parentType === "list") {
				return new Set(["section"]);
			}
			if (parentType === "section" || parentType === "itemContainer") {
				return new Set(["itemContainer", ...leafItemTypes]);
			}
			return new Set();
		};
		const getRequestedAppendType = (spec = {}) => {
			const requested = `${spec.type || ""}`.trim();
			if (requested === "item") {
				return `${spec.itemType || "item"}`.trim();
			}
			return requested;
		};
		const assertAppendSpecPlacement = (parentNode, spec, contextLabel = "appendNodes[0]") => {
			const allowedChildTypes = getAllowedAppendChildTypes(parentNode);
			const requestedType = getRequestedAppendType(spec);
			if (!allowedChildTypes.has(requestedType)) {
				throw new Error(`${contextLabel} cannot be placed under parent type "${getNormalizedNodeType(parentNode)}".`);
			}
			if (requestedType === "itemContainer") {
				const syntheticParent = { entity: { type: "itemContainer" }, children: [] };
				(spec.children || []).forEach((childSpec, index) => {
					assertAppendSpecPlacement(syntheticParent, childSpec, `${contextLabel}.children[${index}]`);
				});
			} else if (requestedType === "list" || requestedType === "section") {
				const syntheticParent = { entity: { type: requestedType }, children: [] };
				(spec.children || []).forEach((childSpec, index) => {
					assertAppendSpecPlacement(syntheticParent, childSpec, `${contextLabel}.children[${index}]`);
				});
			} else if (Array.isArray(spec.children) && spec.children.length > 0) {
				throw new Error(`${contextLabel} of type "${requestedType}" cannot include children.`);
			}
		};
		const normalizePropName = (k) => {
			const lower = (k || "").toLowerCase();
			if (lower === "labelonly") { return "labelOnly"; }
			if (lower === "labelonlybackgroundcolor") { return "labelOnlyBackgroundColor"; }
			if (lower === "label1" || lower === "labelone") { return "label1"; }
			if (lower === "label2") { return "label2"; }
			if (lower === "label3") { return "label3"; }
			if (lower === "label4") { return "label4"; }
			if (lower === "label") { return "label"; }
			if (lower === "visible") { return "visible"; }
			if (lower === "enabled") { return "enabled"; }
			if (lower === "type") { return "type"; }
			return k;
		};

		const instCounters = new WeakMap();
		const pickValue = (val, idx) => {
			if (Array.isArray(val)) {
				if (val.length === 0) { return undefined; }
				return val[idx % val.length];
			}
			return val;
		};

		const resolvePlaceholders = (val, entity) => {
			if (typeof val !== "string") { return val; }
			return val.replace(/\{([^}]+)\}/g, (_m, p1) => {
				const key = p1.trim();
				if (!entity) { return _m; }
				const fallbackLabel = entity.label || entity.name || entity.label1 || "";
				if (entity.hasOwnProperty(key)) {
					return entity[key] !== undefined && entity[key] !== null ? `${entity[key]}` : "";
				}
				if (key.toLowerCase() === "label" || key.toLowerCase() === "label1" || key.toLowerCase() === "name" || key.toLowerCase() === "title") {
					return fallbackLabel;
				}
				return _m;
			});
		};

		const applyInstruction = (node, inst, path) => {
			if (!node || !node.entity) { return false; }
			const { type, label, name, label1 } = node.entity;
			const nodeType = type || "";
			const labelText = label || name || label1 || "";
			const nodeTypeKey = nodeType === "checklist" ? "activity" : nodeType.startsWith("item") ? "item" : nodeType;
			if (!inst.targetTypes.includes(nodeTypeKey.toLowerCase())) { return false; }
			if (inst.textContains && !labelText.toLowerCase().includes(inst.textContains)) { return false; }

			let touched = false;
			const currentIdx = instCounters.get(inst) || 0;
			const resolveValue = (val) => {
				if (typeof val === "string") {
					const splitMatch = val.match(/^\{label1?\.split\(['"]-['"]\)\[(\d+)\](?:\.trim\(\))?\}$/i);
					if (splitMatch) {
						const idx = parseInt(splitMatch[1], 10);
						const parts = labelText.split("-").map((p) => p.trim());
						return parts[idx] || "";
					}
					if (val.toLowerCase().includes("match label")) {
						return labelText;
					}
					let out = val
						.replace(/\{label\}/gi, labelText)
						.replace(/\{label1?\}|\{name\}|\{title\}/gi, labelText)
						.replace(/\{label2\}/gi, node.entity.label2 || "");
					out = out.replace(/\{label1?\.split\(['"]-['"]\)\[(\d+)\](?:\.trim\(\))?\}/gi, (_m, p1) => {
						const idx = parseInt(p1, 10);
						const parts = labelText.split("-").map((p) => p.trim());
						return parts[idx] || "";
					});
					return out;
				}
				return val;
			};
			const changeProp = (prop, val) => {
				handleChangeProperty(tree, prop, val, path, null);
				touched = true;
				if (node.entity.guid) { changedIds.add(node.entity.guid); }
			};

			if (inst.delete === true) {
				if (path !== selectedPath) {
					deletePaths.push(path);
					touched = true;
					if (node.entity.guid) { changedIds.add(node.entity.guid); }
				}
			}
			if (inst.setLabel !== undefined && nodeTypeKey !== "activity") {
				const rawVal = pickValue(inst.setLabel, currentIdx);
				const resolvedVal = resolveValue(resolvePlaceholders(rawVal, node.entity));
				changeProp("label", resolvedVal);
			}
			if (nodeTypeKey === "item" && inst.setItemType) {
				const candidateType = pickValue(inst.setItemType, currentIdx);
				if (isAllowedItemType(candidateType)) {
					changeProp("type", candidateType);
				}
			}
			if (inst.setVisible !== undefined) {
				changeProp("visible", inst.setVisible);
			}
			if (inst.setEnabled !== undefined) {
				changeProp("enabled", inst.setEnabled);
			}
			if (inst.setProps && typeof inst.setProps === "object") {
				Object.keys(inst.setProps).forEach((k) => {
					const rawVal = pickValue(inst.setProps[k], currentIdx);
					const propName = normalizePropName(k);
					const resolvedVal = resolveValue(resolvePlaceholders(rawVal, node.entity));
					changeProp(propName, resolvedVal);
				});
			}
			if (touched) {
				instCounters.set(inst, currentIdx + 1);
			}
			return touched;
		};

		const hasTextFilters = instructions.some((inst) => inst.textContains);
		const deleteAllSpecs = instructions.filter((inst) => inst.delete === true && (!inst.textContains || inst.textContains.trim() === ""));

		const walkWith = (insts) => {
			let localChanged = 0;
			let instrPointer = 0;
			const walk = (path) => {
				const node = tree.get(path);
				if (!node || !node.entity) { return; }
				let nodeTouched = false;
				const total = insts.length;
				for (let offset = 0; offset < total; offset++) {
					const idx = (instrPointer + offset) % total;
					const inst = insts[idx];
					if (applyInstruction(node, inst, path)) {
						nodeTouched = true;
						instrPointer = idx + 1;
						localChanged += 1;
						break;
					}
				}
				if (nodeTouched && node.entity.guid) {
					changedIds.add(node.entity.guid);
				}
				if (node.children && node.children.length) {
					node.children.forEach((_c, idx) => walk(_.concat(path, ["children", idx])));
				}
			};
			walk(selectedPath);
			return localChanged;
		};

		changed = walkWith(instructions);

		if (changed === 0 && hasTextFilters) {
			const loosened = instructions.map((inst) => ({ ...inst, textContains: "" }));
			changed = walkWith(loosened);
		}

		if (deleteAllSpecs.length) {
			const parentNode = tree.get(selectedPath);
			const normalizeTypeKey = (t) => {
				if (t === "checklist") { return "activity"; }
				if (t && t.startsWith("item")) { return "item"; }
				return t || "";
			};
			const specTargets = deleteAllSpecs.map((s) => new Set((s.targetTypes || []).map((t) => t.toLowerCase())));
			const prune = (path) => {
				const node = tree.get(path);
				if (!node || !Array.isArray(node.children)) { return; }
				const pruned = [];
				node.children.forEach((child, idx) => {
					const childPath = _.concat(path, ["children", idx]);
					const key = normalizeTypeKey(child.entity && child.entity.type);
					const shouldDelete = specTargets.some((set) => set.has(key));
					if (shouldDelete) {
						if (child.entity && child.entity.guid) { changedIds.add(child.entity.guid); }
						changed += 1;
						return;
					}
					prune(childPath);
					pruned.push(child);
				});
				node.children = pruned;
			};
			if (parentNode && Array.isArray(parentNode.children)) {
				prune(selectedPath);
			}
		}
		if (deletePaths.length) {
			const sorted = deletePaths.slice().sort((a, b) => b.length - a.length);
			sorted.forEach((path) => {
				if (!Array.isArray(path) || path.length < 2) { return; }
				const idx = path[path.length - 1];
				const parentPath = path.slice(0, path.length - 2);
				const parent = tree.get(parentPath);
				if (parent && Array.isArray(parent.children) && idx >= 0 && idx < parent.children.length) {
					const removed = parent.children[idx];
					parent.children.splice(idx, 1);
					if (removed && removed.entity && removed.entity.guid) { changedIds.add(removed.entity.guid); }
				}
			});
		}

		const appendSpecs = instructions.flatMap((inst) => inst.appendNodes || []);
		if (appendSpecs.length) {
			const createNodeFromSpec = (spec) => {
				const t = (spec.type || "").toLowerCase();
				if (t === "list") {
					const entity = entityUtils.addListEntity(utils.generateUUID(), (spec.label || "List").trim());
					return entityUtils.addCategoryNode(entity, true);
				}
				if (t === "section") {
					const entity = entityUtils.addSectionEntity(utils.generateUUID(), (spec.label || "Section").trim(), true);
					return entityUtils.addCategoryNode(entity, true);
				}
				const requestedType = spec.itemType || spec.type || "item";
				const itemType = isAllowedItemType(requestedType) ? requestedType : "item";
				const entityId = utils.generateUUID();
				const entity = entityUtils.addItemEntity(entityId, (spec.label || "Item").trim(), "", false, false, "", itemType);
				const node = entityUtils.addItemNode(entity, false);
				if (spec.setProps && typeof spec.setProps === "object") {
					Object.keys(spec.setProps).forEach((k) => {
						const normKey = normalizePropName(k);
						node.entity[normKey] = spec.setProps[k];
					});
				}
				return node;
			};
			const parentNode = tree.get(selectedPath);
			if (parentNode) {
				appendSpecs.forEach((spec, index) => assertAppendSpecPlacement(parentNode, spec, `appendNodes[${index}]`));
				if (!parentNode.children) { parentNode.children = []; }
				parentNode.expanded = true;
				appendSpecs.forEach((spec) => {
					const node = createNodeFromSpec(spec);
					if (node) {
						parentNode.children.push(node);
						if (spec.children && Array.isArray(spec.children)) {
							const parentIdx = parentNode.children.length - 1;
							const addNested = (pPath, childrenSpecs) => {
								const pNode = tree.get(pPath);
								if (!pNode) { return; }
								if (!pNode.children) { pNode.children = []; }
								childrenSpecs.forEach((childSpec) => {
									const childNode = createNodeFromSpec(childSpec);
									if (childNode) {
										pNode.children.push(childNode);
										if (childSpec.children && Array.isArray(childSpec.children)) {
											addNested(_.concat(pPath, ["children", pNode.children.length - 1]), childSpec.children);
										}
									}
								});
							};
							addNested(_.concat(selectedPath, ["children", parentIdx]), spec.children);
						}
					}
				});
				changed += appendSpecs.length;
			}
		}

		saveUndoState();
		tree.commit();
		return {
			changedCount: changedIds.size || changed,
			changedGuids: Array.from(changedIds)
		};
	} finally {
		if (showSpinner) {
			hideEditorSpinner();
		}
	}
}

export async function handleApplyAiBulkEdit(tree, options = {}) {
	const result = await generateAiBulkEditInstructions(tree, options);
	const previewMsg = result.previewMessage;

	const continueApply = () => {
		showEditorSpinner();
		try {
			const applyResult = applyAiBulkEditInstructions(tree, result.instructions, {
				selectedPath: result.selectedPath,
				showSpinner: false
			});
			alert(`AI bulk edit complete. Changed ${applyResult.changedCount} node(s).`);
		} finally {
			hideEditorSpinner();
		}
	};

	if (env.config && env.config.useFancyAlerts) {
		showConfirm(previewMsg, "AI Bulk Edit Preview", () => {
			continueApply();
		});
		return;
	}

	const confirmed = (typeof window !== "undefined" && typeof window.confirm === "function")
		? window.confirm(previewMsg)
		: false;
	if (!confirmed) {
		return;
	}

	continueApply();
}

export async function handleGenerateAiOutline(tree, options = {}) {
	const selectedPath = getSelectedNodePath();
	const selectedNode = tree.get(selectedPath);

	if (!selectedNode || !selectedPath || selectedPath.length === 0) {
		return;
	}

	const maxNodesOpt = parseInt(options.maxNodes, 10);
	const maxNodes = _.isFinite(maxNodesOpt) && maxNodesOpt > 0 ? Math.min(maxNodesOpt, 100) : 100;
	const userPrompt = options.prompt || "Generate a practical AmbiFi structure under the selected node. Keep it simple by default and only add grouping when it improves usability.";
	const contentProfile = _.isString(options.contentProfile) && _.trim(options.contentProfile) !== ""
		? _.trim(options.contentProfile).toLowerCase()
		: "auto";

	const normalizeSelectedStructureType = (type = "") => {
		const lower = `${type || ""}`.toLowerCase().trim();
		if (lower === "checklist") { return "checklist"; }
		if (lower === "list") { return "list"; }
		if (lower === "section") { return "section"; }
		if (lower === "itemcontainer") { return "itemContainer"; }
		if (lower.startsWith("item")) { return "item"; }
		return "checklist";
	};

	const selectedStructureType = normalizeSelectedStructureType(selectedNode.entity.type || "node");
	const selectedLabel = (selectedNode.entity.label || selectedNode.entity.name || selectedNode.entity.label1 || "Selected Node").trim();
	const intent = inferStructureStudioIntent(userPrompt);

	if (selectedStructureType === "item" && !intent.allowsLeafSelection) {
		showError("Invalid target", "This request needs a target that can contain children. Select Activity, List, Section, or Item Container, or ask to insert before/after the selected item.");
		return;
	}

	const treePathToChecklistPath = (treePath = []) => {
		const checklistPath = [];
		for (let i = 0; i < treePath.length; i += 1) {
			if (treePath[i] === "children" && typeof treePath[i + 1] === "number") {
				checklistPath.push(treePath[i + 1]);
				i += 1;
			}
		}
		return checklistPath;
	};

	const getStructureNodeAtPath = (structureNode, checklistPath = []) => {
		let currentNode = structureNode;
		for (let i = 0; i < checklistPath.length; i += 1) {
			const index = checklistPath[i];
			const childNodes = _.isArray(currentNode && currentNode.children) ? currentNode.children : [];
			if (index < 0 || index >= childNodes.length) {
				return null;
			}
			currentNode = childNodes[index];
		}
		return currentNode;
	};

	const clipText = (value = "", maxChars = 6000) => {
		const text = typeof value === "string" ? value : `${value || ""}`;
		if (text.length <= maxChars) {
			return text;
		}
		return `${text.slice(0, maxChars)}\n... [truncated]`;
	};

	const summarizeChildNodes = (nodes = []) => {
		if (!Array.isArray(nodes) || nodes.length === 0) {
			return "(none)";
		}
		return nodes.slice(0, 12).map((node) => {
			if (!node || typeof node !== "object") {
				return "- unknown";
			}
			const label = node.name || node.label1 || "(blank)";
			return `- ${node.type}: ${label}`;
		}).join("\n");
	};

	const countNodes = (nodes = []) => {
		if (!Array.isArray(nodes)) {
			return 0;
		}
		let count = 0;
		nodes.forEach((node) => {
			count += 1;
			if (node && Array.isArray(node.children)) {
				count += countNodes(node.children);
			}
		});
		return count;
	};

	const exportedChecklist = transformFromChecklistEntities(tree.get(["tree", "root"]), false, false, false);
	const selectedChecklistPath = treePathToChecklistPath(selectedPath);
	const projectedStructure = projectChecklistToStructureV1(exportedChecklist);
	const selectedStructureNode = getStructureNodeAtPath(projectedStructure, selectedChecklistPath) || projectedStructure;
	const selectedStructureJson = clipText(JSON.stringify(selectedStructureNode, null, 2), 7000);
	const existingChildrenSummary = summarizeChildNodes(selectedStructureNode && selectedStructureNode.children ? selectedStructureNode.children : []);
	const displayParentType = selectedStructureType === "checklist" ? "activity" : selectedStructureType;

	const contentPlanSchema = `{
  "version": 1,
  "title": "content title",
  "kind": "reference | procedure | form | mixed",
  "sections": [
    {
      "title": "section title",
      "intro": "optional plain text intro",
      "groups": [
        {
          "title": "subheading title",
          "items": ["bullet text"],
          "steps": ["step text"],
          "fields": [
            {
              "label": "field label",
              "type": "text | multiline | yesNo | choiceSingle | choiceMulti | picker | date | time | datetime | address | location | search",
              "description": "optional"
            }
          ]
        }
      ],
      "items": ["bullet text"],
      "steps": ["step text"],
      "fields": [
        {
          "label": "field label",
          "type": "text | multiline | yesNo | choiceSingle | choiceMulti | picker | date | time | datetime | address | location | search",
          "description": "optional"
        }
      ]
    }
  ]
}`;

	const structureSchema = `{
  "version": 1,
  "operations": [
    {
      "op": "appendChildren",
      "target": { "mode": "selected" },
      "nodes": [
        {
          "type": "section | list | itemContainer | item*",
          "name": "for list/section only",
          "label1": "for item/itemContainer only",
          "label2": "optional for item/itemContainer",
          "labelOnly": true,
          "children": [ ... same structure rules ... ]
        }
      ]
    }
  ]
}`;

	const hierarchyRules = `AmbiFi structure rules:
- Activity can contain lists, sections, item containers, and leaf items.
- Lists can contain sections only.
- Sections can contain item containers and leaf items.
- Item containers can contain item containers and leaf items.
- Leaf items cannot contain children.
- Use name for lists/sections.
- Use label1 and optional label2 for items/item containers.
- labelOnly is only valid when type is item.
- Do not include datasource, styling, media, conditions, comments, or other rich properties.`;

	const prompt = `${userPrompt}
You are working in AmbiFi AI Structure Studio.
The selected node is type "${displayParentType}" with label "${selectedLabel}".
Always return JSON only.
Use the patch operation that matches the user's request.
Operation rules:
- If the user asks for a sibling, use insertAfter targeting { mode: "selected" } unless they explicitly ask for before.
- If the user asks for before/above, use insertBefore targeting { mode: "selected" }.
- If the user asks for after/below, use insertAfter targeting { mode: "selected" }.
- If the user asks to create under/inside the selected node, use appendChildren targeting { mode: "selected" }.
- If the user asks to replace the selected node's children, use replaceChildren targeting { mode: "selected" }.
- If the user asks to replace the selected node itself, use replaceNode targeting { mode: "selected" }.
If the user asks for a specific node title like "called Test", use that exact title and do not invent extra content.
Prefer the simplest structure that preserves clarity.
Use itemContainer when multiple related fields belong together.
If the request includes YAML or JSON structure content, preserve nested children exactly instead of flattening them.
Allowed leaf item types: item, itemYesNo, itemPicker, itemTextInput, itemTextInputMultiline, itemBarcodeScanner, itemChoiceSingle, itemChoiceMulti, itemDate, itemTime, itemDateTime, itemWeather, itemImagePicker, itemSketchPad, itemRanking, itemAddress, itemLocation, itemSelect, itemSearch, itemButton.
${hierarchyRules}
Return ONLY valid JSON matching this patch schema:
${structureSchema}
Max new nodes including descendants: ${maxNodes}.
Current selected node structure (JSON):
${selectedStructureJson}
Existing direct children:
${existingChildrenSummary}`;

	const contentPlanPrompt = `${userPrompt}
You are working in AmbiFi AI Structure Studio.
First create a neutral content outline, not AmbiFi nodes.
The selected parent is type "${displayParentType}" with label "${selectedLabel}".
Style preference: ${contentProfile}.
Think about the content first, then the app will map that plan into AmbiFi structure.
Rules:
- Do not output AmbiFi node types like section, itemContainer, itemTextInput, itemPicker, or patch operations.
- Use sections, groups, items, steps, and fields only.
- Use fields only when the end user should enter data.
- For recipes, how-to content, procedures, and checklists, prefer sections/groups/items/steps over fields.
- For grouped content like ingredient categories, use groups with items underneath.
- Keep the content concrete and useful, like a strong ChatGPT outline would.
Return ONLY valid JSON matching this content plan schema:
${contentPlanSchema}`;

	showEditorSpinner();
	let structurePatch = null;
	let contentPlan = null;
	try {
		structurePatch = coerceStructurePatchV1(userPrompt, {
			defaultTarget: { mode: "selected" }
		});

		if (!structurePatch && intent.generationMode !== "structurePatch") {
			contentPlan = coerceContentPlanV1(userPrompt, {
				defaultKind: contentProfile === "auto" ? "reference" : contentProfile
			});
			if (contentPlan) {
				structurePatch = contentPlanToStructurePatchV1(contentPlan, {
					parentType: selectedStructureType,
					contentProfile,
					defaultTarget: { mode: "selected" }
				});
			}
		}

		const makeContentPlanPrompt = (strict = false) => {
			const strictSuffix = strict
				? "Return ONLY a valid JSON object. No prose. No markdown. If you cannot comply, return {\"version\":1,\"title\":\"\",\"kind\":\"reference\",\"sections\":[]}"
				: "Return only the JSON object.";
			return {
				messages: [
					{
						role: "system",
						content: "You generate structured content outlines."
					},
					{
						role: "user",
						content: `${contentPlanPrompt}\n${strictSuffix}`
					}
				],
				model: "gpt-5.4"
			};
		};

		const makeStructurePatchPrompt = (strict = false) => {
			const strictSuffix = strict
				? "Return ONLY a valid JSON object. No prose. No markdown. If you cannot comply, return {\"version\":1,\"operations\":[]}"
				: "Return only the JSON object.";
			return {
				messages: [
					{
						role: "system",
						content: "You generate AmbiFi structure patches."
					},
					{
						role: "user",
						content: `${prompt}\n${strictSuffix}`
					}
				],
				model: "gpt-5.4"
			};
		};

		if ((!structurePatch || !Array.isArray(structurePatch.operations) || structurePatch.operations.length === 0) && intent.generationMode !== "structurePatch") {
			const primary = await getChatCompletionsLambda(JSON.stringify(makeContentPlanPrompt(false)));
			contentPlan = coerceContentPlanV1(primary, {
				defaultKind: contentProfile === "auto" ? "reference" : contentProfile
			});
			if (contentPlan) {
				structurePatch = contentPlanToStructurePatchV1(contentPlan, {
					parentType: selectedStructureType,
					contentProfile,
					defaultTarget: { mode: "selected" }
				});
			}
		}
		if ((!structurePatch || !Array.isArray(structurePatch.operations) || structurePatch.operations.length === 0) && intent.generationMode !== "structurePatch") {
			const strict = await getChatCompletionsLambda(JSON.stringify(makeContentPlanPrompt(true)));
			contentPlan = coerceContentPlanV1(strict, {
				defaultKind: contentProfile === "auto" ? "reference" : contentProfile
			});
			if (contentPlan) {
				structurePatch = contentPlanToStructurePatchV1(contentPlan, {
					parentType: selectedStructureType,
					contentProfile,
					defaultTarget: { mode: "selected" }
				});
			}
		}

		if (!structurePatch || !Array.isArray(structurePatch.operations) || structurePatch.operations.length === 0) {
			const primaryPatch = await getChatCompletionsLambda(JSON.stringify(makeStructurePatchPrompt(false)));
			structurePatch = coerceStructurePatchV1(primaryPatch, {
				defaultTarget: { mode: "selected" }
			});
		}
		if (!structurePatch || !Array.isArray(structurePatch.operations) || structurePatch.operations.length === 0) {
			const strictPatch = await getChatCompletionsLambda(JSON.stringify(makeStructurePatchPrompt(true)));
			structurePatch = coerceStructurePatchV1(strictPatch, {
				defaultTarget: { mode: "selected" }
			});
		}
	} catch (err) {
		console.error("AI structure generation failed", err);
		hideEditorSpinner();
		alert("AI structure generation failed. Please try again.");
		return;
	}

	if (!structurePatch || !Array.isArray(structurePatch.operations) || structurePatch.operations.length === 0) {
		hideEditorSpinner();
		alert("AI structure generation returned no usable patch. No changes were made.");
		return;
	}

	let totalCount = 0;
	structurePatch.operations.forEach((operation) => {
		totalCount += countNodes(operation && operation.nodes ? operation.nodes : []);
	});
	if (totalCount > maxNodes) {
		hideEditorSpinner();
		alert(`AI structure generation returned ${totalCount} nodes which exceeds the limit (${maxNodes}). Please try again with a smaller request.`);
		return;
	}

	const previewSummary = structurePatch.operations.map((operation, index) => {
		const targetMode = _.get(operation, "target.mode", "unknown");
		const opCount = countNodes(operation && operation.nodes ? operation.nodes : []);
		return `${index + 1}. ${operation.op || "unknown"} -> ${targetMode} (${opCount} node${opCount === 1 ? "" : "s"})`;
	}).join("\n");
	const previewJson = clipText(JSON.stringify(structurePatch, null, 2), 8000);
	const previewMsg = `Preview structure patch for "${selectedLabel}":\n\n${previewSummary}\n\nPatch JSON:\n${previewJson}\n\nApply these changes?`;

	const continueApply = () => {
		try {
			const currentChecklist = transformFromChecklistEntities(tree.get(["tree", "root"]), false, false, false);
			const patchedChecklist = applyStructurePatchV1(currentChecklist, structurePatch, {
				selectedPath: selectedChecklistPath
			});
			const srcTree = transformToChecklistEntities(patchedChecklist);
			srcTree.root.expanded = true;
			resetTree(srcTree.root.children);
			tree.set("selectedChecklistId", srcTree.root.id);
			tree.set(["tree"], srcTree);
			handleSelectNodeAtPath(tree, selectedPath);
			saveUndoState();
			tree.commit();
			hideEditorSpinner();
		} catch (err) {
			console.error("AI structure application failed", err);
			hideEditorSpinner();
			showError2("AI Structure Studio", `Unable to apply generated structure.\n\n${err.message}`);
		}
	};

	if (env.config && env.config.useFancyAlerts) {
		hideEditorSpinner();
		showConfirm(previewMsg, "AI Structure Studio Preview", () => {
			showEditorSpinner();
			continueApply();
		});
		return;
	}

	const confirmed = (typeof window !== "undefined" && typeof window.confirm === "function")
		? window.confirm(previewMsg)
		: false;
	if (!confirmed) {
		hideEditorSpinner();
		return;
	}

	continueApply();
}

export async function handleGenerateIds(tree, options = {}) {
	const selectedPath = getSelectedNodePath();
	const selectedNode = tree.get(selectedPath);

	if (!selectedNode || !selectedPath || selectedPath.length === 0) {
		return;
	}
	if (`${options.basis || "name"}`.toLowerCase() === "ai" && !isAiCapabilityEnabled(env.appCapabilities)) {
		showError2("ID Generator", "AI ID generation is not available in this environment.");
		return;
	}

	showEditorSpinner();

	try {
		const includeSelected = options.includeSelected !== false;
		const scope = options.scope || "selected";
		const excludes = options.excludes || {};
		const basis = (options.basis || "name").toLowerCase();
		const aiPrompt = options.aiPrompt || "";
		const expression = options.expression || "${nodeType}-${index}";
		const idStyle = (options.idStyle || "kebab").toLowerCase();
		const useHierarchy = !!options.useHierarchy;
		const clearIds = !!options.clear;
		const skipIfHasId = !!options.skipIfHasId;
		const maxLengthOpt = parseInt(options.maxLength, 10);
		const maxLength = _.isFinite(maxLengthOpt) && maxLengthOpt > 0 ? maxLengthOpt : 32;
		const useAi = basis === "ai";

		const trimToLength = (value, length) => {
			if (!value) { return ""; }
			return value.length > length ? value.slice(0, length) : value;
		};

		const wordsFromId = (value) => {
			if (!value) { return []; }
			const normalized = value
				.replace(/\bw\s*\/\s*/gi, "with ")
				.replace(/['’]/g, "");
			return normalized
				.replace(/[^a-zA-Z0-9]+/g, " ")
				.trim()
				.split(/\s+/)
				.filter(Boolean);
		};

		const sanitizeLabelText = (text, fallback) => {
			let cleaned = text || "";
			cleaned = stripAmbifiMarkdownColorSyntax(cleaned);
			// remove markdown (including links)
			cleaned = removeMarkdown(cleaned);
			// first line only
			cleaned = cleaned.split(/\r?\n/)[0] || cleaned;
			// strip URLs
			cleaned = cleaned.replace(/https?:\/\/\S+/gi, " ");
			cleaned = cleaned.trim();
			return cleaned || fallback || "";
		};

		const normalizeToWordsText = (text, fallback = "") => {
			const cleaned = sanitizeLabelText(text, fallback);
			return cleaned
				.replace(/\bw\s*\/\s*/gi, "with ")
				.replace(/['’]/g, "")
				.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
				.replace(/[^a-zA-Z0-9]+/g, " ")
				.trim();
		};

		const applyIdStyle = (value, style, fallbackLabel = "") => {
			let words = wordsFromId(value);
			if (words.length <= 1 && fallbackLabel) {
				words = wordsFromId(fallbackLabel);
			}
			if (words.length === 0) { return ""; }

			switch (style) {
				case "camel": {
					const [first, ...rest] = words;
					return [first.toLowerCase(), ...rest.map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())].join("");
				}
				case "pascal":
					return words.map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join("");
				case "snake":
					return words.map(w => w.toLowerCase()).join("_");
				case "kebab":
				default:
					return words.map(w => w.toLowerCase()).join("-");
			}
		};

		const rootNode = tree.get(["tree", "root"]);
		const usedIds = new Set();

		const collectIds = (node) => {
			if (!node || !node.entity) { return; }
			const { id, checklistId } = node.entity;
			if (id) { usedIds.add(id); }
			if (checklistId) { usedIds.add(checklistId); }
			if (node.children && node.children.length) {
				node.children.forEach(collectIds);
			}
		};

		collectIds(rootNode);

		const getIndexFromPath = (path) => {
			for (let i = path.length - 1; i >= 0; i--) {
				if (typeof path[i] === "number") {
					return path[i];
				}
			}
			return 0;
		};

		const isItemType = (type = "") => {
			return type === "item" || type.startsWith("item");
		};

		const shouldSkip = (type = "") => {
			const normalized = type.toLowerCase();
			if (normalized === "list" && excludes.lists) { return true; }
			if (normalized === "section" && excludes.sections) { return true; }
			if (isItemType(normalized) && excludes.items) { return true; }
			return false;
		};

		const pathKey = (path) => JSON.stringify(path || []);

		const getParentPath = (path) => {
			if (!path || path.length < 2) { return null; }
			return path.slice(0, path.length - 2);
		};

		const findListAncestorPath = (path) => {
			let currentPath = getParentPath(path);
			while (currentPath && currentPath.length >= 2) {
				const node = tree.get(currentPath);
				if (node && node.entity && node.entity.type === "list") {
					return currentPath;
				}
				currentPath = getParentPath(currentPath);
			}
			return null;
		};

		const isSectionType = (type = "") => {
			return type === "section" || type.startsWith("section");
		};

		const findSectionAncestorPath = (path) => {
			let currentPath = getParentPath(path);
			while (currentPath && currentPath.length >= 2) {
				const node = tree.get(currentPath);
				if (node && node.entity && isSectionType(node.entity.type || "")) {
					return currentPath;
				}
				currentPath = getParentPath(currentPath);
			}
			return null;
		};

		const buildIdForNode = (entity, nodeType, index = 0, isRootSelected = false) => {
			const oneBasedIndex = index + 1;
			const displayType = nodeType === "checklist" ? "activity" : (nodeType || "node");

			if (basis === "name") {
				const baseRaw = entity.label || entity.name || entity.label1 || `${displayType}-${oneBasedIndex}`;
				const normalizedBase = baseRaw
					.replace(/\bw\s*\/\s*/gi, "with ")
					.replace(/['’]/g, "");
				const spaced = normalizedBase
					.replace(/[_-]+/g, " ")
					.replace(/([a-z0-9])([A-Z])/g, "$1 $2")
					.replace(/[^a-zA-Z0-9]+/g, " ")
					.trim();
				const cleaned = spaced !== "" ? spaced : `${displayType} ${oneBasedIndex}`;
				return cleaned;
			}

			if (basis === "guid") {
				const guidBase = nodeType === "checklist"
					? ((isRootSelected ? (tree.get(["tree", "root", "id"]) || entity.id) : entity.id) || entity.guid || `${displayType}-${oneBasedIndex}`)
					: (entity.guid || `${displayType}-${oneBasedIndex}`);
				return guidBase;
			}

			if (basis === "expression") {
				const context = {
					nodeType: displayType,
					index: oneBasedIndex,
					name: entity.label || entity.name || "",
					label1: entity.label1 || "",
					guid: entity.guid || ""
				};
				const applied = applyIdTemplate(expression, context).trim();
				if (applied !== "") {
					return applied;
				}
			}
			if (basis === "ai") {
				// AI-generated base will be applied later; return empty to allow fallback
				return "";
			}

			const fallbackBase = entity.guid || `${displayType}-${oneBasedIndex}`;
			const slug = slugifyId(fallbackBase);
			const cleaned = slug !== "" ? slug : fallbackBase;
			return cleaned;
		};

		const generatedIdsByPath = new Map();

		const getHierarchyPrefixBase = (path, nodeType) => {
			if (!useHierarchy || nodeType === "list") { return ""; }

			const preferSection = isItemType(nodeType);
			let ancestorPath = null;

			if (preferSection) {
				const parentPath = getParentPath(path);
				const parentNode = parentPath ? tree.get(parentPath) : null;
				if (parentNode && parentNode.entity && isSectionType(parentNode.entity.type || "")) {
					ancestorPath = parentPath;
				} else {
					ancestorPath = findSectionAncestorPath(path) || findListAncestorPath(path);
				}
			} else {
				ancestorPath = findListAncestorPath(path);
			}

			if (!ancestorPath) { return ""; }
			const ancestorKey = pathKey(ancestorPath);
			let ancestorId = generatedIdsByPath.get(ancestorKey);
			if (!ancestorId) {
				const ancestorNode = tree.get(ancestorPath);
				if (ancestorNode && ancestorNode.entity) {
					const ancestorEntity = ancestorNode.entity;
					ancestorId = ancestorEntity.id || ancestorEntity.label || ancestorEntity.name || ancestorEntity.label1 || "";
				}
			}
			if (!ancestorId) { return ""; }
			return normalizeToWordsText(ancestorId, "");
		};


		const ensureUnique = (base, style) => {
			const suffixForStyle = (num) => {
				if (style === "snake") { return `_${num}`; }
				if (style === "kebab") { return `-${num}`; }
				// camel/pascal/default
				return `${num}`;
			};

			let candidate = trimToLength(base, maxLength);
			if (!candidate || candidate === "") {
				candidate = trimToLength(`${base}` || "node", maxLength);
			}

			let counter = 2;
			while (!candidate || usedIds.has(candidate)) {
				const suffix = suffixForStyle(counter);
				const allowed = Math.max(1, maxLength - suffix.length);
				const trimmed = trimToLength(base, allowed);
				candidate = `${trimmed}${suffix}`;
				counter += 1;
			}
			usedIds.add(candidate);
			return candidate;
		};

		const collectPaths = (path, acc) => {
			const node = tree.get(path);
			if (!node || !node.entity) { return; }
			acc.push(path);
			if (node.children && node.children.length) {
				node.children.forEach((_child, childIdx) => {
					collectPaths(_.concat(path, ["children", childIdx]), acc);
				});
			}
		};

		const allPaths = [];
		collectPaths(selectedPath, allPaths);

		// Build list of nodes to generate IDs for
		const nodesToProcess = [];
		allPaths.forEach((path) => {
			const node = tree.get(path);
			if (!node || !node.entity) { return; }
			const entity = node.entity;
			const nodeType = entity.type || "node";
			const propName = nodeType === "checklist" ? "checklistId" : "id";
			const isSelectedPath = _.isEqual(path, selectedPath);
			const skipCurrent = shouldSkip(nodeType);
			const index = getIndexFromPath(path);

			const shouldProcess = scope === "node" ? isSelectedPath : (includeSelected || !isSelectedPath);

			if (shouldProcess && !skipCurrent) {
				const hasExisting = !!entity[propName];
				if (skipIfHasId && hasExisting) {
					return;
				}
				nodesToProcess.push({ path, entity, nodeType, propName, index, isSelectedPath });
			}
		});

		// Optionally ask AI for suggestions (with a strict retry if the first attempt fails)
		const parseAiResponse = (resp) => {
			const tryExtractArray = (val) => {
				if (!val) { return null; }
				if (Array.isArray(val)) { return val; }
				if (typeof val === "object") {
					for (const key of Object.keys(val)) {
						if (Array.isArray(val[key])) { return val[key]; }
					}
				}
				return null;
			};
			const splitLoose = (str) => str.split(/[\r\n,]+/).map(s => s.trim()).filter(Boolean);

			let parsedArray = null;
			if (typeof resp === "string") {
				try {
					const json = JSON.parse(resp);
					parsedArray = tryExtractArray(json);
				} catch (_err) {
					const match = resp.match(/\[([\s\S]*)\]/);
					if (match && match[0]) {
						try {
							const json = JSON.parse(match[0]);
							parsedArray = tryExtractArray(json);
						} catch (_) {
							parsedArray = null;
						}
					}
					if (!parsedArray) {
						parsedArray = splitLoose(resp);
					}
				}
			} else if (resp && typeof resp === "object") {
				parsedArray = tryExtractArray(resp);
			}

			if (Array.isArray(parsedArray)) {
				return parsedArray
					.map((s) => (typeof s === "string" ? s : `${s || ""}`))
					.map((s) => s.trim())
					.filter(Boolean);
			}
			return [];
		};

		let aiSuggestions = [];
		if (useAi && nodesToProcess.length > 0) {
			const defaultPrompt = "Example: Generate an outline of lists, sections and items with 3 lists nodes, 3 sections nodes per list and 3 item nodes per section.";
			const promptToUse = aiPrompt && aiPrompt.trim() !== "" ? aiPrompt : defaultPrompt;
			const systemSuffix = "Use concise, readable labels. Return ONLY the JSON outline per the schema (type, label, optional itemType, children). Return only a JSON array of IDs, in order, with no extra text.";
			const nodeLines = nodesToProcess.map((n, idx) => {
				let baseName = sanitizeLabelText(n.entity.label || n.entity.name || n.entity.label1 || "", "");
				const displayType = n.nodeType === "checklist" ? "activity" : (n.nodeType || "node");
				return `${idx + 1}. type: ${displayType}, label: "${baseName}", index: ${n.index + 1}`;
			}).join("\n");

			const makePrompt = (basePrompt, strict = false) => {
				const strictSuffix = strict
					? "Return ONLY a valid JSON array of strings (no keys, no extra text). If you cannot comply, return an empty JSON array []."
					: systemSuffix;
				return {
					messages: [
						{
							role: "system",
							content: "You generate clean, unique IDs."
						},
						{
							role: "user",
							content: `${basePrompt}\n${strictSuffix}\nMax length: ${maxLength}.\nNodes:\n${nodeLines}`
						}
					],
					model: "gpt-5.4"
				};
			};

			try {
				const primaryResp = await getChatCompletionsLambda(JSON.stringify(makePrompt(promptToUse, false)));
				if (primaryResp) {
					console.log("AI IDs primary response:", primaryResp);
				}
				aiSuggestions = parseAiResponse(primaryResp);

				if (aiSuggestions.length === 0) {
					const strictResp = await getChatCompletionsLambda(JSON.stringify(makePrompt(promptToUse, true)));
					if (strictResp) {
						console.log("AI IDs strict response:", strictResp);
					}
					aiSuggestions = parseAiResponse(strictResp);
				}
			} catch (err) {
				console.error("AI ID generation failed, falling back", err);
			}

			if (aiSuggestions.length === 0) {
				alert("AI ID generation returned no usable IDs; IDs were left unchanged.");
				return;
			}
		}

		nodesToProcess.forEach((nodeInfo, idx) => {
			const { path, entity, nodeType, propName, index, isSelectedPath } = nodeInfo;
			if (clearIds) {
				handleChangeProperty(tree, propName, "", path, null);
				return;
			}

			let baseId = "";
			if (useAi) {
				if (aiSuggestions.length > idx && aiSuggestions[idx]) {
					baseId = aiSuggestions[idx];
				} else {
					// No AI value for this node; leave unchanged
					return;
				}
			} else {
				baseId = buildIdForNode(entity, nodeType, index, nodeType === "checklist" && isSelectedPath);
				if (!/[a-zA-Z0-9]/.test(baseId)) {
					baseId = "";
				}
				if (!baseId || baseId === "") {
					const fallbackBase = entity.guid || `${nodeType || "node"}-${index + 1}`;
					baseId = fallbackBase;
				}
			}

			const hierarchyPrefix = getHierarchyPrefixBase(path, nodeType);
			const combinedBase = hierarchyPrefix ? `${hierarchyPrefix} ${baseId}`.trim() : baseId;
			const fallbackLabel = sanitizeLabelText(entity.label || entity.name || entity.label1 || `${nodeType || "node"} ${index + 1}`, "");
			const styledBase = useAi ? applyIdStyle(combinedBase.trim(), idStyle, fallbackLabel) : applyIdStyle(combinedBase, idStyle, fallbackLabel);
			const newId = ensureUnique(styledBase, idStyle);
			handleChangeProperty(tree, propName, newId, path, null);
			generatedIdsByPath.set(pathKey(path), newId);
		});
		saveUndoState();
		tree.commit();
	} finally {
		hideEditorSpinner();
	}
}

export function showReassignModalForActivity(tree, activityUrl) {
	tree.set(["appState", "reassignModal", "activityUrl"], activityUrl);
	tree.set(["appState", "reassignModal", "show"], true);
}

export function showReassignModal(tree, instanceUrl, instance = {}) {
	const customerIdentity = ["company", "customerGuid", "customerCode"].reduce((result, field) => {
		const value = instance && instance[field];
		if (_.isString(value) && value.trim() !== "") {
			result[field] = value.trim();
		}
		return result;
	}, {});

	tree.set(["appState", "reassignModal", "instanceUrl"], instanceUrl);
	tree.set(["appState", "reassignModal", "jobContext"], {
		instanceId: instance && instance.instanceId ? instance.instanceId : "",
		jobId: instance && (instance.jobIdString || instance.jobId) ? (instance.jobIdString || instance.jobId) : "",
		customerIdentity
	});
	tree.set(["appState", "reassignModal", "show"], true);
}

export function hideReassignModal(tree) {
	tree.set(["appState", "reassignModal", "show"], false);
	tree.set(["appState", "reassignModal", "jobContext"], null);
}

export function showPlaylistsModal(tree) {
	tree.set(["appState", "playlistsModal", "show"], true);
}

export function hidePlaylistsModal(tree) {
	tree.set(["appState", "playlistsModal", "show"], false);
}

function getPricingModalWorkItemProgress(workItem = {}) {
	return (_.isPlainObject(workItem.progress) && workItem.progress)
		|| (_.isPlainObject(_.get(workItem, ["metadata", "progress"])) && _.get(workItem, ["metadata", "progress"]))
		|| {};
}

function getPricingModalSourceInstanceUrl(source = {}) {
	return _.trim(`${source.url || source.instanceUrl || source.sharedSessionUrl || _.get(source, ["progress", "instanceUrl"]) || _.get(source, ["metadata", "launchContext", "instanceUrl"]) || ""}`);
}

function getPricingModalSourceActivityInstanceId(source = {}) {
	return _.trim(`${source.instanceId || source.activityInstanceId || _.get(source, ["progress", "activityInstanceId"]) || _.get(source, ["metadata", "launchContext", "activityInstanceId"]) || ""}`);
}

function buildPricingModalSourceContext(source = {}) {
	if (!isProjectOpsEnabledForOrg(getOrgId())) {
		return null;
	}

	const progress = getPricingModalWorkItemProgress(source);
	const metadata = _.isPlainObject(source.metadata) ? source.metadata : {};
	const rawProjectOps = source.projectOps
		|| progress.projectOps
		|| _.get(progress, ["activityOps", "projectOps"])
		|| metadata.projectOps
		|| _.get(metadata, ["launchContext", "projectOps"])
		|| _.get(metadata, ["progress", "projectOps"])
		|| _.get(metadata, ["progress", "activityOps", "projectOps"])
		|| (source.projectOpsProjectId || source.projectOpsProjectName || source.projectOpsStageKey || source.projectOpsStageLabel ? {
			projectId: source.projectOpsProjectId || "",
			projectName: source.projectOpsProjectName || "",
			stageKey: source.projectOpsStageKey || "",
			stageLabel: source.projectOpsStageLabel || ""
		} : null);
	const projectOps = normalizeProjectOpsContext(rawProjectOps || {});
	const workflowLaunch = source.workflowLaunch || _.get(metadata, "launchContext") || _.get(progress, "workflowLaunch") || null;
	const activityOps = source.activityOps || progress.activityOps || null;
	const pricingContractProto = source.pricingContractProto
		|| progress.pricingContractProto
		|| _.get(progress, ["activityOps", "pricingContractProto"])
		|| metadata.pricingContractProto
		|| _.get(metadata, ["progress", "pricingContractProto"])
		|| _.get(metadata, ["progress", "activityOps", "pricingContractProto"])
		|| _.get(activityOps, "pricingContractProto")
		|| null;
	const projectContractAnchor = normalizeProjectContractAnchor(
		source.projectContractAnchor
		|| progress.projectContractAnchor
		|| _.get(progress, ["activityOps", "projectContractAnchor"])
		|| metadata.projectContractAnchor
		|| _.get(metadata, ["launchContext", "projectContractAnchor"])
		|| _.get(metadata, ["progress", "projectContractAnchor"])
		|| _.get(metadata, ["progress", "activityOps", "projectContractAnchor"])
		|| _.get(activityOps, "projectContractAnchor")
		|| _.get(projectOps, "projectContractAnchor")
	)
		|| getPricingSaveProjectContractAnchor(source, workflowLaunch || {}, projectOps);
	if (!projectOps.projectId && !projectOps.projectName && !projectContractAnchor && !workflowLaunch && !activityOps) {
		return null;
	}
	return _.pickBy({
		projectOps: projectContractAnchor ? { ...projectOps, projectContractAnchor } : projectOps,
		projectContractAnchor,
		workflowLaunch,
		activityOps,
		pricingContractProto
	}, value => value !== undefined && value !== null && value !== "");
}

function applyPricingModalSourceContext(tree, sourceContext = null) {
	if (!sourceContext) {
		return;
	}
	tree.set(["appState", "showPricing", "sourceContext"], sourceContext);
	if (hasManagedPricingContractProto(sourceContext.pricingContractProto)) {
		tree.set(["appState", "showPricing", "pricingContractProto"], sourceContext.pricingContractProto);
		tree.set(["appState", "showPricing", "pricingContractProtoTemp"], sourceContext.pricingContractProto);
	}
	const checklist = tree.get(["appState", "showPricing", "checklist"]) || {};
	if (Object.keys(checklist).length > 0) {
		tree.set(["appState", "showPricing", "checklist"], {
			...checklist,
			projectOps: checklist.projectOps || sourceContext.projectOps || null,
			projectContractAnchor: checklist.projectContractAnchor || sourceContext.projectContractAnchor || null,
			workflowLaunch: checklist.workflowLaunch || sourceContext.workflowLaunch || null,
			activityOps: checklist.activityOps || sourceContext.activityOps || null,
			pricingContractProto: hasManagedPricingContractProto(sourceContext.pricingContractProto)
				? sourceContext.pricingContractProto
				: checklist.pricingContractProto || null
		});
	}
}

function createEmptyPricingModalState(overrides = {}) {
	const emptyJobDetails = {
		name: "",
		description: "",
		instructions: "",
		notes: "",
		parts: ""
	};
	return {
		checklist: {},
		session: null,
		loading: false,
		saving: false,
		pricingSnapshotId: "base",
		pricingSnapshotIdTemp: "base",
		pricingMode: "wholesale",
		pricingModeTemp: "wholesale",
		pricingModeForced: false,
		selectedValue: "",
		selectedValueTemp: "",
		invoiceItems: [],
		invoiceItemsTemp: [],
		estimates: [],
		estimatesTemp: [],
		jobDetails: emptyJobDetails,
		jobDetailsTemp: { ...emptyJobDetails },
		pricingContractProto: null,
		pricingContractProtoTemp: null,
		projectOpsContext: null,
		source: {},
		sourceContext: null,
		showModal: false,
		url: "",
		...overrides
	};
}

async function hydratePricingModalProjectOpsContext(tree, url, source = {}, pricingSession = null) {
	if (!isProjectOpsEnabledForOrg(getOrgId())) {
		return;
	}
	if (!isPricingSessionActive(tree.get(["appState", "showPricing"]) || {}, pricingSession)) {
		return;
	}

	const sourceInstanceUrl = pricingSession?.url || getPricingModalSourceInstanceUrl(source) || _.trim(`${url || ""}`);
	const sourceActivityInstanceId = pricingSession?.instanceId || getPricingModalSourceActivityInstanceId(source);
	if (!sourceInstanceUrl && !sourceActivityInstanceId) {
		return;
	}

	try {
		const response = await listActivityWorkflowWorkItems({
			orgId: getOrgId(),
			limit: 250
		});
		const workItems = getWorkflowResponseArray(response, "workItems");
		const matchedWorkItem = workItems.find((workItem) => {
			const progress = getPricingModalWorkItemProgress(workItem);
			const metadata = _.isPlainObject(workItem.metadata) ? workItem.metadata : {};
			const workItemUrl = getPricingModalSourceInstanceUrl({
				...workItem,
				progress,
				metadata
			});
			const workItemActivityInstanceId = getPricingModalSourceActivityInstanceId({
				...workItem,
				progress,
				metadata
			});
			return (sourceInstanceUrl && workItemUrl && workItemUrl === sourceInstanceUrl)
				|| (sourceActivityInstanceId && workItemActivityInstanceId && workItemActivityInstanceId === sourceActivityInstanceId);
		});
		const sourceContext = buildPricingModalSourceContext(matchedWorkItem || {});
		if (isPricingSessionActive(tree.get(["appState", "showPricing"]) || {}, pricingSession)) {
			applyPricingModalSourceContext(tree, sourceContext);
		}
	} catch (err) {
		if (isPricingSessionActive(tree.get(["appState", "showPricing"]) || {}, pricingSession)) {
			console.warn("Unable to hydrate Project Ops context for pricing modal", {
				url,
				error: err && err.message ? err.message : err
			});
		}
	}
}

export function showPricingModal(tree, url, source = {}) {
	const pricingSession = createPricingSession(url, generateUUID());
	if (!pricingSession) {
		showError(
			"Unable to Open Pricing",
			"The selected job does not have a valid activity-instance address. Refresh Status and try again."
		);
		return Promise.resolve(null);
	}
	const sourceUrl = getPricingModalSourceInstanceUrl(source);
	const sourceInstanceId = getPricingModalSourceActivityInstanceId(source);
	const sourceMatchesPricingTarget = (!sourceUrl || sourceUrl === pricingSession.url)
		&& (!sourceInstanceId || sourceInstanceId === pricingSession.instanceId);
	const sourceContext = sourceMatchesPricingTarget ? buildPricingModalSourceContext(source) : null;
	tree.set(["appState", "showPricing"], createEmptyPricingModalState({
		session: pricingSession,
		loading: true,
		source: sourceMatchesPricingTarget ? _.cloneDeep(source || {}) : {},
		sourceContext: sourceContext || null,
		url: pricingSession.url
	}));
	tree.commit();

	const loadPromise = awsS3.showPricing(tree, env.s3.contentBucket, pricingSession.url, pricingSession);
	hydratePricingModalProjectOpsContext(tree, pricingSession.url, source, pricingSession);
	return loadPromise;
}

export async function showEstimateManagerModal(tree, hit = {}, hydratedChecklist = null, options = {}) {
	const url = hit.url || "";
	const viewerMode = options && options.viewerMode === "customerApproval"
		? "customerApproval"
		: "manage";
	const initialEstimateValue = _.toString(options && options.initialEstimateValue).trim();
	tree.set(["appState", "showEstimateManager", "hit"], hit || {});
	tree.set(["appState", "showEstimateManager", "url"], url);
	tree.set(["appState", "showEstimateManager", "initialEstimateValue"], initialEstimateValue);
	tree.set(["appState", "showEstimateManager", "showModal"], true);
	tree.set(["appState", "showEstimateManager", "loading"], !hydratedChecklist && Boolean(url));
	tree.set(["appState", "showEstimateManager", "saving"], false);
	tree.set(["appState", "showEstimateManager", "checklist"], hydratedChecklist || {});
	tree.set(["appState", "showEstimateManager", "viewerMode"], viewerMode);
	tree.commit();

	if (!url) {
		return hydratedChecklist;
	}

	try {
		const checklist = await awsS3.loadActivityInstanceFromS3(env.s3.contentBucket, url);
		if (tree.get(["appState", "showEstimateManager", "url"]) === url) {
			tree.set(["appState", "showEstimateManager", "checklist"], checklist || {});
			tree.set(["appState", "showEstimateManager", "loading"], false);
			tree.commit();
		}
		return checklist;
	} catch (err) {
		if (tree.get(["appState", "showEstimateManager", "url"]) === url) {
			tree.set(["appState", "showEstimateManager", "loading"], false);
			if (!hydratedChecklist) {
				tree.set(["appState", "showEstimateManager", "showModal"], false);
			}
			tree.commit();
		}
		return null;
	}
}

export function closeEstimateManagerModal(tree) {
	tree.set(["appState", "showEstimateManager", "showModal"], false);
	tree.set(["appState", "showEstimateManager", "loading"], false);
	tree.set(["appState", "showEstimateManager", "saving"], false);
	tree.set(["appState", "showEstimateManager", "checklist"], {});
	tree.set(["appState", "showEstimateManager", "hit"], {});
	tree.set(["appState", "showEstimateManager", "initialEstimateValue"], "");
	tree.set(["appState", "showEstimateManager", "viewerMode"], "manage");
	tree.set(["appState", "showEstimateManager", "url"], "");
	tree.commit();
}

function hasManagedPricingContractProto(pricingContractProto) {
	return Boolean(pricingContractProto && _.isArray(pricingContractProto.documents) && pricingContractProto.documents.length > 0);
}

function isProjectOpsAddendumIntent(projectOps = {}) {
	const normalizedProjectOps = normalizeProjectOpsContext(projectOps);
	const artifactType = _.toString(normalizedProjectOps.artifactType || "").trim().toLowerCase();
	const contractMode = _.toString(normalizedProjectOps.contractMode || "").trim().toLowerCase();
	return artifactType === "addendum" || contractMode.indexOf("addendum") !== -1;
}

function getProjectOpsContractDocuments(pricingContractProto = null) {
	return hasManagedPricingContractProto(pricingContractProto) ? pricingContractProto.documents : [];
}

function getProjectOpsContractDocumentById(pricingContractProto = null, documentId = "") {
	const normalizedDocumentId = _.toString(documentId || "").trim();
	if (!normalizedDocumentId) {
		return null;
	}
	return getProjectOpsContractDocuments(pricingContractProto).find(document => _.toString(document && document.id || "").trim() === normalizedDocumentId) || null;
}

function getActiveProjectOpsContractDocument(pricingContractProto = null) {
	const documents = getProjectOpsContractDocuments(pricingContractProto);
	if (documents.length === 0) {
		return null;
	}
	return getProjectOpsContractDocumentById(pricingContractProto, pricingContractProto.activeDocumentId)
		|| documents[documents.length - 1]
		|| null;
}

function getBaseProjectOpsContractDocument(pricingContractProto = null, activeDocument = null) {
	if (!activeDocument) {
		return null;
	}
	const baseDocumentId = _.toString(activeDocument.baseDocumentId || "").trim();
	if (baseDocumentId) {
		const baseDocument = getProjectOpsContractDocumentById(pricingContractProto, baseDocumentId);
		if (baseDocument) {
			return baseDocument;
		}
	}

	const documents = getProjectOpsContractDocuments(pricingContractProto);
	const activeIndex = documents.findIndex(document => document && activeDocument && document.id === activeDocument.id);
	return activeIndex > 0 ? documents[activeIndex - 1] : null;
}

function getProjectOpsInvoiceItemLineKey(invoiceItem = {}) {
	const lineId = _.toString(invoiceItem.lineId || "").trim();
	if (lineId) {
		return `line:${lineId}`;
	}
	const id = _.toString(invoiceItem.id || "").trim();
	const productId = _.toString(invoiceItem.productId || "").trim();
	const description = _.toString(invoiceItem.description || "").trim();
	const settlesContractLineId = _.toString(invoiceItem.settlesContractLineId || "").trim();
	if (id || productId || description) {
		return `item:${id}|product:${productId}|description:${description}|settles:${settlesContractLineId}`;
	}
	return "";
}

function mergeProjectOpsInvoiceItemsByLineKey(...itemGroups) {
	const mergedItems = [];
	const indexByKey = new Map();
	itemGroups.forEach((items = []) => {
		(Array.isArray(items) ? items : []).forEach((invoiceItem) => {
			const lineKey = getProjectOpsInvoiceItemLineKey(invoiceItem);
			if (lineKey && indexByKey.has(lineKey)) {
				mergedItems.splice(indexByKey.get(lineKey), 1, _.cloneDeep(invoiceItem));
				return;
			}
			if (lineKey) {
				indexByKey.set(lineKey, mergedItems.length);
			}
			mergedItems.push(_.cloneDeep(invoiceItem));
		});
	});
	return mergedItems;
}

function isAllowanceInvoiceItem(invoiceItem = {}) {
	return invoiceItem && (invoiceItem.lineType === "allowance" || invoiceItem.recordType === "allowance");
}

function getProjectOpsInvoiceItemAmount(invoiceItem = {}) {
	const value = Number(invoiceItem.value);
	if (Number.isFinite(value)) {
		return value;
	}
	const rate = Number(invoiceItem.rate) || 0;
	const qty = Number(invoiceItem.qty) || 0;
	const discount = Number.isFinite(Number(invoiceItem.discount)) ? Number(invoiceItem.discount) : 1;
	const total = rate * qty * discount;
	return Number.isFinite(total) ? total : 0;
}

function getProjectOpsBudgetTargetInvoiceItem(projectOps = {}, invoiceItems = []) {
	const resolution = getProjectOpsBudgetTargetResolution(projectOps, invoiceItems);
	return resolution ? resolution.invoiceItem : null;
}

function getProjectOpsBudgetTargetResolution(projectOps = {}, invoiceItems = []) {
	const normalizedProjectOps = normalizeProjectOpsContext(projectOps);
	const budgetTargets = Array.isArray(normalizedProjectOps.budgetTargets) ? normalizedProjectOps.budgetTargets : [];
	if (budgetTargets.length === 0) {
		return null;
	}

	if (normalizedProjectOps.activeBudgetLineId) {
		const activeTarget = (Array.isArray(invoiceItems) ? invoiceItems : []).find(invoiceItem => (
			isAllowanceInvoiceItem(invoiceItem)
			&& _.toString(invoiceItem.lineId || "").trim() === normalizedProjectOps.activeBudgetLineId
		));
		if (activeTarget) {
			const activeBudgetTarget = budgetTargets.find(target => _.toString(target.lineId || "").trim() === normalizedProjectOps.activeBudgetLineId) || {
				lineId: normalizedProjectOps.activeBudgetLineId
			};
			return {
				invoiceItem: activeTarget,
				target: activeBudgetTarget
			};
		}
	}

	for (let targetIndex = 0; targetIndex < budgetTargets.length; targetIndex++) {
		const budgetTarget = budgetTargets[targetIndex];
		const matchedInvoiceItem = (Array.isArray(invoiceItems) ? invoiceItems : []).find(invoiceItem => (
			invoiceItemMatchesProjectOpsBudgetTarget(invoiceItem, budgetTarget)
		));
		if (matchedInvoiceItem) {
			return {
				invoiceItem: matchedInvoiceItem,
				target: budgetTarget
			};
		}
	}

	return null;
}

function buildProjectOpsBudgetSettlementFields(budgetTargetInvoiceItem = {}, activeDocument = {}) {
	const budgetLineId = _.toString(budgetTargetInvoiceItem.lineId || "").trim();
	if (!budgetLineId) {
		return {};
	}
	return {
		settlesContractLineId: budgetLineId,
		allowanceSettlement: {
			budgetLineId,
			budgetDescription: budgetTargetInvoiceItem.description || "",
			budgetAmount: getProjectOpsInvoiceItemAmount(budgetTargetInvoiceItem),
			budgetCategory: _.get(budgetTargetInvoiceItem, ["allowance", "category"]) || "",
			addendumId: activeDocument.id || "",
			addendumNumber: Number(activeDocument.number) || 0
		}
	};
}

function buildProjectOpsContributionFields(projectOps = {}) {
	return _.pickBy({
		projectId: projectOps.projectId,
		projectName: projectOps.projectName,
		stageKey: projectOps.stageKey,
		stageLabel: projectOps.stageLabel,
		addendumNumber: projectOps.addendumNumber,
		changeMode: projectOps.changeMode,
		budgetApplicationPolicy: projectOps.budgetApplicationPolicy,
		source: "cloudProjectOpsPricingSave"
	}, value => value !== undefined && value !== null && value !== "");
}

function mergeProjectOpsContributionIntoPricingContractProto(data = {}) {
	if (!isProjectOpsEnabledForOrg(getOrgId())) {
		return data;
	}

	const workflowLaunch = getPricingSaveWorkflowLaunch(data);
	const projectOps = normalizeProjectOpsContext(getPricingSaveProjectOps(data, workflowLaunch));
	if (!isProjectOpsAddendumIntent(projectOps)) {
		return data;
	}

	const pricingContractProto = data.pricingContractProto || _.get(data, ["activityOps", "pricingContractProto"]);
	if (!hasManagedPricingContractProto(pricingContractProto)) {
		return data;
	}

	const activeDocument = getActiveProjectOpsContractDocument(pricingContractProto);
	if (!activeDocument || activeDocument.kind !== "addendum" || activeDocument.status !== "draft") {
		return data;
	}

	const incomingInvoiceItems = Array.isArray(data.invoiceItems) ? data.invoiceItems : [];
	if (incomingInvoiceItems.length === 0) {
		return data;
	}

	const currentDocumentItems = Array.isArray(activeDocument.invoiceItems) ? activeDocument.invoiceItems : [];
	const baseDocument = getBaseProjectOpsContractDocument(pricingContractProto, activeDocument);
	const baseDocumentItems = Array.isArray(baseDocument && baseDocument.invoiceItems) ? baseDocument.invoiceItems : [];
	const baselineDocumentItems = mergeProjectOpsInvoiceItemsByLineKey(baseDocumentItems, currentDocumentItems);
	const documentItemKeys = new Set(baselineDocumentItems.map(getProjectOpsInvoiceItemLineKey).filter(Boolean));
	const baseItemKeys = new Set(baseDocumentItems.map(getProjectOpsInvoiceItemLineKey).filter(Boolean));
	const incomingKeys = incomingInvoiceItems.map(getProjectOpsInvoiceItemLineKey).filter(Boolean);
	const overlapCount = incomingKeys.filter(key => documentItemKeys.has(key)).length;
	const baseOverlapCount = incomingKeys.filter(key => baseItemKeys.has(key)).length;
	const incomingCoversBaseDocument = baseItemKeys.size === 0 || baseOverlapCount >= Math.min(3, baseItemKeys.size);
	const shouldTreatIncomingAsFullActiveDocument = incomingCoversBaseDocument && (
		incomingInvoiceItems.length >= baselineDocumentItems.length
		|| overlapCount >= Math.min(3, documentItemKeys.size)
	);

	const mergedItems = shouldTreatIncomingAsFullActiveDocument
		? _.cloneDeep(incomingInvoiceItems)
		: _.cloneDeep(baselineDocumentItems);
	const mergedItemIndexByKey = new Map();
	mergedItems.forEach((invoiceItem, index) => {
		const lineKey = getProjectOpsInvoiceItemLineKey(invoiceItem);
		if (lineKey) {
			mergedItemIndexByKey.set(lineKey, index);
		}
	});

	if (!shouldTreatIncomingAsFullActiveDocument) {
		incomingInvoiceItems.forEach((invoiceItem) => {
			const lineKey = getProjectOpsInvoiceItemLineKey(invoiceItem);
			if (lineKey && mergedItemIndexByKey.has(lineKey)) {
				mergedItems.splice(mergedItemIndexByKey.get(lineKey), 1, _.cloneDeep(invoiceItem));
			} else {
				mergedItems.push(_.cloneDeep(invoiceItem));
			}
		});
	}

	const budgetTargetResolution = getProjectOpsBudgetTargetResolution(projectOps, [
		...baseDocumentItems,
		...currentDocumentItems,
		...incomingInvoiceItems
	]);
	const budgetSettlementFields = budgetTargetResolution && budgetTargetResolution.invoiceItem
		? buildProjectOpsBudgetSettlementFields(budgetTargetResolution.invoiceItem, activeDocument)
		: {};
	const budgetTargetForPolicy = budgetTargetResolution && budgetTargetResolution.target
		? {
			...budgetTargetResolution.target,
			lineId: budgetSettlementFields.settlesContractLineId || budgetTargetResolution.target.lineId || ""
		}
		: null;
	const shouldSetActiveBudgetLineId = budgetSettlementFields.settlesContractLineId
		&& _.toString(projectOps.changeMode || "").trim().toLowerCase() !== "contract_change";
	const incomingKeySet = new Set(incomingKeys);
	const nextDocumentItems = mergedItems.map((invoiceItem) => {
		if (!invoiceItem || typeof invoiceItem !== "object" || isAllowanceInvoiceItem(invoiceItem)) {
			return invoiceItem;
		}
		const lineKey = getProjectOpsInvoiceItemLineKey(invoiceItem);
		if (!lineKey || baseItemKeys.has(lineKey) || !incomingKeySet.has(lineKey)) {
			return invoiceItem;
		}
		const hasExplicitSettlementField = Object.prototype.hasOwnProperty.call(invoiceItem, "settlesContractLineId");
		const shouldSettleAgainstBudget = !hasExplicitSettlementField
			&& !invoiceItem.settlesContractLineId
			&& budgetSettlementFields.settlesContractLineId
			&& shouldApplyProjectOpsBudgetSettlement({
				projectOps,
				invoiceItem,
				budgetTarget: budgetTargetForPolicy
			});
		const nextItem = {
			...invoiceItem,
			projectOpsContribution: {
				...(invoiceItem.projectOpsContribution && typeof invoiceItem.projectOpsContribution === "object" ? invoiceItem.projectOpsContribution : {}),
				...buildProjectOpsContributionFields(projectOps)
			}
		};
		return shouldSettleAgainstBudget
			? {
				...nextItem,
				...budgetSettlementFields
			}
			: nextItem;
	});

	const nextPricingContractProto = {
		...pricingContractProto,
			documents: pricingContractProto.documents.map((document) => {
				if (!document || document.id !== activeDocument.id) {
					return document;
				}
				return {
					...document,
					activeBudgetLineId: shouldSetActiveBudgetLineId ? budgetSettlementFields.settlesContractLineId : document.activeBudgetLineId || "",
					invoiceItems: nextDocumentItems
				};
			})
		};

	return {
		...data,
		invoiceItems: nextDocumentItems,
		pricingContractProto: nextPricingContractProto
	};
}

function normalizeProjectContractAnchor(anchor = null) {
	if (!_.isPlainObject(anchor)) {
		return null;
	}
	const normalized = {
		projectId: _.trim(`${anchor.projectId || ""}`),
		projectName: _.trim(`${anchor.projectName || ""}`),
		workItemId: _.trim(`${anchor.workItemId || ""}`),
		activityId: _.trim(`${anchor.activityId || ""}`),
		activityInstanceId: _.trim(`${anchor.activityInstanceId || anchor.instanceId || ""}`),
		instanceUrl: _.trim(`${anchor.instanceUrl || anchor.activityInstanceUrl || anchor.sharedSessionUrl || anchor.url || ""}`),
		stageKey: _.trim(`${anchor.stageKey || ""}`),
		stageLabel: _.trim(`${anchor.stageLabel || ""}`),
		source: _.trim(`${anchor.source || "project_ops_contract_anchor"}`)
	};
	return (normalized.workItemId || normalized.instanceUrl || normalized.activityInstanceId)
		? _.pickBy(normalized, value => value !== "")
		: null;
}

function getPricingSaveWorkflowLaunch(data = {}) {
	const candidates = [
		_.get(data, ["activityOps", "workflowLaunch"]),
		_.get(data, "workflowLaunch"),
		_.get(data, "launchContext"),
		_.get(data, ["metadata", "launchContext"])
	];
	return candidates.find(candidate => _.isPlainObject(candidate) && _.trim(`${candidate.workItemId || ""}`)) || {};
}

function getPricingSaveProjectOps(data = {}, workflowLaunch = getPricingSaveWorkflowLaunch(data)) {
	return _.get(data, ["activityOps", "projectOps"])
		|| data.projectOps
		|| workflowLaunch.projectOps
		|| _.get(workflowLaunch, ["launchContext", "projectOps"])
		|| _.get(data, ["metadata", "projectOps"])
		|| {};
}

function getPricingSaveProjectContractAnchor(data = {}, workflowLaunch = getPricingSaveWorkflowLaunch(data), projectOps = getPricingSaveProjectOps(data, workflowLaunch)) {
	const candidates = [
		data.projectContractAnchor,
		_.get(data, ["activityOps", "projectContractAnchor"]),
		workflowLaunch.projectContractAnchor,
		_.get(workflowLaunch, ["launchContext", "projectContractAnchor"]),
		projectOps && projectOps.projectContractAnchor,
		_.get(data, ["metadata", "projectContractAnchor"]),
		_.get(data, ["metadata", "launchContext", "projectContractAnchor"])
	];
	return candidates.map(candidate => normalizeProjectContractAnchor(candidate)).find(Boolean) || null;
}

function buildAnchorInstanceProjectOps(anchor = {}, existingProjectOps = {}, contributingProjectOps = {}) {
	return _.pickBy({
		...(existingProjectOps || {}),
		projectId: anchor.projectId || existingProjectOps.projectId || contributingProjectOps.projectId || "",
		projectName: anchor.projectName || existingProjectOps.projectName || contributingProjectOps.projectName || "",
		projectType: existingProjectOps.projectType || contributingProjectOps.projectType || "",
		projectStatus: existingProjectOps.projectStatus || contributingProjectOps.projectStatus || "",
		stageKey: existingProjectOps.stageKey || anchor.stageKey || "",
		stageLabel: existingProjectOps.stageLabel || anchor.stageLabel || "",
		activityRole: existingProjectOps.activityRole || "",
		artifactType: existingProjectOps.artifactType || "contract",
		contractMode: existingProjectOps.contractMode || "initial_purchase",
		projectContractAnchor: anchor,
		latestContribution: _.pickBy({
			stageKey: contributingProjectOps.stageKey,
			stageLabel: contributingProjectOps.stageLabel,
			addendumNumber: contributingProjectOps.addendumNumber,
			contractMode: contributingProjectOps.contractMode,
			artifactType: contributingProjectOps.artifactType
		}, value => value !== undefined && value !== null && value !== "")
	}, value => value !== undefined && value !== null && value !== "");
}

function normalizeProjectOpsTagText(value) {
	return _.trim(`${value || ""}`);
}

function mergeProjectOpsTags(existingTags = [], projectOps = {}) {
	const sourceTags = _.isArray(existingTags) ? existingTags : [];
	const projectName = normalizeProjectOpsTagText(projectOps.projectName);
	const projectId = normalizeProjectOpsTagText(projectOps.projectId);
	const stageLabel = normalizeProjectOpsTagText(projectOps.stageLabel || projectOps.stageKey);
	const anchor = projectOps.projectContractAnchor || {};
	const nextTags = sourceTags.filter(tag => {
		const text = normalizeProjectOpsTagText(tag).toLowerCase();
		return text !== "project-ops"
			&& text.indexOf("project:") !== 0
			&& text.indexOf("stage:") !== 0
			&& text !== "contract-anchor"
			&& text !== "contract-contributor";
	});
	if (projectName || projectId) {
		nextTags.push("project-ops");
		nextTags.push(`project: ${projectName || projectId}`);
	}
	if (stageLabel) {
		nextTags.push(`stage: ${stageLabel}`);
	}
	if (anchor && anchor.workItemId) {
		nextTags.push(anchor.stageKey === projectOps.stageKey ? "contract-anchor" : "contract-contributor");
	}
	return Array.from(new Set(nextTags));
}

function stripProjectOpsInstanceFields(data = {}) {
	if (!data || !_.isPlainObject(data)) {
		return data;
	}
	const stripped = _.omit(data, [
		"projectOps",
		"projectContractAnchor",
		"workflowLaunch",
		"activityOps",
		"projectOpsProjectId",
		"projectOpsProjectName",
		"projectOpsStageKey",
		"projectOpsStageLabel",
		"projectOpsPricingScope",
		"projectOpsContributionTotal",
		"projectOpsBudgetTotal",
		"projectOpsBudgetDelta",
		"projectOpsContributionSummaryString",
		"projectOpsContributionDetailString"
	]);
	if (_.isArray(stripped.tags)) {
		stripped.tags = stripped.tags.filter((tag) => {
			const text = _.trim(`${tag || ""}`).toLowerCase();
			return text !== "project-ops"
				&& text.indexOf("project:") !== 0
				&& text.indexOf("stage:") !== 0
				&& text !== "contract-anchor"
				&& text !== "contract-contributor";
		});
	}
	return stripped;
}

function buildProjectOpsContributionPricingIndexFields(data = {}) {
	const summary = getProjectOpsContributionPricingSummary(_.omit(data, [
		"projectOpsContributionSummaryString",
		"projectOpsContributionDetailString",
		"pricingBudgetSummaryString",
		"pricingBudgetDetailString"
	]));
	if (!summary || !summary.primaryText) {
		return {};
	}

	return _.pickBy({
		projectOpsPricingScope: "contribution",
		projectOpsContributionTotal: Number.isFinite(summary.spentTotal) ? summary.spentTotal : undefined,
		projectOpsBudgetTotal: Number.isFinite(summary.budgetTotal) ? summary.budgetTotal : undefined,
		projectOpsBudgetDelta: Number.isFinite(summary.delta) ? summary.delta : undefined,
		projectOpsContributionSummaryString: summary.primaryText,
		projectOpsContributionDetailString: summary.detailText || "",
		pricingBudgetSummaryString: summary.primaryText,
		pricingBudgetDetailString: summary.detailText || ""
	}, value => value !== undefined && value !== null && value !== "");
}

function prepareProjectOpsInstanceForSave(data = {}) {
	if (!isProjectOpsEnabledForOrg(getOrgId())) {
		return data;
	}

	const workflowLaunch = getPricingSaveWorkflowLaunch(data);
	const projectOps = getPricingSaveProjectOps(data, workflowLaunch);
	const projectContractAnchor = getPricingSaveProjectContractAnchor(data, workflowLaunch, projectOps);
	if (!projectOps.projectId && !projectOps.projectName && !projectContractAnchor) {
		return data;
	}
	const projectId = projectOps.projectId || (projectContractAnchor && projectContractAnchor.projectId) || "";
	const projectName = projectOps.projectName || (projectContractAnchor && projectContractAnchor.projectName) || "";
	const nextProjectOps = projectContractAnchor
		? {
			...projectOps,
			projectContractAnchor
		}
		: projectOps;
	const projectOpsData = {
		...data,
		projectOps: nextProjectOps,
		projectContractAnchor: projectContractAnchor || data.projectContractAnchor || null,
		projectOpsProjectId: projectId || data.projectOpsProjectId || "",
		projectOpsProjectName: projectName || data.projectOpsProjectName || "",
		projectOpsStageKey: projectOps.stageKey || data.projectOpsStageKey || "",
		projectOpsStageLabel: projectOps.stageLabel || data.projectOpsStageLabel || "",
		tags: mergeProjectOpsTags(data.tags || [], nextProjectOps)
	};
	const contributionPricingIndexFields = buildProjectOpsContributionPricingIndexFields(projectOpsData);
	return {
		...projectOpsData,
		...contributionPricingIndexFields
	};
}

function getWorkflowResponseArray(response, key) {
	return _.get(response, ["body", key])
		|| _.get(response, key)
		|| _.get(response, ["body", "items"])
		|| _.get(response, "items")
		|| [];
}

function getPricingSaveWorkItemProgress(workItem = {}) {
	return (_.isPlainObject(workItem.progress) && workItem.progress)
		|| (_.isPlainObject(_.get(workItem, ["metadata", "progress"])) && _.get(workItem, ["metadata", "progress"]))
		|| {};
}

function getPricingSaveWorkItemActivityId(workItem = {}) {
	const progress = getPricingSaveWorkItemProgress(workItem);
	return _.trim(`${workItem.activityId || progress.activityId || _.get(workItem, ["metadata", "launchContext", "activityId"]) || ""}`);
}

function getPricingSaveWorkItemActivityInstanceId(workItem = {}) {
	const progress = getPricingSaveWorkItemProgress(workItem);
	return _.trim(`${workItem.activityInstanceId || progress.activityInstanceId || _.get(workItem, ["metadata", "launchContext", "activityInstanceId"]) || ""}`);
}

async function resolvePricingSaveWorkItemId(workflowLaunch = {}, data = {}) {
	const directWorkItemId = _.trim(`${workflowLaunch.workItemId || ""}`);
	if (directWorkItemId) {
		return directWorkItemId;
	}

	const activityId = _.trim(`${data.id || workflowLaunch.activityId || ""}`);
	const activityInstanceId = _.trim(`${data.instanceId || workflowLaunch.activityInstanceId || ""}`);
	if (!activityId || !activityInstanceId) {
		return "";
	}

	try {
		const response = await listActivityWorkflowWorkItems({
			orgId: getOrgId(),
			limit: 250
		});
		const workItems = getWorkflowResponseArray(response, "workItems");
		const match = workItems.find((workItem) => (
			getPricingSaveWorkItemActivityId(workItem) === activityId
			&& getPricingSaveWorkItemActivityInstanceId(workItem) === activityInstanceId
		));
		return match ? _.trim(`${match.id || ""}`) : "";
	} catch (err) {
		console.warn("Unable to resolve Project Ops work item for pricing progress sync", {
			activityId,
			activityInstanceId,
			error: err && err.message ? err.message : err
		});
		return "";
	}
}

async function syncProjectOpsPricingProgress(fileName, data = {}) {
	if (!isProjectOpsEnabledForOrg(getOrgId())) {
		return null;
	}

	const workflowLaunch = getPricingSaveWorkflowLaunch(data);
	const pricingContractProto = data.pricingContractProto || _.get(data, ["activityOps", "pricingContractProto"]);
	if (!hasManagedPricingContractProto(pricingContractProto)) {
		return null;
	}

	const workItemId = await resolvePricingSaveWorkItemId(workflowLaunch, data);
	if (!workItemId) {
		return null;
	}

	const projectOps = getPricingSaveProjectOps(data, workflowLaunch);
	const projectContractAnchor = getPricingSaveProjectContractAnchor(data, workflowLaunch, projectOps);
	const activityOpsRole = _.get(data, ["activityOps", "role"]) || projectOps.activityRole || projectOps.stageKey || workflowLaunch.activityOpsRole || workflowLaunch.role || "";
	const payload = {
		reason: "Pricing contract updated from AmbiFi Cloud pricing modal.",
		activityId: data.id || workflowLaunch.activityId || null,
		activityInstanceId: data.instanceId || workflowLaunch.activityInstanceId || null,
		instanceUrl: fileName || workflowLaunch.instanceUrl || workflowLaunch.activityInstanceUrl || null,
		instanceName: data.sessionName || data.name || null,
		pricingContractProto,
		projectContractAnchor,
		projectOps,
		activityOps: {
			role: activityOpsRole || null,
			source: "cloudPricingModalSave",
			projectOps,
			pricingContractProto,
			projectContractAnchor
		},
		workflowLaunch: _.pick({
			...workflowLaunch,
			workItemId,
			projectContractAnchor
		}, [
			"workItemId",
			"activityId",
			"activityInstanceId",
			"role",
			"activityOpsRole",
			"recipientRole",
			"recipientType",
			"status",
			"openMode",
			"projectContractAnchor"
		])
	};

	try {
		const result = await updateActivityWorkflowWorkItemProgress(workItemId, payload);
		if (projectContractAnchor && projectContractAnchor.instanceUrl && projectContractAnchor.instanceUrl !== fileName) {
			try {
				const anchorInstance = await awsS3.getObject(env.s3.contentBucket, projectContractAnchor.instanceUrl) || {};
				const anchorProjectOps = buildAnchorInstanceProjectOps(projectContractAnchor, anchorInstance.projectOps || {}, projectOps || {});
				const anchorStamp = stampIchInstanceForSave({
					...anchorInstance,
					pricingContractProto,
					projectOps: anchorProjectOps,
					projectContractAnchor,
					projectOpsProjectId: anchorProjectOps.projectId || anchorInstance.projectOpsProjectId || "",
					projectOpsProjectName: anchorProjectOps.projectName || anchorInstance.projectOpsProjectName || "",
					projectOpsStageKey: anchorProjectOps.stageKey || anchorInstance.projectOpsStageKey || "",
					projectOpsStageLabel: anchorProjectOps.stageLabel || anchorInstance.projectOpsStageLabel || "",
					tags: mergeProjectOpsTags(anchorInstance.tags || [], anchorProjectOps)
				});
				const nextAnchorInstance = anchorStamp.instance;
				await awsS3.saveInstance(env.s3.contentBucket, projectContractAnchor.instanceUrl, nextAnchorInstance);
				if (projectContractAnchor.workItemId && projectContractAnchor.workItemId !== workItemId) {
					await updateActivityWorkflowWorkItemProgress(projectContractAnchor.workItemId, {
						reason: "Project contract anchor updated from AmbiFi Cloud pricing modal.",
						activityId: projectContractAnchor.activityId || null,
						activityInstanceId: projectContractAnchor.activityInstanceId || null,
						instanceUrl: projectContractAnchor.instanceUrl,
						instanceName: projectContractAnchor.projectName || null,
						pricingContractProto,
						projectOps: anchorProjectOps,
						projectContractAnchor,
						activityOps: {
							source: "cloudPricingModalProjectContractAnchorSync",
							projectOps: anchorProjectOps,
							pricingContractProto,
							projectContractAnchor,
							contributingWorkItemId: workItemId
						}
					});
				}
				if (anchorStamp.reachedMilestoneKeys.length > 0) {
					await advanceIchProjectForMilestones(nextAnchorInstance, anchorStamp.reachedMilestoneKeys, { projectId: projectContractAnchor.projectId });
				}
			} catch (anchorErr) {
				console.warn("Project Ops contract anchor sync from pricing save failed", {
					projectContractAnchor,
					error: anchorErr && anchorErr.message ? anchorErr.message : anchorErr
				});
				showWarningToast("Pricing saved, but the project contract anchor was not updated. Reopen Status after refresh and verify the contract before continuing.");
			}
		}
		return result;
	} catch (err) {
		console.warn("Project Ops pricing progress sync failed", {
			workItemId,
			activityId: payload.activityId,
			activityInstanceId: payload.activityInstanceId,
			error: err && err.message ? err.message : err
		});
		showWarningToast("Pricing saved, but Project Ops progress was not updated. The next stage may need to be opened manually after refresh.");
		return null;
	}
}

function isIchContractAnchorPricingSave(fileName, data = {}) {
	// Contract milestones live on the home's contract anchor instance. A contributor
	// (addendum) save reaches the anchor through syncProjectOpsPricingProgress instead.
	const anchor = data.projectContractAnchor || _.get(data, ["projectOps", "projectContractAnchor"]) || null;
	if (!anchor) {
		return true;
	}
	const anchorUrl = _.toString(anchor.instanceUrl || "").trim();
	if (anchorUrl) {
		return anchorUrl === fileName;
	}
	// Anchors built at launch carry no url yet; fall back to the instance id so a
	// contributor session is never mistaken for the home.
	const anchorInstanceId = _.toString(anchor.activityInstanceId || "").trim();
	const instanceId = _.toString(data.instanceId || "").trim();
	return !anchorInstanceId || !instanceId || anchorInstanceId === instanceId;
}

export async function savePricing(tree, fileName, data, pricingSession) {
	const currentPricingState = tree.get(["appState", "showPricing"]) || {};
	const identityValidation = validatePricingChecklistForSession(data, pricingSession);
	if (!isPricingSessionActive(currentPricingState, pricingSession) || fileName !== pricingSession?.url || !identityValidation.valid) {
		const error = new Error("The pricing session or target job changed before it could be saved.");
		error.code = "PRICING_SESSION_MISMATCH";
		throw error;
	}
	const projectOpsPricingEnabled = isProjectOpsEnabledForOrg(getOrgId());
	const projectOpsPricingData = projectOpsPricingEnabled ? mergeProjectOpsContributionIntoPricingContractProto(data) : stripProjectOpsInstanceFields(data);
	const preparedData = projectOpsPricingEnabled ? prepareProjectOpsInstanceForSave(projectOpsPricingData) : projectOpsPricingData;
	const preparedIdentityValidation = validatePricingChecklistForSession(preparedData, pricingSession);
	if (!isPricingSessionActive(tree.get(["appState", "showPricing"]) || {}, pricingSession) || !preparedIdentityValidation.valid) {
		const error = new Error("The pricing session or target job changed before it could be saved.");
		error.code = "PRICING_SESSION_MISMATCH";
		throw error;
	}
	// ICH only: a locked Agreement of Sale or addendum stamps the matching milestones
	// (Contract Date, Addendum N) on the instance before it is saved and indexed.
	const ichStamp = isIchContractAnchorPricingSave(fileName, preparedData)
		? stampIchInstanceForSave(preparedData)
		: { instance: preparedData, reachedMilestoneKeys: [] };

	const result = await awsS3.saveInstance(env.s3.contentBucket, fileName, ichStamp.instance);
	if (projectOpsPricingEnabled) {
		await syncProjectOpsPricingProgress(fileName, ichStamp.instance);
	}
	if (ichStamp.reachedMilestoneKeys.length > 0) {
		await advanceIchProjectForMilestones(ichStamp.instance, ichStamp.reachedMilestoneKeys);
	}
	return result;
}

export async function saveTasks(tree, fileName, data) {
	console.log("SAVE!!!", fileName, data);
	// Tasks are part of pricing-- in the end just saving the session
	return await awsS3.saveInstance(env.s3.contentBucket, fileName, data);
}

export function closeInvoiceModal(tree) {
	const shouldReleaseSpinner = tree.get(["appState", "showPricing", "loading"]) === true
		|| tree.get(["appState", "showPricing", "saving"]) === true;
	tree.set(["appState", "showPricing"], createEmptyPricingModalState());
	if (shouldReleaseSpinner) {
		hideStatusSpinner(tree);
	}
}

export function handleGenerateExternalUrls(tree) {
	let entityRoot = tree.get(["tree", "root"]);

	if (entityRoot.entity.heroImage) {
		if (isDriveReference(entityRoot.entity.heroImage)) {
			entityRoot.entity.heroImageDrive = _.cloneDeep(entityRoot.entity.heroImage);
		}
		entityRoot.entity.heroImage = getUrlForValue(entityRoot.entity.heroImage, entityRoot.id);
	}
	if (entityRoot.entity.logoImage) {
		if (isDriveReference(entityRoot.entity.logoImage)) {
			entityRoot.entity.logoImageDrive = _.cloneDeep(entityRoot.entity.logoImage);
		}
		entityRoot.entity.logoImage = getUrlForValue(entityRoot.entity.logoImage, entityRoot.id);
	}
	if (entityRoot.entity.logoImageSmall) {
		if (isDriveReference(entityRoot.entity.logoImageSmall)) {
			entityRoot.entity.logoImageSmallDrive = _.cloneDeep(entityRoot.entity.logoImageSmall);
		}
		entityRoot.entity.logoImageSmall = getUrlForValue(entityRoot.entity.logoImageSmall, entityRoot.id);
	}
	if (entityRoot.entity.backgroundAudio) {
		if (isDriveReference(entityRoot.entity.backgroundAudio)) {
			entityRoot.entity.backgroundAudioDrive = _.cloneDeep(entityRoot.entity.backgroundAudio);
		}
		entityRoot.entity.backgroundAudio = getUrlForValue(entityRoot.entity.backgroundAudio, entityRoot.id);
	}
	if (entityRoot.entity.backgroundImage) {
		if (isDriveReference(entityRoot.entity.backgroundImage)) {
			entityRoot.entity.backgroundImageDrive = _.cloneDeep(entityRoot.entity.backgroundImage);
		}
		entityRoot.entity.backgroundImage = getUrlForValue(entityRoot.entity.backgroundImage, entityRoot.id);
	}
	if (entityRoot.entity.labelAudioFile) {
		if (isDriveReference(entityRoot.entity.labelAudioFile)) {
			entityRoot.entity.labelAudioFileDrive = _.cloneDeep(entityRoot.entity.labelAudioFile);
		}
		entityRoot.entity.labelAudioFile = getUrlForValue(entityRoot.entity.labelAudioFile, entityRoot.id);
	}

	utils.recurseDriveRefsToUrlsForEntities(entityRoot.children, entityRoot.id);
}

export function handleRestoreDriveRefs(tree) {
	let entityRoot = tree.get(["tree", "root"]);

	if (entityRoot.entity.heroImageDrive) {
		entityRoot.entity.heroImage = _.cloneDeep(entityRoot.entity.heroImageDrive);
		delete entityRoot.entity.heroImageDrive;
	}

	if (entityRoot.entity.logoImageDrive) {
		entityRoot.entity.logoImage = _.cloneDeep(entityRoot.entity.logoImageDrive);
		delete entityRoot.entity.logoImageDrive;
	}

	if (entityRoot.entity.logoImageSmallDrive) {
		entityRoot.entity.logoImageSmall = _.cloneDeep(entityRoot.entity.logoImageSmallDrive);
		delete entityRoot.entity.logoImageSmallDrive;
	}

	if (entityRoot.entity.backgroundAudioDrive) {
		entityRoot.entity.backgroundAudio = _.cloneDeep(entityRoot.entity.backgroundAudioDrive);
		delete entityRoot.entity.backgroundAudioDrive;
	}

	if (entityRoot.entity.backgroundImageDrive) {
		entityRoot.entity.backgroundImage = _.cloneDeep(entityRoot.entity.backgroundImageDrive);
		delete entityRoot.entity.backgroundImageDrive;
	}

	utils.recurseRestoreDriveRefs(entityRoot.children);
}

export function handleClearTtsAudio(tree) {
	let entityRoot = tree.get(["tree", "root"]);

	entityRoot.entity.labelAudioFile = "";

	utils.recurseClearTtsAudio(entityRoot.children);
}

export async function generateTtsAudio(tree, params = {}) {

	let content = [];

	let entityRoot = tree.get(["tree", "root"]);
	let entity = entityRoot.entity;

	params.pathPrefix = getGenerateTtsAudioPathPrefix(getOrgId(), entity.driveRootPath);

	createContentArrayForTtsAudio(entityRoot, content, params);

	try {
		showEditorSpinner();

		if (content.length > 0) {
			let response = await sendTtsAudioRequest(content, params);
			await listDrive();
			applyGeneratedTtsAudioResponseToActivity(tree, response, content);

			//console.log("Entity after tts audio generation", entityRoot);
			saveUndoState();
		} else {
			console.log("No tts audio to generate");
		}

		//console.log("TTS Request", ttsRequest);
		handleHideGenerateTtsAudioModal(tree);
		hideEditorSpinner();
	} catch (err) {
		console.log(err);
		showError("Error", "TTS audio generation failed.");
		handleHideGenerateTtsAudioModal(tree);
		hideEditorSpinner();
	}
}

function getGenerateTtsAudioPathPrefix(orgId, driveRootPath) {
	return "private/" + orgId + "/activities/" + driveRootPath + "/polly-generated-audio";
}

async function sendTtsAudioRequest(content, params) {

	let orgId = getOrgId();

	let chunks = _.chunk(content, env.apiGateway.endpoints.audio.generateTts.batchSize);

	let responseContent = [];
	try {

		for (let i = 0; i < chunks.length; i++) {

			let ttsRequest = {
				pathPrefix: params.pathPrefix,
				orgId: orgId,
				items: chunks[i],
				sampleRate: params.sampleRate,
				voiceId: params.voice.Id,
				lang: params.voice.LanguageCode,
				engine: params.engine
			};

			//console.log("TTS request", ttsRequest);

			let promise = new Promise((resolve, reject) => {
				refreshCredentials().then(() => {
					request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.audio.generateTts.generate}`)
						.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
						.send(ttsRequest)
						.then(res => {
							_.each(res.body.items, (item) => {
								responseContent.push(item);
							});
							resolve();
						}).catch(err => {
							console.error(err);
							reject(err);
						});
				}).catch(err => {
					reject(err);
				});
			});
			await promise;
		}
	} catch (err) {
		console.log(err);
		throw new Error("TTS audio generation failed");
	}

	return responseContent;
}

function isTtsAudioGeneratedOrEmpty(entity, prop, pathPrefix, guid = entity?.guid) {
	let fileRef = entity?.[prop];
	const type = getEntityTypeForTtsAudioGeneration(entity);

	// No file? Treat as empty.
	if (!fileRef) { return true; }

	// Not a managed resource ref? Not generated/empty.
	if (!_.isObject(fileRef) || fileRef.type !== "resource/ref") { return false; }

	const externalResource = getDriveObjectForReference(fileRef);
	const path = externalResource?.path || "";

	// New rule: if the path contains any GUID and at least one of them
	// is different from this entity's GUID, treat as generated/empty (true).
	// (Standard UUID v4 pattern; extend if your GUIDs differ.)
	const guidRx = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
	const pathGuids = path.match(guidRx) || [];
	const currentGuid = String(guid || "").toLowerCase();

	if (pathGuids.some(id => id.toLowerCase() !== currentGuid)) {
		return true;
	}

	// Original "managed file" check
	const managedPath = `${pathPrefix}/${type}-${guid}-${prop}.mp3`;
	return path === managedPath;
}



export async function generateTtsAudioForProperty(tree, params = {}) {

	let entityRoot = tree.get(["tree", "root"]);
	let entity = entityRoot.entity;

	params.pathPrefix = getGenerateTtsAudioPathPrefix(getOrgId(), entity.driveRootPath);

	try {
		showEditorSpinner();

		let response = await sendTtsAudioRequestForProperty(params);

		await listDriveMap();

		let item = response[0];
		let resourceRef = getResourceRefForGeneratedTtsAudioResponseItem(item);

		tree.set([...getSelectedNodePath(), "entity", params.propName], resourceRef);

		saveUndoState();


		handleHideGenerateTtsAudioForPropertyModal(tree);
		hideEditorSpinner();
	} catch (err) {
		console.log(err);
		showError("Error", "TTS audio generation failed.");
		hideEditorSpinner();
	}
}

async function sendTtsAudioRequestForProperty(params) {

	let currentNode = state.get(getSelectedNodePath());
	let entity = (currentNode.entity) ? currentNode.entity : currentNode;

	let type = getEntityTypeForTtsAudioGeneration(entity);
	let guid = (type === "activity") ? currentNode.id : entity.guid;

	let ttsRequest = {
		pathPrefix: params.pathPrefix,
		orgId: getOrgId(),
		items: [
			{
				entityGuid: guid,
				type,
				text: params.text,
				propName: params.propName
			}
		],
		sampleRate: params.sampleRate,
		voiceId: params.voice.Id,
		lang: params.voice.LanguageCode,
		engine: params.engine
	};

	let responseContent = [];

	try {
		let promise = new Promise((resolve, reject) => {
			refreshCredentials().then(() => {
				request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.audio.generateTts.generate}`)
					.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
					.send(ttsRequest)
					.then(res => {
						_.each(res.body.items, (item) => {
							responseContent.push(item);
						});
						resolve();
					}).catch(err => {
						console.error(err);
						reject(err);
					});
			}).catch(err => {
				reject(err);
			});
		});
		await promise;
	} catch (e) {
		console.error(e);
		throw new Error("TTS audio generation failed");
	}

	return responseContent;
}





function createContentArrayForTtsAudio(entityRoot, content, params) {
	let entity = entityRoot.entity;

	if (isTtsAudioGeneratedOrEmpty(entity, "labelAudioFile", params.pathPrefix, entityRoot.id)) {

		let labelText = getEntityTextForAudioProperty(entity, "labelAudioFile");

		if (labelText) {
			content.push({
				text: labelText,
				type: getEntityTypeForTtsAudioGeneration(entity),
				propName: "labelAudioFile",
				entityGuid: entityRoot.id
			});
		}
	}

	recurseCreateContentArrayForTtsAudio(entityRoot.children, content, params, 0, 0);
}

function recurseCreateContentArrayForTtsAudio(arr, content, params, lastListIndex, lastSectionIndex) {
	for (let i = 0; i < arr.length; i++) {

		let entity = arr[i].entity;

		if (entity.type.startsWith("list")) {
			lastListIndex = i;

			if (isTtsAudioGeneratedOrEmpty(entity, "labelAudioFile", params.pathPrefix, entity.guid)) {

				let listText = getEntityTextForAudioProperty(entity, "labelAudioFile");

				if (listText) {
					content.push({
						text: listText,
						type: getEntityTypeForTtsAudioGeneration(entity),
						listIndex: i,
						propName: "labelAudioFile",
						entityGuid: entity.guid
					});
				}
			}
		} else if (entity.type.startsWith("section")) {
			lastSectionIndex = i;

			if (isTtsAudioGeneratedOrEmpty(entity, "labelAudioFile", params.pathPrefix, entity.guid)) {

				let sectionText = getEntityTextForAudioProperty(entity, "labelAudioFile");

				if (sectionText) {
					content.push({
						text: sectionText,
						type: getEntityTypeForTtsAudioGeneration(entity),
						listIndex: lastListIndex,
						sectionIndex: i,
						propName: "labelAudioFile",
						entityGuid: entity.guid
					});
				}
			}
		} else if (entity.type.startsWith("item")) {

			if (isTtsAudioGeneratedOrEmpty(entity, "label1AudioFile", params.pathPrefix, entity.guid)) {

				let itemLabelText = getEntityTextForAudioProperty(entity, "label1AudioFile");

				if (itemLabelText) {
					content.push({
						text: itemLabelText,
						type: getEntityTypeForTtsAudioGeneration(entity),
						listIndex: lastListIndex,
						sectionIndex: lastSectionIndex,
						itemIndex: i,
						propName: "label1AudioFile",
						entityGuid: entity.guid
					});
				}
			}

			if (isTtsAudioGeneratedOrEmpty(entity, "label2AudioFile", params.pathPrefix, entity.guid)) {

				let itemLabel2Text = getEntityTextForAudioProperty(entity, "label2AudioFile");

				if (itemLabel2Text) {
					content.push({
						text: itemLabel2Text,
						type: getEntityTypeForTtsAudioGeneration(entity),
						listIndex: lastListIndex,
						sectionIndex: lastSectionIndex,
						itemIndex: i,
						propName: "label2AudioFile",
						entityGuid: entity.guid
					});
				}
			}

			if (isTtsAudioGeneratedOrEmpty(entity, "commentsAudioFile", params.pathPrefix, entity.guid)) {

				let itemCommentsText = getEntityTextForAudioProperty(entity, "commentsAudioFile");

				if (itemCommentsText) {
					content.push({
						text: itemCommentsText,
						type: getEntityTypeForTtsAudioGeneration(entity),
						listIndex: lastListIndex,
						sectionIndex: lastSectionIndex,
						itemIndex: i,
						propName: "commentsAudioFile",
						entityGuid: entity.guid
					});
				}
			}
		}
		if (arr[i].hasOwnProperty("children")) {
			recurseCreateContentArrayForTtsAudio(arr[i].children, content, params, lastListIndex, lastSectionIndex);
		}
	}
}

export function getEntityTextForAudioProperty(entity, propName) {

	let text = "";

	if (entity.type === "checklist") {

		if (propName === "labelAudioFile") {
			if (entity.labelSsml) {
				text = replaceTtsPhonetics(entity.labelSsml);
			} else if (entity.labelAudio) {
				text = fixUtterance(entity.labelAudio);
			} else if (entity.label) {
				text = fixUtterance(entity.label);
			}
		}

	} else if (entity.type === "list") {

		if (propName === "labelAudioFile") {
			if (entity.labelSsml) {
				text = replaceTtsPhonetics(entity.labelSsml);
			} else if (entity.labelAudio) {
				text = fixUtterance(entity.labelAudio);
			} else if (entity.label) {
				text = fixUtterance(entity.label);
			}
		}

	} else if (entity.type === "section") {

		if (propName === "labelAudioFile") {
			if (entity.labelSsml) {
				text = replaceTtsPhonetics(entity.labelSsml);
			} if (entity.labelAudio) {
				text = fixUtterance(entity.labelAudio);
			} else if (entity.label) {
				text = fixUtterance(entity.label);
			}
		}

	} else if (entity.type.startsWith("item")) {

		if (propName === "label1AudioFile") {
			if (entity.label1Ssml) {
				text = replaceTtsPhonetics(entity.label1Ssml);
			} else if (entity.label1Audio) {
				text = fixUtterance(entity.label1Audio);
			} else if (entity.label) {
				text = fixUtterance(entity.label);
			}
		}

		if (propName === "label2AudioFile") {
			if (entity.label2Ssml) {
				text = replaceTtsPhonetics(entity.label2Ssml);
			} else if (entity.label2Audio) {
				text = fixUtterance(entity.label2Audio);
			} else if (entity.label2) {
				text = fixUtterance(entity.label2);
			}
		}

		if (propName === "commentsAudioFile") {
			if (entity.commentsSsml) {
				text = replaceTtsPhonetics(entity.commentsSsml);
			} else if (entity.commentsAudio) {
				text = fixUtterance(entity.commentsAudio);
			} else if (entity.comments) {
				text = fixUtterance(entity.comments);
			}
		}
	}

	return text;
}

function applyGeneratedTtsAudioResponseToActivity(tree, ttsResponse, contentMetadata) {

	let activityRoot = tree.get(["tree", "root"]);

	_.each(ttsResponse, (item, i) => {

		let itemMetadata = contentMetadata[i];

		let resourceRef = getResourceRefForGeneratedTtsAudioResponseItem(item);

		switch (itemMetadata.type) {
			case "activity":
				tree.set(["tree", "root", "entity", itemMetadata.propName], resourceRef);
				break;
			case "list":
				tree.set(["tree", "root", "children", itemMetadata.listIndex, "entity", itemMetadata.propName], resourceRef);
				break;
			case "section":
				if (utils.isEditorChecklistSections(activityRoot)) {
					tree.set(["tree", "root", "children", itemMetadata.sectionIndex, "entity", itemMetadata.propName], resourceRef);
				} else {
					tree.set(["tree", "root", "children", itemMetadata.listIndex, "children", itemMetadata.sectionIndex, "entity", itemMetadata.propName], resourceRef);
				}
				break;
			default:
				if (itemMetadata.type.startsWith("item")) {
					if (utils.isEditorChecklistItems(activityRoot)) {
						tree.set(["tree", "root", "children", itemMetadata.itemIndex, "entity", itemMetadata.propName], resourceRef);
					} else if (utils.isEditorChecklistSections(activityRoot)) {
						tree.set(["tree", "root", "children", itemMetadata.sectionIndex, "children", itemMetadata.itemIndex, "entity", itemMetadata.propName], resourceRef);
					} else {
						tree.set(["tree", "root", "children", itemMetadata.listIndex, "children", itemMetadata.sectionIndex, "children", itemMetadata.itemIndex, "entity", itemMetadata.propName], resourceRef);
					}
				}
				break;
		}
	});
}

function getResourceRefForGeneratedTtsAudioResponseItem(item) {
	item.driveMetadata.isVideo = (item.propName) === "video";

	const refId = addExternalResource(getDriveObject(item.driveMetadata.guid));

	// const refId = addExternalResource(getDriveObjectByPath(item.driveMetadata.path));
	const resourceRef = getResourceReference(refId);
	return resourceRef;
}

export function handleShowGenerateTtsAudioForPropertyModal(tree, propName) {
	initGenerateTtsAudioConfig(tree);

	tree.set(["audio", "modals", "generateTtsForProperty", "show"], true);
	tree.set(["audio", "modals", "generateTtsForProperty", "propName"], propName);
	tree.set(["audio", "modals", "generateTtsForProperty", "previewUrl"], "");

	let currentNode = tree.get(getSelectedNodePath());

	let previewText = getEntityTextForAudioProperty(currentNode.entity ? currentNode.entity : currentNode, propName);

	tree.set(["audio", "modals", "generateTtsForProperty", "previewText"], previewText);
}

export function handleHideGenerateTtsAudioForPropertyModal(tree) {
	tree.set(["audio", "modals", "generateTtsForProperty", "show"], false);
	tree.set(["audio", "modals", "generateTtsForProperty", "propName"], "");
	tree.set(["audio", "modals", "generateTtsForProperty", "previewUrl"], "");
}

export async function generateTtsAudioForPropertyPreview(tree, params = {}) {

	try {
		showEditorSpinner();

		let ttsRequest = {
			text: tree.get(["audio", "modals", "generateTtsForProperty", "previewText"]),
			sampleRate: params.sampleRate,
			voiceId: params.voice.Id,
			lang: params.voice.LanguageCode,
			engine: params.engine
		};

		let promise = new Promise((resolve, reject) => {
			refreshCredentials().then(() => {
				request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.audio.generateTts.preview}`)
					.set({ Authorization: getJwtToken(), "Content-Type": "application/json" })
					.send(ttsRequest)
					.then(res => {
						tree.set(["audio", "modals", "generateTtsForProperty", "previewUrl"], res.body.url);
						resolve();
					}).catch(err => {
						console.error(err);
						reject(err);
					});
			}).catch(err => {
				reject(err);
			});
		});
		await promise;


		hideEditorSpinner();
	} catch (err) {
		console.log(err);
		showError("Error", "TTS audio generation preview failed.");
		hideEditorSpinner();
	}
}

function getEntityTypeForTtsAudioGeneration(entity) {
	return (entity.type === "checklist") ? "activity" : (entity.type.startsWith("item") ? "item" : entity.type);
}

export function handleGenerateTtsAudioConfigOnChange(tree, property, value) {

	switch (property) {
		case "sampleRate":
			utils.setLs(AppConstants.audio.tts.generationParams.SAMPLE_RATE, value);
			tree.set(["audio", "generateTtsConfig", property], value);
			break;
		case "voiceId":
			utils.setLs(AppConstants.audio.tts.generationParams.VOICE_ID, value);
			tree.set(["audio", "generateTtsConfig", property], value);
			break;
		case "engine":
			utils.setLs(AppConstants.audio.tts.generationParams.ENGINE, value);
			tree.set(["audio", "generateTtsConfig", property], value);
			break;
		default:
			break;
	}
}

export function initGenerateTtsAudioConfig(tree) {

	let sampleRate = utils.getLs(AppConstants.audio.tts.generationParams.SAMPLE_RATE);

	if (sampleRate === null) {
		sampleRate = 24000;
	}

	let voiceId = utils.getLs(AppConstants.audio.tts.generationParams.VOICE_ID);

	if (voiceId === null) {
		voiceId = utils.getSortedPollyVoices()[0].Id;
	}

	let engine = utils.getLs(AppConstants.audio.tts.generationParams.ENGINE);

	if (engine === null) {
		engine = "standard";
	}

	tree.set(["audio", "generateTtsConfig", "sampleRate"], sampleRate);
	tree.set(["audio", "generateTtsConfig", "voiceId"], voiceId);
	tree.set(["audio", "generateTtsConfig", "engine"], engine);
}

export function resetGenerateTtsAudioConfig(tree) {

	let sampleRate = 24000;
	let voiceId = utils.getSortedPollyVoices()[0].Id;
	let engine = "standard";

	utils.setLs(AppConstants.audio.tts.generationParams.SAMPLE_RATE, sampleRate);
	utils.setLs(AppConstants.audio.tts.generationParams.VOICE_ID, voiceId);
	utils.setLs(AppConstants.audio.tts.generationParams.ENGINE, engine);

	tree.set(["audio", "generateTtsConfig", "sampleRate"], sampleRate);
	tree.set(["audio", "generateTtsConfig", "voiceId"], voiceId);
	tree.set(["audio", "generateTtsConfig", "engine"], engine);
}

export function setSelectedFolderFromDriveRootPath(driveRootPath) {
	// If there is a root drive path, set that as the selected folder
	if (driveRootPath) {
		const selectedFolder = `private/${getOrgId()}/activities/${driveRootPath}/`;
		if (selectedFolder !== state.get(["drive", "selectedFolder"])) {
			state.set(["drive", "selectedFolder"], selectedFolder);
		}
	}
}

export function showMediaPreviewModal(tree, url, propName = "") {
	//show only if url is valid
	if (url && utils.validateUrl(url)) {
		let previewUrl = url;
		const normalizedPropName = `${propName || ""}`.toLowerCase();
		const normalizedUrl = `${url || ""}`.toLowerCase().split("?")[0].split("#")[0];
		const looksLikeVideo = normalizedPropName === "video" || /\.(mp4|m4v|mov|webm|ogv|ogg)$/i.test(normalizedUrl);
		if (looksLikeVideo) {
			const separator = url.indexOf("?") >= 0 ? "&" : "?";
			previewUrl = `${url}${separator}previewTs=${Date.now()}`;
		}
		tree.set(["appState", "mediaPreviewModal", "show"], true);
		tree.set(["appState", "mediaPreviewModal", "url"], previewUrl);
		tree.set(["appState", "mediaPreviewModal", "propName"], propName);
	}
}

export function closeMediaPreviewModal(tree) {
	tree.set(["appState", "mediaPreviewModal", "show"], false);
}

function deepCloneNodeFromClipboard(tree, node) {
	const srcExternalResources = tree.get("clipboardExternalResources");
	const srcRelatedItems = tree.get("clipboardRelatedItems");

	let entityId = utils.generateUUID();
	const guid = utils.generateUUID();
	let newNode = _.cloneDeep(node);
	newNode.entity.entityId = entityId;
	newNode.entity.guid = guid;
	newNode.entity = fixIftttStructureIds(newNode.entity);

	if (newNode.entity.groupNames && newNode.entity.groupNames.indexOf("#internal-templates") > -1) {
		newNode.entity.groupNames.splice(newNode.entity.groupNames.indexOf("#internal-templates"), 1);
	}

	const pastedExternalResources = {};
	const pastedRelatedItems = {};
	recurseEntityProps(newNode.entity, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);

	newNode.selected = false;

	if (newNode.hasOwnProperty("children")) {
		recurseUpdateIds(newNode.children);
		recursePasteEntries(newNode.children, srcExternalResources, pastedExternalResources, srcRelatedItems, pastedRelatedItems);
	}

	finalizePasteEntries(pastedExternalResources, pastedRelatedItems, newNode);

	return newNode;
}

/**
 * List the drive before editing an activity, this will only load the drive if it has not 
 * been initialized yet.
 */
export async function listDriveOnEditActivity() {

	//Load drive if not yet available
	if (!state.get(["drive", "hierarchy"])) {

		// If in editor, show editor spinner, else, show document spinner
		const inActivityEditor = utils.isInActivityEditor();
		const spinnerMessage = state.get(["content", "loadingStatuses", "loadingDrive"]);

		try {
			if (inActivityEditor) {
				setEditorSpinnerMessage(spinnerMessage);
				showEditorSpinner();
			} else {
				setDocumentsSpinnerMessage(spinnerMessage);
				showDocumentsSpinner();
			}

			await listDrive();
		} finally {

			if (inActivityEditor) {
				setEditorSpinnerMessage("");
				hideEditorSpinner();
			} else {
				setDocumentsSpinnerMessage("");
				hideDocumentsSpinner();
			}
		}
	}
}
